<template>

    
    <v-container>
        <v-layout row wrap mb-2>
            <v-flex xs12 sm12>
                <v-card>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md12>
                                <h3 class="commen-heading">
                                <v-avatar size="22" class="ic-white mt-1">
                                    <img :src="surverListIcon" alt="icon">
                                </v-avatar>&nbsp;Form List
                                </h3>
                            </v-flex>
                            <v-flex xs12 sm12 md12 mt-2>
                                <v-tabs slider-color="none">
                                    <v-tab :key="1" class="tab-btn"
                                        active-class='primary-bg white--text tab-btn-active'>
                                        <!--ACTIVE-->
                                        FORMS
                                    </v-tab>
                                    <!-- <v-tab :key="2" class="tab-btn" active-class='primary-bg white--text tab-btn-active'>

                                        SAVED
                                    </v-tab> -->

                                    <!-- <v-tab :key="2" class="tab-btn"
                                        active-class='primary-bg white--text tab-btn-active'>
                                        SUBMITTED
                                    </v-tab> -->
                                    <v-tab-item :key="1" >
                                        <v-layout row wrap style="padding-left: 6px !important">
                                        <!-- <div row style="margin-top:2rem"> -->
                                            <v-flex xs6 sm6 md6 class="DigiFormsTitle">
                                                <h3 class="commen-heading pt-2 mt-3 pl-2">
                                                    Digital Forms
                                                </h3>
                                            </v-flex>
                                            <!--Popup Buttons-->
                                            <v-flex xs12 sm6 md6 class="searchPadTop">

                                                <!--Search btn -->
                                                <v-btn light fab small color="white" 
                                                    class="rounded-rect-btn float-right" style="margin-top: 10px;"  @click="toggleSearchBox">
                                                    <i alt="icon" class="mdi mdi-magnify" style="font-size: 20px; position: relative;top: 5px;"></i>
                                                </v-btn>

                                                <v-text-field :autocomplete="'off'" full-width class="mt-2 mb-0 small-input"
                                                        transition="slide-x-transition" id="ActiveSearch"
                                                        v-model="Search" label="Search" solo 
                                                        @click:prepend="toggleSearchBox" v-show="searchBox">
                                                     
                                                    </v-text-field>
                                            </v-flex>

                                            <v-flex xs12 sm12 md12 mt-2>

                                                <!--hide-actions -->
                                                <v-data-table :items="ActiveSurveyList" class="custom-data-table"
                                                    hide-default-footer :headers="ActiveSurveyListHeader"
                                                    :sort-by="[]" :loading="loading">
                                                    <template v-slot:item="props">
                                                        <tr>
                                                            <td class="py-3">
                                                                <h3>{{ props.item.SurveyName }}</h3>
                                                                <!-- <h6>Version : {{ Version }}</h6> -->
                                                                <!-- <h6>Added on : {{props.item.CreatedDate}}</h6> -->
                                                                <h6> Added on {{ formatDate(props.item.CreatedDate) }}
                                                                </h6>
                                                            </td>
                                                            <td class="py-3">
                                                                <v-btn light fab small color="white"
                                                                    class="rounded-rect-btn float-right"
                                                                    v-on:click="PreLoader = true; GetSurveySections(props.item.SurveyID, 0)">
                                                                    <!-- <v-icon class="text-primary">
                                                                        add
                                                                    </v-icon> -->
                                                                    <i style="font-size: 20px;" class="mdi mdi-plus"></i>
                                                                </v-btn>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-tab-item>

                                    <v-tab-item :key="2">
                                        <v-layout row wrap>
                                            <v-flex xs6 sm6>
                                                <h3 class="commen-heading pt-2">
                                                    Submitted Forms
                                                </h3>
                                            </v-flex>
                                            <!--Popup Buttons-->
                                            <v-flex xs6 sm6>


                                                <!--Search btn -->
                                                <v-btn light fab small color="white"
                                                    class="rounded-rect-btn float-right"
                                                    @click="searchBoxEditTab = true">
                                                    <img :src="searchIcon" class="ic-small" alt="icon">
                                                </v-btn>
                                            </v-flex>
                                            <!--Search box-->
                                            <v-flex xs12 sm12 class="search-popup" id="Submittedsearchsec">
                                                <div class="small-input" style="width:100%">
                                                    <v-text-field :autocomplete="'off'" full-width class="mt-2 mb-0"
                                                        transition="slide-x-transition" id="Submittedsearch"
                                                        v-model="Search" label="Search" solo=""
                                                        v-show="searchBoxEditTab" prepend-icon="arrow_back"
                                                        @click:prepend="searchBoxEditTab = false" append-icon="search">
                                                        <template v-slot:append="">
                                                            <img width="14" height="14" :src="searchIcon"
                                                                alt="">
                                                        </template>
                                                    </v-text-field>
                                                </div>
                                            </v-flex>
                                            <v-flex xs12 sm12 mt-2>
                                                <v-data-table :items="SubmittedSurveyList" class="custom-data-table"
                                                hide-default-footer :headers="SubmittedSurveyListHeader" :sort-by="null"
                                                    :loading="loading">
                                                    <template v-slot:items="props">
                                                        <tr v-if="props.item.Formcount > 0">
                                                            <td class="py-3">
                                                                <h3>{{ props.item.SurveyName }}</h3>
                                                                <!-- <h6>Version : {{ Version }}</h6> -->
                                                                <!-- <h6>Added on : {{props.item.CreatedDate}}</h6> -->
                                                                <!-- <h6> Added on {{ formatDate(props.item.CreatedDate) }} -->
                                                                <!-- </h6> -->

                                                            </td>
                                                            <td class="text-xs-center">
                                                                <h3>{{ props.item.Formcount }}</h3>
                                                            </td>
                                                            <td class="py-3">
                                                                <!--add btn @click.native="GetSurveyQuestion(props.item.SurveyID,1,0)" GetEditedSurveyQuestion(props.item.SurveyID,1,0)@click="router.push(`/Forms/${props.item.SurveyID}`)"-->
                                                                <v-btn light fab small color="white"
                                                                    class="rounded-rect-btn float-right"
                                                                    @click="router.push(`/dataforms/${props.item.SurveyID}/false`)">
                                                                    <v-icon class="text-primary">
                                                                        arrow_forward
                                                                    </v-icon>
                                                                </v-btn>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-tab-item>
                                </v-tabs>
                            </v-flex>
                            <v-dialog persistent scrollable v-for="(items,index) in CurrentSectionQuestions" :key="index"
                                v-model="ActiveAddQuestPopup" style="padding-top: 3rem;">
                                <v-card>
                                    <v-card-title>
                                        <v-layout row wrap>
                                            <v-flex xs12 sm12 class="text-xs-center">
                                                <h1 class="text-center">
                                                    <!-- <img src="@/assets/images/CBZ_Logo.svg" alt="Genz" width="200" height="auto"> -->
                                                </h1>
                                                <h2 class="commen-heading marg-top-4">{{ SurveyName }} </h2>
                                            </v-flex>
                                            <!-- <v-flex xs2 sm2>
                                                <v-avatar size="39" color="grey lighten-3" class="mr-2 pa-2" v-on:click="NextSectionQuestions(items.SurveyID,SelectedSection-1);$('#qstDiv').scrollTop(0);" v-if="SelectedSection>1">
                                                    <img src="@/assets/images/Left_chev_act.svg" alt="icon">
                                                </v-avatar>
                                            </v-flex> -->
                                            <v-flex style="text-align: center;">
                                                <h3 class="grey--text text--darken-2"> {{ SelectedSection }} of
                                                    {{ TotSections }} Questions</h3>
                                            </v-flex>
                                            <!-- <v-flex xs2 sm2 class="text-xs-right">
                                                <v-avatar size="39" color="grey lighten-3" class="mr-2 pa-2" v-if="SelectedSection < TotSections">
                                                    <img src="@/assets/images/Right_chev_act.svg" alt="icon" v-on:click="NextSectionQuestions(items.SurveyID,SelectedSection+1);$('#qstDiv').scrollTop(0);">
                                                </v-avatar>
                                            </v-flex> -->
                                        </v-layout>
                                    </v-card-title>
                                    <v-card-text style="height:75vh;z-index:999;" id="qstDiv">
                                        <v-container grid-list-md id="container">
                                            <v-layout row wrap style="border-bottom:1px solid #eaeaea;">
                                                <v-flex xs12 sm12 md12>
                                                    <table>
                                                        <tr>
                                                            <td class="pb-2">
                                                                <h4 class="form-label-2 grey--text text--darken-1 pr-2">
                                                                   <b> Liveliness Check </b></h4>
                                                            </td>
                                                            <td class="pb-2">
                                                                <v-avatar
                                                                    :color="liveness == 'True' ? 'green accent-2' : 'red lighten-2'"
                                                                    size="20">
                                                                    <i light="" size="15" class="mdi mdi-check"
                                                                        v-if="liveness == 'True'"></i>
                                                                    <i light="" size="15" class="mdi mdi-close"
                                                                        v-if="liveness == 'False'"></i>

                                                                </v-avatar>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pb-2">
                                                                <h4 class="form-label-2 grey--text text--darken-1 pr-2">
                                                                <b> Facial Match </b></h4>
                                                            </td>
                                                            <td class="pb-2">
                                                                <v-avatar
                                                                    :color="facematch == 'True' ? 'green accent-2' : 'red lighten-2'"
                                                                    size="20">
                                                                    <i light="" size="15" class="mdi mdi-check"
                                                                        v-if="facematch == 'True'"></i>
                                                                    <i light="" size="15" class="mdi mdi-close"
                                                                        v-if="facematch == 'False'"></i>
                                                                </v-avatar>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td class="pb-2">
                                                                <h4 class="form-label-2 grey--text text--darken-1 pr-2">
                                                                <b>Facial Match Percentage:</b>
                                                                </h4>
                                                            </td>
                                                            <td class="pb-2">

                                                                <b>{{ facematchPercentage }} %</b>
                                                            </td>
                                                        </tr>

                                                    </table>
                                                    <div>
                                                        <b>
                                                            <h4 class="error-text" style="color: red">Kindly review all
                                                                the extracted details before
                                                                proceeding further. </h4>
                                                        </b>
                                                        <b>
                                                            <h4 class="error-text" style="color: red">NOTE: If Customer
                                                                is less than 18 years, they
                                                                are not eligible to open an account. Kindly visit the
                                                                nearest branch with a legal
                                                                guardian. </h4>
                                                        </b>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 class="my-4">
                                                    <h4
                                                        class="form-label-2 idfc-yellow-strip grey--text text--darken-1">
                                                        {{ items.SectionName }}</h4>
                                                </v-flex>
                                            </v-layout>
                                            <div v-for="(question, i) in items.Questions" :key="i">
                                                <v-layout row wrap class="mt-2"
                                                    v-if="question.QuestionText == 'Salary'"></v-layout>
                                                    <v-layout v-bind:id="(question && question.QuestionText) ? question.QuestionText + '_layout' : ''"
                                                    row wrap
                                                    class="mt-2"
                                                    v-bind:style="[((question && (question.QuestionText == 'ISDCodes' || question.QuestionText == 'CurrencyType') && question.QuestionType == 'Dropdown')) ? { 'float': 'left' } : {}]">
                                            

                                                    <v-flex xs12 sm12>
                                                        <v-layout row wrap>
                                                            <!--Notes-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'Notes'">
                                                                <!--<div class="small-input">-->
                                                                <label>{{ question.QuestionName }}</label>
                                                                <!--</div>-->
                                                                <!--<v-divider v-if="question.RepeatOrder>0"></v-divider>-->
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12 v-if="question.QuestionType == 'Text'"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div v-if="question.TextLength > 0"
                                                                    class="small-input counter">
                                                                    <v-col cols="12" sm="12" md="12">
                                                                        <v-text-field :autocomplete="'off'"
                                                                            v-model="question.Answers"
                                                                            onpaste="return false;" solo
                                                                            :rules="[value => value.length <= question.TextLength]"
                                                                            v-on:focusin="removeIDformat($event, question)"
                                                                            v-on:focusout="addIDformat($event, question)"
                                                                            counter :value="question.DefaultValue"
                                                                            :disabled="question.Disabled"
                                                                            v-bind:maxlength="question.TextLength"
                                                                            v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, i)"
                                                                            :pattern=question.pattern
                                                                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(new RegExp(this.pattern,'gi'), '');">
                                                                        </v-text-field>
                                                                    </v-col>


                                                                </div>
                                                                <div v-else class="small-input">
                                                                    <v-text-field class="mt-2"
                                                                        :id='question.QuestionName'
                                                                        v-bind:maxlength="question.TextLength"
                                                                        :disabled="question.Disabled"
                                                                        v-on:focusin="removeIDformat($event, question)"
                                                                        v-on:focusout="addIDformat($event, question)"
                                                                        oninput="javascript:  this.value = this.value.replace(new RegExp(this.pattern,'gi'), '');"
                                                                        :pattern=question.pattern
                                                                        onpaste="return false;" solo full-width
                                                                        v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"></v-text-field>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>




                                                            <!--ResidencePeriod-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'ResidencePeriod'">
                                                                <label>{{ question.QuestionName }}
                                                                    (Year-Month)</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-col cols="12" sm="6">
                                                                        <v-text-field :autocomplete="'off'"
                                                                            type='number'
                                                                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);if (parseInt(this.value) < parseInt(this.min)) this.value = '';"
                                                                            style="width: 30%; float:left; padding-right: 10%;"
                                                                            v-model="years_period" name="year"
                                                                            placeholder="YY" pattern="\d*" maxlength="2"
                                                                            size="2" min="0" onpaste="return false;"
                                                                            solo></v-text-field>
                                                                        <span>-</span>
                                                                        <v-text-field :autocomplete="'off'"
                                                                            type='number'
                                                                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);if (parseInt(this.value) < parseInt(this.min)) this.value = '';if (parseInt(this.value) > parseInt(this.max)) this.value = this.max;"
                                                                            min="0" max="11"
                                                                            style="width: 30%;margin-top: -20px;padding-left: 10%;"
                                                                            v-model="months_period" name="month"
                                                                            placeholder="MM" pattern="\d*" maxlength="2"
                                                                            size="2" onpaste="return false;"
                                                                            solo></v-text-field>
                                                                    </v-col>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>

                                                            </v-flex>
                                                            <!--Number field-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'Number'"
                                                                v-show="!question.hide">
                                                                <!-- <div class="margin-bt-8"> -->
                                                                <label
                                                                    v-if="(question.QuestionText != 'ISDCode' && question.QuestionText != 'Salary')">{{ question.QuestionName }}</label><sub
                                                                    v-if="question.QuestionText != 'ISDCode' && question.QuestionText != 'Salary' && question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input" style="margin-bottom: 1rem;">
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-if="question.QuestionText != 'ISDCode'"
                                                                        v-bind:maxlength="question.TextLength"
                                                                        v-bind:style="[question.QuestionText == 'Salary' ? { 'top': '7px' } : {}]"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        @focus="Calculation(question.QuestionID, question.IsFormulaQuestion, question.RepeatOrder, question.SubRepeatOrder)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, '', question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"
                                                                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');"></v-text-field>
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-if="question.QuestionText == 'ISDCode'"
                                                                        v-bind:maxLength="[question.QuestionText == 'ISDCode' ? '15' : '']"
                                                                        v-bind:style="[question.QuestionText == 'ISDCode' ? { 'top': '15px' } : {}]"
                                                                        oninput="javascript: this.value = this.value.replace(/[^0-9]/gi, '');if(!this.value.match('^[1-9][0-9]*$')){this.value='';}"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        @focus="Calculation(question.QuestionID, question.IsFormulaQuestion, question.RepeatOrder, question.SubRepeatOrder)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, '', question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></v-text-field>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                                <!-- </div> -->
                                                            </v-flex>

                                                            <v-flex xs12 sm12 style="background-color: lightgrey;"
                                                                v-if="question.QuestionType == 'Label'">
                                                                <label
                                                                    style="font-size: 15px;font-weight: bold;">{{ question.QuestionName }}</label>
                                                            </v-flex>

                                                            <!--Date field-->
                                                            <v-flex xs12 sm12 md12 v-if="question.QuestionType == 'Date'"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-text-field type="date" onkeydown="return false;"
                                                                        onpaste="return false;"
                                                                        v-bind:id="'dt_' + question.QuestionID" solo
                                                                        full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        v-bind:max="issuanceDateRestrictionMax(question.QuestionName)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></v-text-field>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <!-- Issuance date -->
                                                            <v-flex xs12 sm12 md12
                                                                style="padding: 1px !important; margin-top: -10px !important;"
                                                                v-if="question.QuestionType == 'IssuanceDate'"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        type="date" :disabled="question.Disabled"
                                                                        onkeydown="return false" onpaste="return false;"
                                                                        v-bind:id="'issuedt_' + question.QuestionID"
                                                                        v-bind:max="issuanceDateRestrictionMax(question.QuestionName)"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)">
                                                                    </v-text-field>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!-- Expiry date -->
                                                            <v-flex xs12 sm12 md12
                                                                style="padding: 1px !important; margin-top: -10px !important;"
                                                                v-if="question.QuestionType == 'ExpiryDate'"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        type="date"
                                                                        v-bind:id="'date_picker_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                        onkeydown="return false" onpaste="return false;"
                                                                        solo full-width v-model="question.Answers"
                                                                        :value="question.DefaultValue"
                                                                        @click="expiryDateRestrictionMax(question.QuestionID, question.RepeatOrder, question.QuestionName)"
                                                                        v-on:change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled">
                                                                    </v-text-field>
                                                                </div>
                                                                <!-- <div v-if="expiryErrMsg" style="color:red;display:none" > Expiry date is required</div> -->
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>

                                                            </v-flex>
                                                            <!--Multiline field-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'MultiLine' || question.QuestionType == 'MultiLineText'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div v-if="question.TextLength > 0">
                                                                    <v-col cols="12" sm="12">
                                                                        <v-textarea v-model="question.Answers"
                                                                            @keypress="checkSpcialChar" @paste.prevent
                                                                            solo
                                                                            :rules="[value => value.length <= question.TextLength]"
                                                                            :counter="question.DefaultValue"
                                                                            :maxlength="question.TextLength"
                                                                            @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"></v-textarea>
                                                                    </v-col>
                                                                </div>
                                                                <!-- <v-text-field rows="10" cols="50" multi-line class="mt-2" solo full-width v-model="question.Answers"></v-text-field>-->
                                                                <v-col cols="12" md="12" v-else>
                                                                    <v-textarea @keypress.prevent="checkSpcialChar"
                                                                        @paste.prevent v-model="question.Answers"
                                                                        @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        solo></v-textarea>
                                                                </v-col>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!--CheckBox-->
                                                            <!-- <v-flex xs12 sm12 v-if="question.QuestionType=='CheckBox'">
                                                            <label>{{question.QuestionName}}</label><sub v-if="question.IsMandatory==true" style="color:red;font-size:large">*</sub>
                                                            <ul class="list-style-none">
                                                                <li v-for="option in question.Options">
                                                                    <v-CheckBox :label="option.OptionText" :id="option.OptionID"
                                                                                class="my-0" v-model="question.Answers" v-bind:value="option.OptionValue" @change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,question.IsRepeatSection,question.RepeatOrder)">
                                                                    </v-CheckBox>
                                                                </li>
                                                            </ul>
                                                            <div v-bind:id="'lbl_'+question.QuestionID+'_'+question.RepeatOrder" style="color:red;display:none">{{question.ErrorText}}</div>
                                                        </v-flex> -->

                                                        <v-flex xs12 sm12 v-if="question.QuestionType == 'CheckBox'">
                                                            <label>{{ question.QuestionName }}</label>
                                                            <sub v-if="question.IsMandatory == true" style="color:red;font-size:large">*</sub>
                                                            <ul class="list-style-none">
                                                            <li v-for="(option, i) in question.Options" :key="i">
                                                                <v-checkbox
                                                                :label="option.OptionText"
                                                                :id="option.OptionID"
                                                                class="my-0"
                                                                v-model="question.Answers"
                                                                :value="option.OptionValue"
                                                                @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                ></v-checkbox>
                                                            </li>
                                                            </ul>
                                                            <div :id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder" style="color:red;display:none">
                                                            {{ question.ErrorText }}
                                                            </div>
                                                        </v-flex>
                                                            <!--Dropdown  items.DrpDwnopt-->
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && question.QuestionText != 'ISDCodes' && (question.QuestionText != 'Account Class(Current)' && question.QuestionText != 'Account Class(Savings)' && question.QuestionText != 'Account Class(Call)' && question.QuestionText != 'Source of Funds(Employed)' && question.QuestionText != 'Source of Funds(UnEmployed)' && question.QuestionText != 'Source of Funds(Pensioner)' && question.QuestionText != 'Source of Funds(SelfEmployed)')"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'ISDCodes') && (question.QuestionText != 'Account Class(Current)' && question.QuestionText != 'Account Class(Savings)' && question.QuestionText != 'Account Class(Call)' && question.QuestionText != 'Source of Funds(Employed)' && question.QuestionText != 'Source of Funds(UnEmployed)' && question.QuestionText != 'Source of Funds(Pensioner)' && question.QuestionText != 'Source of Funds(SelfEmployed)')"
                                                                v-show="!question.hide">
                                                                <label>{{ question.QuestionLabel }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <!--   <vue-multiselect v-if="question.DrpDwnopt.length>10" v-model="question.Answers" :options="question.DrpDwnopt" value="OptionValue" placeholder="Select one" label="OptionText" @input="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,question.IsRepeatSection,question.RepeatOrder)"></vue-multiselect>-->
                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Account Class(Current)')"
                                                                v-show="question.QuestionText == 'Account Class(Current)' && dispCurrentAccountClass == true"
                                                                v-hide="question.QuestionText == 'Account Class(Current)' && dispCurrentAccountClass == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Account Class(Savings)')"
                                                                v-show="question.QuestionText == 'Account Class(Savings)' && dispSavingAccountClass == true"
                                                                v-hide="question.QuestionText == 'Account Class(Savings)' && dispSavingAccountClass == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Account Class(Call)')"
                                                                v-show="question.QuestionText == 'Account Class(Call)' && dispCallAccountClass == true"
                                                                v-hide="question.QuestionText == 'Account Class(Call)' && dispCallAccountClass == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(Employed)')"
                                                                v-show="question.QuestionText == 'Source of Funds(Employed)' && isdispEmployedLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(Employed)' && isdispEmployedLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(UnEmployed)')"
                                                                v-show="question.QuestionText == 'Source of Funds(UnEmployed)' && isdispUnEmployedLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(UnEmployed)' && isdispUnEmployedLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>


                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(Pensioner)')"
                                                                v-show="question.QuestionText == 'Source of Funds(Pensioner)' && isdispPensionerLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(Pensioner)' && isdispPensionerLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Dropdown' && (question.QuestionText == 'Source of Funds(SelfEmployed)')"
                                                                v-show="question.QuestionText == 'Source of Funds(SelfEmployed)' && isdispSelfEmployedLookup == true"
                                                                v-hide="question.QuestionText == 'Source of Funds(SelfEmployed)' && isdispSelfEmployedLookup == false">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>

                                                                    <vue-multiselect v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="true" :close-on-select="true"
                                                                        @input="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, question.IsRepeatSection, question.RepeatOrder)"
                                                                        :disabled="question.Disabled"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>


                                                            <!-- masterdb -->
                                                            <!-- <v-flex xs12 sm12 v-if="question.QuestionType == 'masterdb'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <vue-multiselect v-if="question.DrpDwnopt.length > 10"
                                                                        v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        value="OptionValue" placeholder="Select one"
                                                                        label="OptionText"
                                                                        @input="GetHierarchyDrpdwn(question.QuestionID, question.SurveyID)"></vue-multiselect>
                                                                    <vue-multiselect v-else v-model="question.Answers"
                                                                        :options="question.DrpDwnopt"
                                                                        placeholder="Select one" label="OptionText"
                                                                        :searchable="false" :close-on-select="true"
                                                                        @input="GetHierarchyDrpdwn(question.QuestionID, question.SurveyID)"></vue-multiselect>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex> -->


                                                            <!--Radio  -->
                                                            <!-- <v-flex xs12 sm12 style="padding: 1px !important;" v-if="question.QuestionType=='Radio'">
                                                            <p ><label>{{question.QuestionName}}</label></p>
                                                            <div >
                                                                <v-radio-group v-model="question.Answers" v-for="(option,i) in question.Options" style="float: left;clear: none;" row :disabled="question.Disabled">
                                                                    <v-radio :key="i"
                                                                             :label="option.OptionText" :id="option.OptionID" style="margin-right: 100px"
                                                                             :value="option.OptionValue" v-on:change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,option.OptionText,question.IsRepeatSection,question.RepeatOrder)">
                                                                    </v-radio>
                                                                </v-radio-group>
                                                            </div><br/><br/><br/><br/>
                                                            <div v-bind:id="'lbl_'+question.QuestionID+'_'+question.RepeatOrder" style="color:red;display:none;" >{{question.ErrorText}}</div>
                                                        </v-flex> -->
                                                            <v-flex xs12 sm12 style="padding: 1px !important;"
                                                                v-if="question.QuestionType == 'Radio'">
                                                                <div>
                                                                    <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                </div>
                                                                <div v-for="(option, i) in question.Options" :key="i"
                                                                    style="float: left; clear: none;">
                                                                    <v-radio-group v-model="question.Answers" row
                                                                        :disabled="question.Disabled">
                                                                        <v-radio :label="option.OptionText"
                                                                            :id="option.OptionID"
                                                                            style="margin-right: 100px"
                                                                            :value="option.OptionValue"
                                                                            @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, option.OptionText, question.IsRepeatSection, question.RepeatOrder)">
                                                                        </v-radio>
                                                                    </v-radio-group>
                                                                </div>
                                                                <br /><br /><br /><br />
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none;">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!-- <v-flex xs12 sm12 v-if="question.QuestionType=='Radio'">
                                                            <label>{{question.QuestionName}}</label><sub v-if="question.IsMandatory==true" style="color:red;font-size:large">*</sub>
                                                            <div>
                                                                <v-radio-group v-model="question.Answers" v-for="(option,i) in question.Options" row>
                                                                    <v-radio :key="i"
                                                                             :label="option.OptionText" :id="option.OptionID"
                                                                             :value="option.OptionValue" v-on:change="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,option.OptionText,question.IsRepeatSection,question.RepeatOrder)">
                                                                    </v-radio>
                                                                </v-radio-group>
                                                            </div>
                                                            <div v-bind:id="'lbl_'+question.QuestionID+'_'+question.RepeatOrder" style="color:red;display:none">{{question.ErrorText}}</div>
                                                        </v-flex> -->
                                                            <!--Yes/No  -->
                                                            <v-flex xs12 sm12 v-if="question.QuestionType == 'Yes/No'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="radio-without-vuetify pt-2">
                                                                    <div v-for="(option, i) in question.Options"
                                                                        :key="i">
                                                                        <v-radio-group v-model="question.Answers" row>
                                                                            <v-radio :label="option.OptionText"
                                                                                :id="option.OptionID"
                                                                                :value="option.OptionValue"
                                                                                @change="AppendSection(question.QuestionID, question.QuestionType, question.IsConditionQuestion, option.OptionText)">
                                                                            </v-radio>
                                                                        </v-radio-group>
                                                                    </div>

                                                                    <!--<v-radio-group v-model="items.Answers" row>
                                                                    <v-radio :key="0"
                                                                             :label="`Yes`" :id="`Yes`"
                                                                             :value="1" @click.native="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,'Yes')">
                                                                    </v-radio>
                                                                    <v-radio :key="1"
                                                                             :label="`No`" :id="`No`" @click.native="AppendSection(question.QuestionID,question.QuestionType,question.IsConditionQuestion,'No')"
                                                                             :value="2"></v-radio>
                                                                </v-radio-group>-->
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!--GPS v-model="hdngpslocation.longitude" v-model="hdngpslocation.latitude"-->
                                                            <v-flex xs12 sm12 md12 v-if="question.QuestionType == 'GPS'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="small-input">

                                                                    <label>Longitude</label>
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-bind:id="'longitude_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                        solo full-width
                                                                        v-model="question.longitude"></v-text-field>
                                                                    <label>Latitude</label>
                                                                    <v-text-field :autocomplete="'off'" class="mt-2"
                                                                        v-bind:id="'latitude_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                        solo full-width
                                                                        v-model="question.latitude"></v-text-field>
                                                                    <v-flex xs6 sm6 md6 class="pr-1">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            @click="GetGPSLocation(question.QuestionID, question.RepeatOrder)">
                                                                            Get GPS Location
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                          


                                                            <!--sign-->
                                                            <!-- <v-flex xs12 sm12 v-if="question.QuestionType == 'Sign'">
                                                                    <label>{{ question.QuestionName }}</label>
                                                                    <sub v-if="question.IsMandatory == true" style="color:red;font-size:large">*</sub>
                                                                    <v-btn color="white" full-width :id="'btnsignaturepad_' + question.QuestionID + '_' + question.RepeatOrder" @click="GetSignaturePad(question.QuestionID, question.RepeatOrder)">Open Signature Pad</v-btn>
                                                                   
                                                                    <div :id="'signaturepaddiv_' + question.QuestionID + '_' + question.RepeatOrder" style="display:none;align-items:center">
                                                                        <canvas ref="signatureCanvas" :id="'signature-pad_' + question.QuestionID + '_' + question.RepeatOrder" width="400" height="200" style="border: 1px solid black;"></canvas>
                                                                        <button type="button" class="Sig-btn-close" :id="'btn-close_' + question.QuestionID + '_' + question.RepeatOrder">x</button>
                                                                        <button class="text-none" :id="'save_' + question.QuestionID + '_' + question.RepeatOrder">Save</button>&nbsp;&nbsp;
                                                                        <button class="text-none" :id="'clear_' + question.QuestionID + '_' + question.RepeatOrder">Clear</button>
                                                                    </div>
                                                                   
                                                                    <div v-for="(itm, index) in question.Blob" :key="index">
                                                                        <v-card-text class="py-1">
                                                                                <img v-if="itm"
                                                                                    :src="URL ? URL.createObjectURL(itm) : ''"
                                                                                    alt="Signature"
                                                                                    >
                                                                            </v-card-text>
                                                                    </div>
                                                                   
                                                                    <br />
                                                                    <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder" style="color:red;display:none">
                                                                        {{ question.ErrorText }}
                                                                    </div>
                                                                    </v-flex> -->
                                                                      <!--sign-->
                                                            <v-flex xs12 sm12 v-if="question.QuestionType == 'Sign'">
                                                                    <label>{{ question.QuestionName }}</label>
                                                                    <sub v-if="question.IsMandatory == true" style="color:red;font-size:large">*</sub>
                                                                    <v-btn color="white" full-width :id="'btnsignaturepad_' + question.QuestionID + '_' + question.RepeatOrder" @click="GetSignaturePad(question.QuestionID, question.RepeatOrder)">Open Signature Pad</v-btn>
                                                                   
                                                                    <!-- <div :id="'signaturepaddiv_' + question.QuestionID + '_' + question.RepeatOrder" style="display:none;align-items:center" class="signature-container">
                                                                        <canvas ref="signatureCanvas" :id="'signature-pad_' + question.QuestionID + '_' + question.RepeatOrder" class="sigCanvasWidth"></canvas>
                                                                        <button type="button" class="Sig-btn-close" :id="'btn-close_' + question.QuestionID + '_' + question.RepeatOrder">x</button>
                                                                        <button class="text-none" :id="'save_' + question.QuestionID + '_' + question.RepeatOrder">Save</button>&nbsp;&nbsp;
                                                                        <button class="text-none" :id="'clear_' + question.QuestionID + '_' + question.RepeatOrder">Clear</button>
                                                                    </div> -->
                                                                    <div :id="'signaturepaddiv_' + question.QuestionID + '_' + question.RepeatOrder" style="display:none;align-items:center" class="signature-container">
                                                                        <button type="button" class="Sig-btn-close" :id="'btn-close_' + question.QuestionID + '_' + question.RepeatOrder">x</button>
                                                                        <canvas ref="signatureCanvas" :id="'signature-pad_' + question.QuestionID + '_' + question.RepeatOrder" class="sigCanvasWidth"></canvas>
                                                                        <!-- <button type="button" class="Sig-btn-close" :id="'btn-close_' + question.QuestionID + '_' + question.RepeatOrder">x</button> -->
                                                                        <div class="button-container">
                                                                        <button class="text-none" :id="'save_' + question.QuestionID + '_' + question.RepeatOrder">Save</button>&nbsp;&nbsp;
                                                                        <button class="text-none" :id="'clear_' + question.QuestionID + '_' + question.RepeatOrder">Clear</button>
                                                                    </div>
                                                                    </div>

                                                                    <!-- <div class="signature-container" :id="'signaturepaddiv_' + question.QuestionID + '_' + question.RepeatOrder">
                                                                        <button type="button" class="Sig-btn-close" :id="'btn-close_' + question.QuestionID + '_' + question.RepeatOrder">x</button>
                                                                        <canvas ref="signatureCanvas" :id="'signature-pad_' + question.QuestionID + '_' + question.RepeatOrder" width="400" height="200" class="sigCanvasWidth"></canvas>
                                                                        <div class="button-container">
                                                                            <button class="text-none" :id="'save_' + question.QuestionID + '_' + question.RepeatOrder">Save</button>&nbsp;&nbsp;
                                                                            <button class="text-none" :id="'clear_' + question.QuestionID + '_' + question.RepeatOrder">Clear</button>
                                                                        </div>
                                                                    </div> -->
                                                                   
                                                                    <div v-for="(itm, index) in question.Blob" :key="index">
                                                                        <v-card-text class="py-1">
                                                                                <img v-if="itm"
                                                                                    :src="URL ? URL.createObjectURL(itm) : ''"
                                                                                    alt="Signature"
                                                                                    >
                                                                            </v-card-text>
                                                                    </div>
                                                                   
                                                                    <br />
                                                                    <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder" style="color:red;display:none">
                                                                        {{ question.ErrorText }}
                                                                    </div>
                                                                    </v-flex>
                                                            <!--image input field-->
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Image' && question.QuestionName != 'Documents for Source of Funds / Income Proof'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="custom-file-upload mt-2" :style="backgroundImageStyle">
                                                                    <input class="mt-2"
                                                                        v-on:change="imagetoblob($event, question.QuestionID, question.RepeatOrder)"
                                                                        type="file" accept=".gif, .jpg, .jpeg, .png"
                                                                        multiple="multiple" />
                                                                    <div style="color: grey;">(Click on the icon to
                                                                        upload/capture the image)
                                                                    </div>
                                                                </div>
                                                                <div v-for="(itm, index) in question.Blob" :key="index">
                                                                    <v-card-text class="py-1">
                                                                        <input type="image"
                                                                            v-bind:src="URL.createObjectURL(itm)">
                                                                    </v-card-text>
                                                                </div>
                                                                <div :id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12
                                                                v-if="question.QuestionType == 'Image' && dispDocForSourceOfFunds && question.QuestionName == 'Documents for Source of Funds / Income Proof'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div class="custom-file-upload mt-2" :style="backgroundImageStyle">
                                                                    <input class="mt-2"
                                                                        v-on:change="imagetoblob($event, question.QuestionID, question.RepeatOrder)"
                                                                        type="file" accept=".gif, .jpg, .jpeg, .png"
                                                                        multiple="multiple" />
                                                                    <div style="color: grey;">(Click on the icon to
                                                                        upload/capture the image)
                                                                    </div>
                                                                </div>
                                                                <div v-for="(itm, index) in question.Blob" :key="index">
                                                                    <v-card-text class="py-1">
                                                                        <input type="image"
                                                                            v-bind:src="URL.createObjectURL(itm)">
                                                                    </v-card-text>
                                                                </div>
                                                                <div :id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <!--Lite KYC Camera Upload -->

                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'CaptureImage'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <img src="" class="ic-shadow" id="captureImage"
                                                                        style="margin:0 !important;display: none;"
                                                                        alt="Attachment" width="200">
                                                                    <div class="inputContainer headingExtra">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            style="max-width: max-content;"
                                                                            @click="captureDocs($event, question.QuestionID, question.RepeatOrder)"
                                                                            id="start-camera"><b>Capture the
                                                                                Image</b></v-btn>
                                                                    </div>
                                                                </div>

                                                                <div class="modal-backdrop camerapopup" ref="modal"
                                                                    id="captureModalDocuments" data-keyboard="false"
                                                                    data-backdrop="static" v-if="isModalVisible">
                                                                    <div class="modal">
                                                                        <section class="modal-body">
                                                                            <slot name="body">
                                                                                <div class="play-area">
                                                                                    <!-- <center> -->
                                                                                    <div class="play-area-sub">
                                                                                        <video id="track" muted
                                                                                            playsinline
                                                                                            autoplay></video>
                                                                                    </div>
                                                                                    <!-- </center> -->
                                                                                </div>
                                                                                <div style="display:none">
                                                                                    <h3>The Capture</h3>
                                                                                    <canvas id="capture"></canvas>
                                                                                    <div id="snapshot"></div>
                                                                                </div>
                                                                            </slot>
                                                                        </section>
                                                                        <footer class="modal-footer">
                                                                            <v-layout row justify-center>
                                                                                <v-flex xs12 sm12 md6>
                                                                                    <v-btn color="primary-btn" dark
                                                                                        block class="text-none"
                                                                                        @click="captureTheImg($event, question.QuestionID, question.RepeatOrder)"
                                                                                        id="click-photo">Click
                                                                                        Photo</v-btn>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </footer>
                                                                    </div>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>



                                                            <!--ProofOfResidence Upload Camera-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'ProofOfResidence'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <img src="" class="ic-shadow" id="ProofOfResidence"
                                                                        style="margin:0 !important;display: none;"
                                                                        alt="Attachment" width="200">
                                                                    <div class="inputContainer headingExtra">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            style="max-width: max-content;"
                                                                            @click="captureResidenceProof($event, question.QuestionID, question.RepeatOrder)"
                                                                            id="start-camera-ResidenceProof"><b>Capture
                                                                                the Image</b></v-btn>
                                                                    </div>
                                                                </div>

                                                                <div class="modal-backdrop camerapopup" ref="modal"
                                                                    id="captureModalDocuments" data-keyboard="false"
                                                                    data-backdrop="static"
                                                                    v-if="isResidenceProofModalVisible">
                                                                    <div class="modal">
                                                                        <section class="modal-body">
                                                                            <slot name="body">
                                                                                <div class="play-area">
                                                                                    <!-- <center> -->
                                                                                    <div class="play-area-sub">
                                                                                        <video id="track" muted
                                                                                            playsinline
                                                                                            autoplay></video>
                                                                                    </div>
                                                                                    <!-- </center> -->
                                                                                </div>
                                                                                <div style="display:none">
                                                                                    <h3>The Capture</h3>
                                                                                    <canvas
                                                                                        id="captureProofOfResidence"></canvas>
                                                                                    <div id="snapshot"></div>
                                                                                </div>
                                                                            </slot>
                                                                        </section>
                                                                        <footer class="modal-footer">
                                                                            <v-layout row justify-center>
                                                                                <v-flex xs12 sm12 md6>
                                                                                    <v-btn color="primary-btn" dark
                                                                                        block class="text-none"
                                                                                        @click="captureTheProofOfResidence($event, question.QuestionID, question.RepeatOrder)"
                                                                                        id="click-residenceProof-photo">Click
                                                                                        Photo</v-btn>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </footer>
                                                                    </div>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <!--Utility Bill Upload Camera-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'ProofOfUtilityBill'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>
                                                                <div>
                                                                    <img src="" class="ic-shadow"
                                                                        id="ProofOfUtilityBill"
                                                                        style="margin:0 !important;display: none;"
                                                                        alt="Attachment" width="200">
                                                                    <div class="inputContainer headingExtra">
                                                                        <v-btn color="primary-btn" dark block
                                                                            class="text-none"
                                                                            style="max-width: max-content;"
                                                                            @click="captureUtilityBillProof($event, question.QuestionID, question.RepeatOrder)"
                                                                            id="start-camera-UtilityBillProof"><b>Capture
                                                                                the Image</b></v-btn>
                                                                    </div>
                                                                </div>

                                                                <div class="modal-backdrop camerapopup" ref="modal"
                                                                    id="captureModalDocuments" data-keyboard="false"
                                                                    data-backdrop="static"
                                                                    v-if="isUtilityBillModalVisible">
                                                                    <div class="modal">
                                                                        <section class="modal-body">
                                                                            <slot name="body">
                                                                                <div class="play-area">
                                                                                    <div class="play-area-sub">
                                                                                        <video id="track" muted
                                                                                            playsinline
                                                                                            autoplay></video>
                                                                                    </div>
                                                                                </div>
                                                                                <div style="display:none">
                                                                                    <h3>The Capture</h3>
                                                                                    <canvas
                                                                                        id="captureProofOfUtilityBill"></canvas>
                                                                                    <div id="snapshot"></div>
                                                                                </div>
                                                                            </slot>
                                                                        </section>
                                                                        <footer class="modal-footer">
                                                                            <v-layout row justify-center>
                                                                                <v-flex xs12 sm12 md6>
                                                                                    <v-btn color="primary-btn" dark
                                                                                        block class="text-none"
                                                                                        @click="captureTheProofOfUtilityBill($event, question.QuestionID, question.RepeatOrder)"
                                                                                        id="click-residenceProof-photo">Click
                                                                                        Photo</v-btn>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </footer>
                                                                    </div>
                                                                </div>
                                                                <div v-bind:id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>

                                                            <!--Audio-->
                                                            <v-flex xs12 sm12 md12
                                                                v-if="question.QuestionType == 'Audio'">
                                                                <label>{{ question.QuestionName }}</label><sub
                                                                    v-if="question.IsMandatory == true"
                                                                    style="color:red;font-size:large">*</sub>

                                                                <div class="custom-file-upload mt-2" 
                                                                    style="height:auto">
                                                                    <!--<audio-recorder v-modal="question.Answers" :id="question.QuestionID" upload-url="some url"
                                                                        :attempts="1"
                                                                        :time="1"
                                                                        :before-recording="callback"
                                                                        :after-recording="audiotoblob"
                                                                        :before-upload="callback"
                                                                        :successful-upload="callback"
                                                                        :failed-upload="callback" />-->
                                                                </div>
                                                                <div v-for="(itm, index) in question.Blob" :key="index">
                                                                    <audio id="player"
                                                                        v-bind:src="URL.createObjectURL(itm)" controls
                                                                        class="mt-4"></audio>
                                                                </div>
                                                                <div :id="'lbl_' + question.QuestionID + '_' + question.RepeatOrder"
                                                                    style="color:red;display:none">
                                                                    {{ question.ErrorText }}</div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12>
                                                                <div
                                                                    v-bind:id="'question_subsection_' + question.QuestionID">

                                                                </div>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </div>
                                        </v-container>
                                    </v-card-text>


                                    <v-card-actions style="margin: 1rem;">
                                        <v-layout row wrap>
                                            <v-flex xs12 sm12 md12 v-if="showProcessMsg">
                                                <v-layout row justify-center style="padding-bottom: 1rem;">
                                                    <v-flex xs12 sm12 md6 v-if="dataProcessed">
                                                        <!-- <v-alert :value="true"
                                                                 color="success"
                                                                 icon="check_circle"
                                                                 outline="" v-if="dataprocessedsuccess">
                                                            {{ProcessMsg}}
                                                        </v-alert> -->
                                                        <v-alert :value="true" color="error" icon="warning" outline=""
                                                            v-if="dataprocessedfailure">
                                                            {{ ProcessMsg }}
                                                        </v-alert>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md6 class="text-xs-center" v-else>
                                                        <h4>Form Data Processing. Please wait...</h4>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12 v-if="Issubmitclicked === 'False'">
                                                <v-layout row justify-center style="margin-bottom: 2px">
                                                    <!-- <v-flex xs6 class="pl-1" style="flex-basis: 0% !important;">
                                                        <v-btn color="primary-btn" dark block class="text-none" style="font-weight: bold;max-width: max-content;" v-on:click="PreviousSectionQuestions(items.SurveyID,SelectedSection-1);$('#qstDiv').scrollTop(0);" v-if="SelectedSection>1">Back</v-btn>
                                                    </v-flex> -->

                                                    <v-flex xs6 class="pl-1" style="flex-basis: 0% !important;">
                                                        <v-btn color="primary-btn" dark block class="text-none"
                                                            style="font-weight: bold;max-width: max-content;"
                                                            v-on:click="PreviousSectionQuestions(items.SurveyID, SelectedSection - 1); $('#qstDiv').scrollTop(0);">Back</v-btn>
                                                    </v-flex>

                                                    <v-flex xs8 sm8 class="text-xs-center">
                                                        <h3 class="grey--text text--darken-2"> {{ SelectedSection }} /
                                                            {{ TotSections }} </h3>
                                                    </v-flex>

                                                    <v-flex xs6 class="pr-1" style="flex-basis: 0% !important;"
                                                        v-if="dispProcessBtn == true">
                                                        <v-btn color="primary-btn" dark block class="text-none"
                                                            style="font-weight: bold;max-width: max-content;"
                                                            @click="SubmitDataProcess()">Submit
                                                            Form</v-btn>
                                                    </v-flex>

                                                    <v-flex xs6 class="pl-1" style="flex-basis: 0% !important;"
                                                        v-if="SelectedSection < TotSections">
                                                        <v-btn color="primary-btn" dark block class="text-none"
                                                            style="font-weight: bold;max-width: max-content;"
                                                            v-on:click="NextSectionQuestions(items.SurveyID, SelectedSection + 1); $('#qstDiv').scrollTop(0);">Next</v-btn>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm12 md12 v-if="Issubmitclicked === 'True'">
                                                <v-layout row justify-center>
                                                    <v-flex xs12 sm12 md6>
                                                        <h2 style="text-align:center;">Please Wait</h2>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>


        <div class="successDialog text-center" style="display: contents !important;">
            <v-dialog persistent success v-model="dialogSuccess" class="transparentBackground max-content" >
                <div style="display:flex !important; justify-content: center !important">
                <v-card class="modal-backdrop maxWidth bckgrndTransparent" ref="modal" data-backdrop="static" v-model="dialogSuccess">
                    <div class="modal w-100" style="max-width: fit-content;overflow-y: auto; text-align: -webkit-center;">
                        <v-card-text>

                            <div style="border: 1px solid green">
                                <v-alert :value="true" color="success" class="successicon" 
                                    style="place-self: baseline; text-align: center;border-width: 0px !important;background-color: white !important; font-size: 30px; color: green !important">
                                    <i class="mdi mdi-check-circle"></i>
                                </v-alert>

                                <p style="text-align-last: center; padding: 10px !important;">
                                    <b>{{ successMessage1 }}</b><br />
                                    {{ successMessage2 }} <br />
                                    {{ successMessage }}

                                <ul id="example-1">
                                    <li v-for="(item, index) in uploadSuccess" :key="index"
                                        style="max-width: fit-content;">
                                        {{ item }}
                                    </li>
                                </ul>
                                </p>
                            </div>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark
                                @click="downloadPDF()">
                                Download PDF
                            </v-btn>
                            <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark
                                @click="popUpOkButton()">
                                Finish
                            </v-btn>
                            
                        </v-card-actions>
                    </div>
                </v-card>
            </div>
            </v-dialog>
        </div>

        <v-dialog persistent v-model="dialogError" style="transform: translate(25%, 0%);box-shadow: none !important;">
            <v-card class="errorWidth">
                <v-card-text>
                    <v-alert :value="true" color="error" outline>
                        <span class="mdi mdi-alert"></span> {{ ErrorMessage }}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark
                        @click="ErrorpopUpOkButton()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="dialogError1">
            <v-card>
                <v-card-text>
                    <v-alert :value="true" color="error" outline>
                        <span class="mdi mdi-alert"></span> {{ ErrorMessage }}
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-btn style="margin-right:auto;margin-left:auto" color="primary-btn" dark @click="tolimitExceed()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <div class="processingDiv"
            v-bind:class="{ 'show': processLoader == 1 || processLoader == 2 || processLoader == 3 || processLoader == 4 || processLoader == 5 }">
            <v-layout row wrap justify-center>
                <v-flex md4 class="text-xs-center">
                    <v-stepper class="elevation-0" v-model="processLoader" style="width:100%">
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <img :src="processLoader1" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{ SubmitProgressMessage }}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <img :src="processLoader2" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{ SubmitProgressMessage }}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <img :src="processLoader3" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{ SubmitProgressMessage }}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="4">
                                <img :src="processLoader4" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{ SubmitProgressMessage }}
                                </h3>
                            </v-stepper-content>
                            <v-stepper-content step="5">
                                <img :src="processLoader5" class="stepper-vector center-block" />
                                <h3 class="text-primary">
                                    {{ SubmitProgressMessage }}
                                </h3>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-flex>
            </v-layout>
        </div>

        <!--Preloader starts-->
        <div class="pre-loader" v-show="PreLoader==true" v-hide="PreLoader == false">
    
    <img :src="preLoaderImg">
  
  </div>
  
  <!--Preloader ends-->
    </v-container>

</template>

<script type="text/javascript">
// var blobObject = new Array();

import formListIcon from '@/assets/images/Survey_List.svg';
import 'core-js/modules/es.array.push.js';  
import router from '@/router';
import { db, externalURL,disabledFields } from '@/sunidhiapp';
// import axios from 'axios';
import '@/customJs/compressjs.js'
// import VCheckBox from '@/components/VCheckBox.vue';
import SignaturePad from '@/customJs/signature_pad.min.js'
// import SignaturePad from 'signature_pad';
import $ from 'jquery';
// eslint-disable-next-line no-unused-vars
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import {  VCheckbox } from 'vuetify/lib';
// Vue.prototype.$http = axios;
//Vue.use(VueAudioRecorder);
// Vue.component('vue-multiselect', window.VueMultiselect.default);
// import jsPDF from 'jspdf';
import processLoader1 from '@/assets/images/process_loader-1.gif';
import processLoader2 from '@/assets/images/process_loader-2.gif';
import processLoader3 from '@/assets/images/process_loader-3.gif';
import processLoader4 from '@/assets/images/process_loader-4.gif';
import processLoader5 from '@/assets/images/process_loader-5.gif';
import imagePath from '@/assets/images/ic-fileUpload.png';
// import axios from 'axios';

var cameraStream = null;
export default {
    name: 'HomeDataForm',
    computed: {
    backgroundImageStyle() {
      return {
        backgroundImage: `url(${imagePath})`
      };
    },
    params() {
            return {
                query: this.Search
            };
        }
  },
    components: {
        VCheckbox
  },
    data: function () {
        return {
            upload: {
                blbImage: "",
                blbAudio: "",
                FileName: [],
                blbFile: [],
                blbsignImage: [],
            },
            Issubmitclicked: 'False',
            SurveyName: '',
            Search: "",
            //NotificationCount:0,
            loading: true,
            MorePopup: false,
            TotSections: 0,
            SelectedSection: 1,
            FilterPopup: false,
            searchBox: false,
            ActiveAddQuestPopup: false,

            ActiveSurveyList: [],
            SurveySectionList: [],
            CurrentSectionQuestions: [],
            EditedSurveyList: [],
            sectionArray: [],
            SubmittedSurveyList: [],
            MorePopupEditTab: false,
            FilterPopupEditTab: false,
            SearchPopup: false,
            searchBoxEditTab: false,
            fileimageerrmsg: '',
            liveness: 'False',
            facematch: 'False',
            facematchPercentage: '',
            dialogSuccess: false,
            successMessageUserName: "",
            successMessagePassword: "",
            successLoginDetails: "",
            hdngpslocation: "",
            submitLoading: false,
            UploadStatusMsg: "",
            UploadStatus: false,
            ErrorMessage: "",
            dialogError: false,
            isMinor: false,
            dialogError1: false,
            ActiveSurveyListHeader: [
                { text: "Form Name", value: "SurveyName", align: "left" },
                { text: "", value: "" },
            ],
            EditedSurveyListHeader: [
                { text: "Form Name", value: "", align: "left" },
                { text: "Form Count", value: "" },
                { text: "", value: "" }
            ],
            SubmittedSurveyListHeader: [
                { text: "Form Name", value: "", align: "left" },
                { text: "Form Count", value: "" },
                { text: "", value: "" }
            ],
            SubmitProgressMessage: "",
            processLoader: 6,
            customerCreationNo: "",
            casaAccountNo: "",
            uploadSuccess: [],
            dataProcessed: false,
            showProcessMsg: false,
            ProcessMsg: "",
            onceProcessed: false,
            ProcessedSurveySectionList: [],
            processedFormId: 0,
            processedStatus: true,
            dataprocessedsuccess: false,
            dataprocessedfailure: false,
            PreLoader: false,
            reviewerCheck: false,
            years_period: "00",
            months_period: "00",
            dispProcessBtn: false,
            successMessage: "",
            successMessage1: "",
            successMessage2: "",
            dispSavingAccountClass: false,
            dispCurrentAccountClass: false,
            dispCallAccountClass: false,
            dispTransactionalAccountClass: false,
            dispFullKycAccountClass: false,
            isSubmitBtnClicked: false,
            captureImageModal: false,
            nationalidBackModal: false,
            isModalVisible: false,
            isResidenceProofModalVisible: false,
            isUtilityBillModalVisible: false,
            isSourceOfFundsModalVisible: false,
            isdispEmployedLookup: false,
            isdispUnEmployedLookup: false,
            isdispPensionerLookup: false,
            isdispSelfEmployedLookup: false,
            dispDocForSourceOfFunds: false,
            isLocalID: false,
            expiryErrMsg: false,
            isSaveCount: 0,
            isCallAcct: false,
            signaturePad: null,
            URL: window.URL || window.webkitURL,
            surverListIcon: formListIcon,
            processLoader1: processLoader1,
                processLoader2: processLoader2,
                processLoader3: processLoader3,
                processLoader4: processLoader4,
                processLoader5: processLoader5,


        };
    },
        // components: { VueAudioRecorder },
        watch: {
            params: {
                handler() {
                    this.GetActiveSurvey().then(data => {
                        this.ActiveSurveyList = data.ActiveSurveyList;
                    });
                    this.GetEditedSurvey().then(data => {
                        this.EditedSurveyList = data.EditedSurveyList;
                    });
                    this.GetSubmittedSurvey().then(data => {
                        this.SubmittedSurveyList = data.SubmittedSurveyList;
                        console.log("submitList::::", this.SubmittedSurveyList)
                    });
                },
                deep: true
            }
        },
        mounted: async function () {
        document.addEventListener('click', this.handleClickOutside);
        this.$sunidhi.logoutBtnDisp = 'false';
        await this.$sunidhi.insertofflinedata(1);
        await this.$sunidhi.insertLiteKycAcctdata(1);
       
        // await this.getLookUpValues();

        this.Issubmitclicked = 'False';

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.hdngpslocation = position.coords.latitude + "," + position.coords.longitude;
            });
        }

        await this.GetEditedSurvey().then(data => {
            this.EditedSurveyList = data.EditedSurveyList;
        });
        this.GetActiveSurvey().then(data => {
            this.ActiveSurveyList = data.ActiveSurveyList;
        });
        this.GetSubmittedSurvey().then(data => {
            this.SubmittedSurveyList = data.SubmittedSurveyList;
            console.log("test2::::", this.SubmittedSurveyList )
        });

        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
        if (genzdata != null || genzdata.length > 0) {
            if (typeof genzdata[0].liveness != 'undefined') {
                this.liveness = genzdata[0].liveness;
            }

            if (typeof genzdata[0].facematch != 'undefined') {
                this.facematch = genzdata[0].facematch;

                if (this.facematch == 'False') {
                    this.reviewerCheck = true;
                }
            }
            if (typeof genzdata[0].facematchPercentage != 'undefined') {
                this.facematchPercentage = genzdata[0].facematchPercentage;
                console.log("percentage:", this.facematchPercentage)

            }
        }
        this.todo();
    },
    // computed: {
    //     params() {
    //         return {
    //             query: this.Search
    //         };
    //     }
    // },
    beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
    methods: {
        toggleSearchBox() {
      this.searchBox = !this.searchBox;
    },

    handleClickOutside(event) {
      const searchElement = this.$refs.searchBox;
      if (searchElement && !searchElement.contains(event.target)) {
        this.searchBox = false;
      }
    },
    generateRandomId() {
      // Generate a random 4-digit number
    //   return Math.floor(1000 + Math.random()* 9000);  // to get 4 digits
      return Math.floor(10 + Math.random() * 90); // to get 2 digits
    },
        formatDate(createdDate) {
            if (typeof createdDate === 'object' && createdDate instanceof Date) {
                // Extract string representation of the date
                const dateString = createdDate.toString();
                // Perform the replacement
                return dateString.replace(/GMT\+(\d{2})(\d{2})/, 'GMT+$1:$2');
            } else {
                // If createdDate is not a Date object, return as is
                return createdDate;
            }
        },

        issuanceDateRestrictionMax: function (questionName) {
            if (questionName == "Passport Issue Date" || questionName == 'Date of Birth') {
                // Use Javascript
                var dtToday = new Date();

                var month = dtToday.getMonth() + 1;
                var day = dtToday.getDate();
                var year = dtToday.getFullYear();
                if (month < 10)
                    month = '0' + month.toString();
                if (day < 10)
                    day = '0' + day.toString();

                var minDate = year + '-' + month + '-' + day;

                return minDate
            }

        },
        expiryDateRestrictionMax: function (questid, questReporder, questionName) {

            if (questionName == "National ID Expiry Date" || questionName == "Passport Expiry Date") {
                var today = new Date();
                var dd = String(today.getDate()).padStart(2, '0');
                var mm = String(today.getMonth() + 1).padStart(2, '0');
                var yyyy = today.getFullYear();

                today = yyyy + '-' + mm + '-' + dd;
                $('#date_picker_' + questid + '_' + questReporder).prop('min', today);
                // $('expirydt_'+questID).prop('min',today);

            }

        },

        //Validation for input starts//
        checkValidation(event, type) {
            if (type === "onlySpaceAlphabet") {
                this.isAlphabetSpace(event);
            } else if (type === "onlyAlphabet") {
                this.isAlphabet(event);
            } else if (type === "AlphaNumeric") {
                this.isAlphaNumeric(event);
            } else if (type === "onlyEmailId") {
                this.emailRestrict(event);
            }
        }, checkValidationMb(event, type) {
            if (type === "onlySpaceAlphabet") {
                this.isAlphabetSpaceMb(event);
            } else if (type === "onlyAlphabet") {
                this.isAlphabetMb(event);
            } else if (type === "AlphaNumeric") {
                this.isAlphaNumeric(event);
            } else if (type === "onlyEmailId") {
                this.emailRestrictMb(event);
            }
        },

        isLetter(e, question) {
            // debugger
            // if(question.questionName == 'First Name' || question.questionName == 'Middle Name' || question.questionName == 'Surname' || question.questionName == 'Place of Birth' || question.questionName =='Name of Spouse' ||  question.questionName == "Employer's Name" )
            if (question.QuestionName == 'First Name') {
                var regex = new RegExp("^[a-zA-Z ]+$");
                var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
                // var value = question.Answers

                // Test the value against the regular expression
                if (!regex.test(key)) {
                    e.preventDefault();
                }
            }
        },

        spaceRestrict: function (event) {
            if (event.keyCode === 32) {
                event.preventDefault();
            }


        },
        RemoveSpace(event, question) {
            // debugger
            let val = event.target._value;
            question.Answers = val.trim();

        },
        emailRestrict: function (event) {
            var regex = new RegExp("^[a-zA-Z0-9.@_]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, emailRestrictMb: function (event) {
            event.srcElement.value = event.srcElement.value.replace(/[^[a-zA-Z0-9.@_]/gi, '');
        },

        isAlphabet(event) {
            // debugger
            var regex = new RegExp("^[a-zA-Z ]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        },
        isAlphabetSpace(event) {
            var regex = new RegExp("^[a-zA-Z ]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, isAlphaNumeric(event) {
            var regex = new RegExp("^[a-zA-Z0-9]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            } else {/*
						$input = event.srcElement.value;
						if ($input.length == 2) {
						  event.srcElement.value = event.srcElement.value+"-";
						}
						var isAlphabet =true;
						var regex = new RegExp("^[a-zA-Z ]+$");
						var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
						if (!regex.test(key)) {
						   isAlphabet = false;
						}
						if(isAlphabet){
						  if ($input.length == 9 || $input.length == 10) {
						  $input = $input.replace(/(\d{2})(\d{6,7})/, "$1-$2")
						  event.srcElement.value = $input + "-";
						  } else {
						   event.preventDefault();
						   return false;
						  }
						} else if($input.length == 10){
						  if(!isAlphabet){
						   event.preventDefault();
						   return false;
						  }
						}
						if (($input.length == 11 || $input.length == 12)&& ( $input[$input.length-1] !="-")) {
						  $input = $input.replace(/(\d{2})(\d{6,7})(\w{1})/, "$1-$2-$3")
						  event.srcElement.value = $input+"-"; 
						}
						var finalRegex =  new RegExp('^[0-9]{2}[\-][0-9]{6,7}[\-][A-Za-z][\-][0-9]{2}$');
						if(finalRegex.test($input)){
						   if(!isAlphabet){
						   event.preventDefault();
						   return false;
						  }
						}
						
						return true;*/
            }
        },
        isAlphabetSpaceMb(event) {
            event.srcElement.value = event.srcElement.value.replace(/[^a-zA-Z ]/gi, '');
        },
        isNumberMb(event) {
            event.srcElement.value = event.srcElement.value.replace(/[^0-9]/gi, '');
        }, spaceRestrictMb: function (event) {
            event.srcElement.value = event.srcElement.value.replace(" ", '');

        }, isAlphabetMb(event) {
            event.srcElement.value = event.srcElement.value.replace(/[^a-zA-Z ]/gi, '');
        },
        isNumber: function (event) {
            // console.log(event)
            var regex = new RegExp("^[0-9]+$");
            var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, dateRestrictionMax: function (questionName) {
            if (questionName == "Date of Birth") {
                // Use Javascript
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; //January is 0 so need to add 1 to make it 1!
                var yyyy = today.getFullYear();
                if (dd < 10) {
                    dd = '0' + dd
                }
                if (mm < 10) {
                    mm = '0' + mm
                }

                var maxYear = yyyy - 18; //Calculate Maximum Age (>18)
                var max = maxYear + "-" + mm + "-" + dd;
                return max;
            }
        },
        removeIDformat(event, question) {
            if (question.QuestionName == "ID Number") {
                event.target.value = event.target.value.replace(/[^a-zA-Z0-9]/gi, '');
            }
        }, addIDformat(event, question) {
            //    debugger
            // var AnswerValue = question.Answers;

            //    question.Answers = AnswerValue.trim();
            if (question.QuestionName == "ID Number") {

                var $input = event.srcElement.value;

                var regex = new RegExp("^[0-9]{8,9}[A-Za-z][0-9]{2}$");
                if (regex.test($input)) {
                    $input = $input.replace(/(\d{2})(\d{6,7})(\w{1})(\d{2})/, "$1-$2-$3-$4")
                    //    $input = $input.replace(/(\d{2})(\w{8})(\d{2})/, "$1-$2-$3");
                    event.target.value = $input.toUpperCase();
                    question.Answers = $input.toUpperCase();
                    document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).textContent = "";
                    document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).style.display = "none";

                } else {
                    var regex2 = new RegExp("^[0-9]{2}-[0-9]{6,7}-[A-Za-z]-[0-9]{2}$");
                    // var regex2 =new RegExp("^[0-9]{2}[\-][A-Za-z0-9]{8}[\-][0-9]{2}$");
                    if (regex2.test($input)) {
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).textContent = "";
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).style.display = "none";

                    } else {
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).textContent = question.ErrorText;
                        document.getElementById("lbl_" + question.QuestionID + "_" + question.RepeatOrder).style.display = "inline";
                    }
                }
            }

        },

        //Validation for input ends // 

        //adding custom value to occupation
        addTag(newTag, question) {
            question.Answers = ({ "OptionValue": newTag, "OptionText": newTag });


        },

        gotoSavedTab(surveyid) { this.backbuttonpressed = false; router.push('/dataforms/' + surveyid + '/true') },
        async tolimitExceed() {
            this.backbuttonpressed = false;
            this.dialogError1 = false;
            this.ErrorMessage = "";
            this.Issubmitclicked = 'False';
            //  window.location.reload();
            // if (this.uploadSuccess != null && this.uploadSuccess.length > 0) {
            //     window.location.reload();
            // }
            //  else {
            //     await this.GetEditedSurvey().then(data => {
            //         this.EditedSurveyList = data.EditedSurveyList;
            //     });
            //     window.location.reload();
            // }
        },
        // async popUpOkButton() {
        //     backbuttonpressed = false;
        //     this.successMessage = "";
        //     this.dialogSuccess = false;
        //     window.location.reload();
        // },
        // async ErrorpopUpOkButton() {
        //     this.ErrorMessage = "";
        //     this.dialogError = false;
        // },
        async popUpOkButton() {
            // debugger
            this.backbuttonpressed = false;
            this.successMessage = "";
            this.dialogSuccess = false;
            if (this.isSubmitBtnClicked == true) {

                // router.push('/dataforms/' + this.CurrentSectionQuestions[0].SurveyID + '/false')
                // this.gotoSubmittedTab(this.CurrentSectionQuestions[0].SurveyID);
                // window.location.reload();
                this.PreLoader = true;
                // await checkDBVersion();
        //         var FormID = 0;
        // var SurveyId = 0;
        // var ClientSyncData =  await db.ClientSyncQueue.where("FormID").equals(formid).toArray();
      
                this.$sunidhi.logoutBtnDisp = 'true';
                router.push({ name: 'menuSelection' });
                // this.$router.go(0);

    }   
                
            },
            // else if( this.isSaveAndExitBtnClicked  == true){
            // this.gotoSavedTab(this.CurrentSectionQuestions[0].SurveyID);
            // }
            // key = 2;

//     async downloadPDF() {
//   try {
//     // Retrieve data from database
//     const genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

//     // Check if data is available
//     if (genzdata.length === 0) {
//       throw new Error('No data found for UserId 1');
//     }

//     // Prepare JSON data
//     // const formImageData = this.$sunidhi.formJsonValue || {};
//     var jsondata = JSON.stringify(this.$sunidhi.formJsonValue);
//     var stringifyImagejson = JSON.stringify(this.$sunidhi.formImage);
                   
//     jsondata = '{"customerdetails":' + jsondata + '}';
//     // const jsondata = JSON.stringify({ customerdetails: formImageData });

//     // Prepare FormData
//     var pdfData = new FormData();
//     pdfData.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
//     pdfData.append("UserId", genzdata[0].token);
//     pdfData.append("formjson", jsondata);
//     pdfData.append("data", stringifyImagejson);


//     // Define URL
   
//     let response = await fetch(externalURL+"PDFCreation/", {
//                         method: 'POST',
//                         body: pdfData
//                     });

    

//     // Handle response
//     let result = await response.json();
//        console.log("result:::", result);
//                     return result;
//   } catch (error) {
//     console.error('Error in pdf:', error);
//     throw error; // Re-throw the error to propagate it further if needed
//   }
// },

async downloadPDF1() {
      try {
        // Retrieve data from the database
        const genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

        // Check if data is available
        if (genzdata.length === 0) {
          throw new Error('No data found for UserId 1');
        }

        // Prepare JSON data
        var jsondata = JSON.stringify(this.$sunidhi.formJsonValue);
        var stringifyImagejson = JSON.stringify(this.$sunidhi.formImage);
        jsondata = '{"customerdetails":' + jsondata + '}';

        // Prepare FormData
        var pdfData = new FormData();
        pdfData.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
        pdfData.append("UserId", genzdata[0].token);
        pdfData.append("formjson", jsondata);
        pdfData.append("data", stringifyImagejson);

        // Define URL
        let response = await fetch(externalURL + "PDFCreation/", {
          method: 'POST',
          body: pdfData
        });

        // Handle response
        let result = await response.json();
        console.log("result:::", result);

        // Check if the result contains the PDF path
        if (result && result.PDF_path) {
          // Create a temporary link element
          const link = document.createElement('a');
          link.href = result.PDF_path;
          link.setAttribute('download', 'document.pdf'); // Set the default filename
          document.body.appendChild(link);
          link.click();

          // Clean up by removing the temporary link
          document.body.removeChild(link);
        } else {
          throw new Error('PDF path not found in the response');
        }
      } catch (error) {
        console.error('Error in pdf:', error);
        throw error; // Re-throw the error to propagate it further if needed
      }
    },

    async downloadPDF() {
  try {
    // Retrieve data from the database
    const genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();

    // Check if data is available
    if (genzdata.length === 0) {
      throw new Error('No data found for UserId 1');
    }

    // Prepare JSON data
    var jsondata = JSON.stringify(this.$sunidhi.formJsonValue);
    var stringifyImagejson = JSON.stringify(this.$sunidhi.formImage);
    jsondata = '{"customerdetails":' + jsondata + '}';

    // Prepare FormData
    var pdfData = new FormData();
    pdfData.append("PWAUserSessionId", genzdata[0].PWAUserSessionId);
    pdfData.append("UserId", genzdata[0].token);
    pdfData.append("formjson", jsondata);
    pdfData.append("data", stringifyImagejson);

    // Define URL
    let response = await fetch(externalURL + "PDFCreation/", {
      method: 'POST',
      body: pdfData,
      headers: {
        'ngrok-skip-browser-warning': '69420'  // Only include this if required by the server
    }
    });

    // Handle response
    let result = await response.json();
    console.log("result:::", result);

    // Check if the result contains the PDF path
    if(result.PWAUserSessionStatus == 'Active'){
    if (result && result.PDF_path) {

      // Fetch the PDF as a Blob
    //   window.open(result.PDF_path, '_blank');
//     const downloadLink = document.createElement('a');
//   downloadLink.href = result.PDF_path;
//   downloadLink.setAttribute('download', 'document.pdf'); // Force download
//   document.body.appendChild(downloadLink);
//   downloadLink.click();
//   document.body.removeChild(downloadLink);

//   // Fallback for browsers that open the PDF instead of downloading
//   if (!downloadLink.download) {
//     window.open(result.PDF_path, '_blank');
//   }
var pdfUrl = result.PDF_path;
const downloadLink = document.createElement('a');
downloadLink.href = pdfUrl;
downloadLink.setAttribute('download', 'downloaded-file.pdf'); // Should trigger the download
downloadLink.setAttribute('target', '_blank'); // Ensures it opens in a new tab
document.body.appendChild(downloadLink);
downloadLink.click();
document.body.removeChild(downloadLink);

        } else {
        throw new Error('PDF path not found in the response');
        }
    } else if (result.PWAUserSessionStatus == 'expired') {
        setTimeout(() => {
                    self.PreLoader = false;
                }, 500);
                this.$sunidhi.logoutBtnDisp = false;
                router.push({ name: 'SessionTimeout' });
    }
  } catch (error) {
    console.error('Error in pdf:', error);
    throw error; // Re-throw the error to propagate it further if needed
  }
},

  
        async ErrorpopUpOkButton() {
            this.ErrorMessage = "";

            if (this.isMinor == true) {

                this.dialogError = false;
                this.PreLoader = true;
                this.$sunidhi.logoutBtnDisp = 'true';
                // router.push({ name: 'menuSelection' });
                this.PreLoader = false;

                // if (window.location.pathname === '/menuSelection') {
                // // Reload the page
                // console.log("2");
                // window.location.reload();
                // }

            } else {
                window.location.reload();
            }

            // window.location.reload();

        },
        callback() {
            // console.debug('Event: ', msg)
        },
        async GetQuestionList(sectionId, SurveyID) {

            var questions = await db.TbSurveyQuestions.where({ SurveyID: SurveyID }).toArray();
            questions = questions.filter(x => x.SectionId == sectionId);
            return questions;
        },
        async GetNotificationCount() {
            var UserId;
            if (localStorage) {
                UserId = parseInt(localStorage.getItem("UserId"));
            }
            var Notifications = await db.TbNotifications.where("UserId").equals(UserId).toArray();
            Notifications = Notifications.filter(x => x.IsRead == false);

            // eslint-disable-next-line no-unused-vars
            var NotificationCount = Notifications.length;
        },
        
        // async ErrorpopUpOkButton() {
        //     debugger
        //     this.ErrorMessage = "";

        //     if (this.isMinor == true) {
        //         // setTimeout(() => {
        //         this.dialogError = false;

        //         this.PreLoader = true;
        //         this.$sunidhi.logoutBtnDisp = 'true';
        //         // router.push({ name: 'menuSelection' });
        //         this.PreLoader = false;


        //         //     if (window.location.pathname === '/menuSelection') {
        //         // // Reload the page
        //         // console.log("1");
        //         // window.location.reload();
        //         // }

        //         // }, 500);

        //         // window.location.reload()

        //     } else {
        //         this.dialogError = false;
        //         // window.location.reload();
        //     }
        // },
        // callback(msg) {
        //     // console.debug('Event: ', msg)
        // },
        // async GetQuestionList(sectionId, SurveyID) {

        //     var questions = await db.TbSurveyQuestions.where({ SurveyID: SurveyID }).toArray();
        //     questions = questions.filter(x => x.SectionId == sectionId);
        //     return questions;
        // },
        // async GetNotificationCount() {
        //     var UserId;
        //     if (localStorage) {
        //         UserId = parseInt(localStorage.getItem("UserId"));
        //     }
        //     var Notifications = await db.TbNotifications.where("UserId").equals(UserId).toArray();
        //     Notifications = Notifications.filter(x => x.IsRead == false);

        //     NotificationCount = Notifications.length;
        // },
           async GetActiveSurvey() {

                this.loading = true;
                var UserID;
                if (localStorage) {
                    // eslint-disable-next-line no-unused-vars
                    UserID = parseInt(localStorage.getItem("UserId"));
                }
                var SurveyTable = [];
                var ActiveSurveyList = [];

                SurveyTable = await db.TbSurvey.toArray();
                if (SurveyTable != null && SurveyTable.length > 0) {
                    // eslint-disable-next-line no-undef
                    for (var i = 0; i < SurveyTable.length; i++) {
                        var object = new Object();
                        // eslint-disable-next-line no-undef
                        object.SurveyID = SurveyTable[i].SurveyID;
                        // eslint-disable-next-line no-undef
                        object.SurveyName = SurveyTable[i].SurveyName;
                        // eslint-disable-next-line no-undef
                        object.CreatedDate = SurveyTable[i].CreatedDate;
                        // eslint-disable-next-line no-undef
                        object.UpdateID = SurveyTable[i].pkId;
                        ActiveSurveyList.push(object);
                    }
                }
                // eslint-disable-next-line no-unused-vars
                return new Promise((resolve, reject) => {
                    let search = this.Search.trim().toLowerCase();
                    if (search) {

                        ActiveSurveyList = ActiveSurveyList.filter(item => {
                            return Object.values(item)
                                .join(",")
                                .toLowerCase()
                                .includes(search);
                        });
                    }
                    ActiveSurveyList = [...new Map(ActiveSurveyList.map(item => [item.SurveyID, item])).values()];
                    setTimeout(() => {
                        this.loading = false;
                        resolve({
                            ActiveSurveyList
                        });
                    }, 300);

                })
                },
        async GetSurveySections(SurveyID, sectionOrder) {
            // await formsSessionTimeout(); // to check the session timeout
            //  setTimeout(() => {
            this.ActiveAddQuestPopup = true;
            this.SurveyName = "";
            this.SurveySectionList = [];
            this.CurrentSectionQuestions = [];

            this.TotSections = 0;
            this.SelectedSection = 1;
            var SurveySectionList = [];
            var surevy = await db.TbSurvey.where({ SurveyID: SurveyID }).toArray();
            this.SurveyName = (surevy != null && surevy.length > 0) ? surevy[0].SurveyName : "";
            this.sectionArray = [];

            var ans3 = await db.TbSurveySection.where({ SurveyId: SurveyID }).toArray();
            var ans = (ans3 != null ? ans3.sort(function (a, b) { return a.SectionOrder - b.SectionOrder }) : ans3);

            var totConditionQuestion = 0;

            for (var i = 0; i < ans.length; i++) {
                var conArray = await db.TbSurveyQuestions.where({ ConditionSectionId: ans[i].SectionId }).toArray();
                conArray = conArray.filter(x => x.IsConditionQuestion == true);

                var RepeatArray = await db.TbSurveyQuestions.where({ RepeatSectionId: ans[i].SectionId }).toArray();
                RepeatArray = RepeatArray.filter(x => x.IsRepeatSection == true);
                totConditionQuestion += conArray.length + RepeatArray.length;

                if (conArray.length == 0 && RepeatArray.length == 0) {
                    this.sectionArray.push(ans[i].SectionId);
                }

                var object = new Object();
                object.SectionId = ans[i].SectionId;
                object.SectionName = ans[i].Name;
                object.SectionOrder = ans[i].SectionOrder;
                object.SurveyID = ans[i].SurveyId;
                object.SurveyName = this.SurveyName;
                //var dd = await this.GetSectionQuestionList(ans[i].SectionId)
                object.Questions = await this.GetSectionQuestionList(ans[i].SectionId)
                object.IsConditionQuestion = conArray.length > 0 ? true : false;
                object.IsRepeatSection = RepeatArray.length > 0 ? true : false;
                SurveySectionList.push(object);
            }

            this.SurveySectionList = SurveySectionList;
            this.TotSections = ans.length > 0 ? (ans.length - totConditionQuestion) : 0;
            this.CurrentSectionQuestions = SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder]);

            this.PreLoader = false;
            setTimeout(() => {
                // $("#AccountNumber_layout").hide();
                // $("#IntrestSpecify_layout").hide();
                // $("#SpouseName_layout").hide();
                // $("input[type='date']").keydown(function (event) { event.preventDefault(); });
                $("#Account Class_layout").hide();
            }, 1000);

            // },1000);

        },
        async GetSectionQuestionList(SectionId) {
            var SurveySectionList = [];
            var SurveyQuestion = await db.TbSurveyQuestions.where({ SectionId: SectionId }).toArray();

            for (var i = 0; i < SurveyQuestion.length; i++) {
                var object = new Object();
                object.QuestionID = SurveyQuestion[i].QuestionID;
                object.QuestionName = SurveyQuestion[i].QuestionName;
                object.QuestionLabel = SurveyQuestion[i].QuestionLabel;
                object.QuestionText = SurveyQuestion[i].QuestionText;
                object.QuestionType = SurveyQuestion[i].QuestionType;
                object.QuestionOrder = SurveyQuestion[i].QuestionOrder;
                object.validationType = SurveyQuestion[i].validationType;
                object.Disabled = SurveyQuestion[i].Disabled;
                object.hide = SurveyQuestion[i].hide;
                object.SurveyID = SurveyQuestion[i].SurveyID;
                object.SectionId = SurveyQuestion[i].SectionId;
                object.IsConditionQuestion = SurveyQuestion[i].IsConditionQuestion;
                object.ConditionSectionId = SurveyQuestion[i].ConditionSectionId;
                object.ConditionType = SurveyQuestion[i].ConditionType;
                object.ConditionValue1 = SurveyQuestion[i].ConditionValue1;
                //if (SurveyQuestion[i].IsConditionQuestion == true)
                //    object.ParentSectionId = SurveyQuestion[i].IsConditionQuestion == true ? SurveyQuestion[i].ConditionSectionId : SurveyQuestion[i].SectionId;
                object.TotCount = SurveyQuestion[i].TotCount;
                object.IsRepeatSection = SurveyQuestion[i].IsRepeatSection;
                object.RepeatSectionId = SurveyQuestion[i].RepeatSectionId;
                object.FieldVar = SurveyQuestion[i].FieldVar;
                object.FormulaExpression = SurveyQuestion[i].FormulaExpression;
                object.IsFormulaQuestion = SurveyQuestion[i].IsFormulaQuestion;
                object.IsSearchable = SurveyQuestion[i].IsSearchable;
                object.DefaultValue = SurveyQuestion[i].DefaultValue;
                object.HierarchyQuestionOrder = SurveyQuestion[i].HierarchyQuestionOrder;
                object.MinValue = SurveyQuestion[i].MinValue;
                object.MaxValue = SurveyQuestion[i].MaxValue;
                object.TextLength = SurveyQuestion[i].TextLength;
                object.ErrorText = SurveyQuestion[i].ErrorText;
                object.RegEx = SurveyQuestion[i].RegEx;
                object.ValidationCondition = SurveyQuestion[i].ValidationCondition;
                object.RepeatOrder = 0;
                object.SubRepeatOrder = null;
                object.IsMandatory = SurveyQuestion[i].IsMandatory;
                if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" || object.QuestionType == "Datalist") {
                    object.Options = await this.GetQuestionOptions(SurveyQuestion[i].QuestionText, object.QuestionType)
                } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                    object.DrpDwnopt = await this.GetQuestionOptions(SurveyQuestion[i].QuestionText, object.QuestionType)
                }
                else if (object.QuestionType == "masterdb") {
                    object.DrpDwnopt = await this.GetMasterDBData(SurveyQuestion[i].HierarchyQuestionOrder, SurveyQuestion[i].DefaultValue);
                }
                object.Answers = [];

                if (object.QuestionType == "Yes/No" && object.DefaultValue != null && object.DefaultValue != undefined) {
                    object.Answers = parseInt(SurveyQuestion[i].DefaultValue);
                }
                disabledFields.forEach(item => {
                    if (item == SurveyQuestion[i].QuestionName) {
                        object.Disabled = true;
                    }
                });
                if (object.validationType === "onlySpaceAlphabet") {
                    object.pattern = "[^a-zA-Z ]";
                } else if (object.validationType === "onlyAlphabet") {
                    object.pattern = "[^a-zA-Z ]";
                } else if (object.validationType === "AlphaNumeric") {
                    object.pattern = "[^a-zA-Z0-9]";
                } else if (object.validationType === "onlyEmailId") {
                    object.pattern = "[^a-zA-Z0-9@._]";
                }
                var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
                if (genzdata != null || genzdata.length != 0) {

                    if (SurveyQuestion[i].QuestionName == "Application Date") {
                        var d = new Date();
                        object.Answers = d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + (d.getDate())).slice(-2);
                    }
                    else if (SurveyQuestion[i].QuestionName == "Name of the Applicant (Full name as in Passport)") {
                        if (typeof genzdata[0].nameinkyc != 'undefined') {
                            object.Answers = genzdata[0].nameinkyc;
                        }

                    }
                    // else if (SurveyQuestion[i].QuestionName == "ID Number") {
                    //     if (typeof genzdata[0].kycUpload['ZIMPASSPORT - IDENTITY NUMBER'] != '') {
                    //         if(genzdata[0].kycUpload['ZIMPASSPORT - IDENTITY NUMBER'] != undefined){
                    // 	    var kyc = genzdata[0].kycUpload['ZIMPASSPORT - IDENTITY NUMBER'] .toUpperCase().replace(/[^a-zA-Z0-9]/gi, '');
                    // 		kyc = kyc.split("CIT")[0];

                    // 		var regex =new RegExp("^[0-9]{8,9}[A-Za-z][0-9]{2}$");
                    //        kyc= kyc.replace(/(\d{2})(\d{6,7})(\w{1})(\d{2})/, "$1-$2-$3-$4")
                    // 		object.Answers =kyc;
                    //         }


                    //     } else {
                    //         // kyc = kyc.replace(/(\d{2})(\d{6,7})(\w{1})(\d{2})/, "$1-$2-$3-$4");
                    //         object.Answers ='';
                    //     }
                    // } 
                    else if (SurveyQuestion[i].QuestionName == "First Name") {
                        if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - NAME'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - NAME'] != undefined) {
                                // object.Answers = genzdata[0].kycUpload['ZIMPASSPORT - NATIONALITY'];
                                object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - NAME'];
                            }
                        }
                        else if (typeof genzdata[0].firstname != 'undefined') {
                            object.Answers = genzdata[0].firstname;

                        }
                    }
                    else if (SurveyQuestion[i].QuestionText == "Account Type(LiteKYCAcct)") {
                        object.Answers = 'Transactional'
                    }
                    else if (SurveyQuestion[i].QuestionText == "Account Class(Transactional)") {
                        object.Answers = 'Fresh Lite account'
                    }
                    else if (SurveyQuestion[i].QuestionName == "Customer Category" && SurveyQuestion[i].QuestionID == '92') { // lite kyc 
                        object.Answers = 'IND_MASS'
                    }
                    else if (SurveyQuestion[i].QuestionName == "Branch Name") {
                        if (typeof genzdata[0].PWAUserBranchName != 'undefined') {
                            object.Answers = genzdata[0].PWAUserBranchName;


                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Country" || SurveyQuestion[i].QuestionName == "Country") {
                        object.Answers = { "OptionValue": 'Botswana', "OptionText": 'Botswana' };
                    }

                    else if (SurveyQuestion[i].QuestionName == "Branch Code") {
                        if (typeof genzdata[0].PWAUserBranchCode != 'undefined') {
                            object.Answers = genzdata[0].PWAUserBranchCode;

                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Surname") {

                        if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - SURNAME'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - SURNAME'] != undefined) {
                                // object.Answers = genzdata[0].kycUpload['ZIMPASSPORT - NATIONALITY'];
                                object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - SURNAME'];
                            }
                        }
                        else if (typeof genzdata[0].lastName != 'undefined') {
                            object.Answers = genzdata[0].lastName;

                        }
                    } else if (SurveyQuestion[i].QuestionName == "Middle Name") {
                        if (typeof genzdata[0].middlename != 'undefined') {
                            object.Answers = genzdata[0].middlename;

                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Nationality") {
                        if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - NATIONALITY'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - NATIONALITY'] != undefined) {
                                object.Answers = { "OptionValue": genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - NATIONALITY'], "OptionText": genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - NATIONALITY'] };
                                if (object.Answers.OptionValue == 'BOTSWANA' || object.Answers.OptionValue == 'Botswana') {
                                    self.isLocalID = true;
                                }
                            }
                        } else if (genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - NATIONALITY'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - NATIONALITY'] != undefined) {
                                object.Answers = { "OptionValue": genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - NATIONALITY'], "OptionText": genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - NATIONALITY'] };
                                if (object.Answers.OptionValue == 'BOTSWANA' || object.Answers.OptionValue == 'Botswana') {
                                    self.isLocalID = true;
                                }
                            }
                        }
                        else {
                            object.Answers = '';
                        }
                    }

                    else if (SurveyQuestion[i].QuestionName == "National ID Issue Country") {
                        if (self.isLocalID == true) {
                            object.Answers = { "OptionValue": 'Botswana', "OptionText": 'Botswana' };

                        } else {
                            object.Answers = "";
                        }
                    }

                    else if (SurveyQuestion[i].QuestionName == "Passport Number" || SurveyQuestion[i].QuestionName == "Passport Issue Date" || SurveyQuestion[i].QuestionName == "Passport Expiry Date" || SurveyQuestion[i].QuestionName == "Passport Issue Country") {
                        if (self.isLocalID == true) {
                            object.IsMandatory = SurveyQuestion[i].IsMandatory = 0;
                            object.Disabled = SurveyQuestion[i].Disabled = true;
                            object.headingExtra = SurveyQuestion[i].hide = true;

                        } else {
                            object.IsMandatory = SurveyQuestion[i].IsMandatory = 1;
                            object.Disabled = SurveyQuestion[i].Disabled = false;
                            object.hide = SurveyQuestion[i].hide = false;
                        }
                    }

                    // else if (SurveyQuestion[i].QuestionName == "Occupation"){
                    //     if (typeof genzdata[0].kycUpload['ZIMPASSPORT - PROFESSION'] != ''){
                    //         if(genzdata[0].kycUpload['ZIMPASSPORT - PROFESSION'] != undefined){
                    //         if(occupation.find(option => option.OptionValue === genzdata[0].kycUpload['ZIMPASSPORT - PROFESSION'])){
                    //             object.Answers = { "OptionValue": genzdata[0].kycUpload['ZIMPASSPORT - NATIONALITY'], "OptionText": genzdata[0].kycUpload['ZIMPASSPORT - NATIONALITY'] }; 
                    //             }   
                    //         } else {
                    //             object.Answers = { "OptionValue": "OTHERS", "OptionText": "OTHERS" }; 
                    //         }

                    //     } else {
                    //         object.Answers = '';
                    //     }

                    // }
                    else if (SurveyQuestion[i].QuestionName == "Date of Birth") {
                        // if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - BIRTH DATE'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - BIRTH DATE'] != undefined || genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - BIRTH DATE'] != '') {
                                var vadtsplit = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - BIRTH DATE'].split("/");
                                object.Answers = vadtsplit[2] + '-' + vadtsplit[0] + '-' + vadtsplit[1];
                                // object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - BIRTH DATE'];

                                // console.log("DATE ", object.Answers)
                                // object.Answers = vadtsplit
                            }
                        // }


                        // else if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'] != '') {
                            else if (genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'] != undefined || genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'] != '') {
                                var vadsplit = genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'].split("/");
                                object.Answers = vadsplit[2] + '-' + vadsplit[0] + '-' + vadsplit[1];
                                // object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'];
                            }

                        // }

                        else {
                            object.Answers = '';
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "National ID Expiry Date") {
                        // if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - EXPIRY DATE'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - EXPIRY DATE'] != undefined || genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - EXPIRY DATE'] != '') {
                                vadtsplit = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - EXPIRY DATE'].split("/");
                                object.Answers = vadtsplit[2] + '-' + vadtsplit[0] + '-' + vadtsplit[1];
                                // object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - EXPIRY DATE']
                            }
                        // }


                        // else if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'] != '') {
                            else if (genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'] != undefined || genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'] != '') {
                                vadtsplit = genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'].split("/");
                                object.Answers = vadtsplit[0] + '-' + vadtsplit[1] + '-' + vadtsplit[2];
                                // object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH DATE'];
                            }

                        // }

                        else {
                            object.Answers = '';
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Place of Birth") {
                        // if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH PLACE'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH PLACE'] != undefined) {
                                object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - BIRTH PLACE'];
                               
                            }
                        // }



                        else {
                            object.Answers = '';
                        }
                    }


                    else if (SurveyQuestion[i].QuestionName == "National ID Number") {
                        // if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - ID'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - ID'] != undefined) {
                                // var vadtsplit = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - ID'].split("/");
                                // object.Answers = vadtsplit[2] + '-' + vadtsplit[1] + '-' + vadtsplit[0];
                                object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - ID'];
                            }
                        // }
                        // else if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - ID'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - ID'] != undefined) {
                                // var vadtsplit = genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - ID'].split("/");
                                // object.Answers = vadtsplit[2] + '-' + vadtsplit[1] + '-' + vadtsplit[0];
                                object.Answers = genzdata[0].kycUpload['BOTSWANANATIONALIDFRONT - ID'];
                            }
                        // }

                        else {
                            object.Answers = '';
                        }
                    }


                    else if (SurveyQuestion[i].QuestionName == "Gender") {
                        // if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - SEX'] != '') {
                            if (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - SEX'] != undefined) {

                                switch (genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - SEX']) {
                                    case "M":
                                        object.Answers = { "OptionValue": "Male", "OptionText": "Male" };
                                        break;
                                    case "F":
                                        object.Answers = { "OptionValue": "Female", "OptionText": "Female" };
                                        break;
                                }
                            }
                        // }
                    }

                    else if (SurveyQuestion[i].QuestionName == 'Account Currency') {
                        if (SurveyQuestion[i].QuestionID == '52') {
                            // object.Answers = { "OptionValue": "Botswana Pula", "OptionText": "Botswana Pula" };
                            object.Disabled = SurveyQuestion[i].Disabled = false;
                        }
                        else if (SurveyQuestion[i].QuestionID == '113') {
                            object.Answers = "Botswana Pula";
                            object.Disabled = SurveyQuestion[i].Disabled = true;
                            object.hide = SurveyQuestion[i].hide = true;
                        }
                    }


                    else if (SurveyQuestion[i].QuestionName == "Place of Origin") {
                        if (typeof genzdata[0].placeoforigininkyc != 'undefined') {
                            object.Answers = genzdata[0].placeoforigininkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Father's name (Mandatory, if customer does not have PAN)") {
                        if (typeof genzdata[0].fathernameinkyc != 'undefined') {
                            object.Answers = genzdata[0].fathernameinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "PAN") {
                        if (typeof genzdata[0].pannoinkyc != 'undefined') {
                            object.Answers = genzdata[0].pannoinkyc;
                        }
                    }
                    // else if (SurveyQuestion[i].QuestionName == "Passport Number") {
                    //     if (typeof genzdata[0].passportnoinkyc != 'undefined') {
                    //         object.Answers[0] = genzdata[0].passportnoinkyc;
                    //     }
                    // }
                    else if (SurveyQuestion[i].QuestionName == "Date of Expiry") {
                        if (typeof genzdata[0].passportdateexpiryinkyc != 'undefined') {
                            vadtsplit = genzdata[0].passportdateexpiryinkyc.split("/");
                            object.Answers[0] = vadtsplit[2] + '-' + vadtsplit[1] + '-' + vadtsplit[0];
                        }
                    }

                    // else if (SurveyQuestion[i].QuestionName == "National ID Expiry Date") {
                    //     if (typeof genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - EXPIRY DATE'] != '') {


                    //         object.Answers[0] = genzdata[0].kycUpload['BOTSWANANATIONALIDBACK - EXPIRY DATE'];
                    //     }

                    //     else {
                    //         object.Answers = '';
                    //     }
                    // }
                    else if (SurveyQuestion[i].QuestionName == "Aadhar Number") {
                        if (typeof genzdata[0].aadharnoinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].aadharnoinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Primary Mobile Number") {
                        if (typeof genzdata[0].mobilenumber != 'undefined') {
                            object.Answers = genzdata[0].mobilenumber;
                            object.Disabled = SurveyQuestion[i].Disabled = true;
                            // object.hide  = SurveyQuestion[i].hide = true;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Primary Mobile Number[Country code]") {
                        if (typeof genzdata[0].isdcode != 'undefined') {
                            object.Answers = { "OptionValue": genzdata[0].isdcode, "OptionText": genzdata[0].isdcode };
                            object.Disabled = SurveyQuestion[i].Disabled = true;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Email ID") {
                        if (typeof genzdata[0].email != 'undefined') {
                            object.Answers[0] = genzdata[0].email;
                            if (object.Answers[0] == "") {
                                object.Disabled = SurveyQuestion[i].Disabled = false;
                            }
                            else {
                                object.Disabled = SurveyQuestion[i].Disabled = true;
                            }
                        }
                    } else if (SurveyQuestion[i].QuestionName == "Mobile Number[Country code]") {
                        if (typeof genzdata[0].isdcode != 'undefined') {
                            object.Answers = ({ "OptionValue": genzdata[0].isdcode, "OptionText": genzdata[0].isdcode });
                        }
                    } else if (SurveyQuestion[i].QuestionName == "Employer Phone number[Country Code]") {
                        object.Answers = ({ "OptionValue": "+263", "OptionText": "+263" });
                    } else if (SurveyQuestion[i].QuestionName == "Kin Phone number[Country Code]") {
                        object.Answers = ({ "OptionValue": "+263", "OptionText": "+263" });
                    } else if (SurveyQuestion[i].QuestionName == "Gross salary currency type" || SurveyQuestion[i].QuestionName == "Net salary currency type") {
                        object.Answers = ({ "OptionValue": "ZWL", "OptionText": "ZWL" });
                    }
                    else if (SurveyQuestion[i].QuestionName == "Date") {
                        d = new Date();
                        object.Answers[0] = d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + (d.getDate() + 1)).slice(-2);
                    }
                    else if (SurveyQuestion[i].QuestionName == "GSTIN Number") {
                        if (typeof genzdata[0].gstnnoinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].gstnnoinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "GST Name") {
                        if (typeof genzdata[0].gstnameinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].gstnameinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "GST Address") {
                        if (typeof genzdata[0].gstaddressinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].gstaddressinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Address As Mentioned In Your Officially Valid Document") {
                        if (typeof genzdata[0].passportaddressinkyc != 'undefined') {
                            object.Answers = genzdata[0].passportaddressinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Communication Residence Address") {
                        if (typeof genzdata[0].passportaddressinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].passportaddressinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Entity Name") {
                        if (typeof genzdata[0].companypanentitynameinkyc != 'undefined' || typeof genzdata[0].indiaitrentitynameinkyc != 'undefined') {
                            if (typeof genzdata[0].companypanentitynameinkyc != 'undefined') {
                                object.Answers[0] = genzdata[0].companypanentitynameinkyc;
                            }
                            else {
                                object.Answers[0] = genzdata[0].indiaitrentitynameinkyc;
                            }
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Company PAN") {
                        if (typeof genzdata[0].companypannoinkyc != 'undefined' || typeof genzdata[0].itrcompanypninkyc != 'undefined') {
                            if (typeof genzdata[0].companypannoinkyc != 'undefined') {
                                object.Answers[0] = genzdata[0].companypannoinkyc;
                            }
                            else {
                                object.Answers[0] = genzdata[0].itrcompanypninkyc;
                            }
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Date of Incorporation") {
                        if (typeof genzdata[0].dateofincorporationinkyc != 'undefined') {
                            vadtsplit = genzdata[0].dateofincorporationinkyc.split("/");
                            object.Answers[0] = vadtsplit[2] + '-' + vadtsplit[1] + '-' + vadtsplit[0];
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Communication City" || SurveyQuestion[i].QuestionName == "Communication District" || SurveyQuestion[i].QuestionName == "Business City" || SurveyQuestion[i].QuestionName == "Business District") {
                        if (typeof genzdata[0].towncitydistrictinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].towncitydistrictinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Communication State" || SurveyQuestion[i].QuestionName == "Business State") {
                        if (typeof genzdata[0].itrpanstateinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].itrpanstateinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Communication Pin Code" || SurveyQuestion[i].QuestionName == "Business Pin Code") {
                        if (typeof genzdata[0].pinzipcodeinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].pinzipcodeinkyc;
                        }
                    }
                    else if (SurveyQuestion[i].QuestionName == "Communication Address" || SurveyQuestion[i].QuestionName == "Business Address") {
                        if (typeof genzdata[0].nameofvillageinkyc != 'undefined') {
                            object.Answers[0] = genzdata[0].nameofvillageinkyc;
                        }
                    }
                }

                object.FileName = "";
                object.longitude = "";
                object.latitude = "";
                object.OrginalFileName = "";
                object.Blob = [];
                SurveySectionList.push(object);
            }

            return SurveySectionList;
        },
        async GetQuestionOptions(QuestionText, QuestionType) {
            var Options = [];
            var DrpDwnopt = [];

            const QuestionOptions = await db.TbQuestionOptions.where("QuestionID").equals(QuestionText).toArray();

            for (var i = 0; i < QuestionOptions.length; i++) {
                switch (QuestionType) {
                    case "CheckBox":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for (var j = 0; j < QuestionOptions.length; j++) {
                                var obj = new Object();
                                obj.OptionValue = QuestionOptions[j].OptionValue;
                                obj.OptionText = QuestionOptions[j].OptionText;
                                Options.push(obj);
                            }
                            return Options;

                        }
                        break;
                    case "Datalist":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for (j = 0; j < QuestionOptions.length; j++) {
                                DrpDwnopt.push({ "OptionValue": QuestionOptions[j].OptionValue, "OptionText": QuestionOptions[j].OptionText });
                            }
                            return DrpDwnopt;
                        }
                        break;
                    case "Dropdown":
                        
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for (j = 0; j < QuestionOptions.length; j++) {
                                DrpDwnopt.push({ "OptionValue": QuestionOptions[j].OptionValue, "OptionText": QuestionOptions[j].OptionText });
                            }
                            return DrpDwnopt;
                        }
                        break;
                    case "Radio":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for ( j = 0; j < QuestionOptions.length; j++) {
                                 obj = new Object();
                                obj.OptionValue = QuestionOptions[j].OptionValue;
                                obj.OptionText = QuestionOptions[j].OptionText;
                                Options.push(obj);
                            }
                            return Options;
                        }
                        break;

                    case "ConditionalDropdown":
                        if (QuestionOptions != null && QuestionOptions.length > 0) {
                            for ( j = 0; j < QuestionOptions.length; j++) {
                                DrpDwnopt.push({ "OptionValue": QuestionOptions[j].OptionValue, "OptionText": QuestionOptions[j].OptionText });
                            }
                            return DrpDwnopt;
                        }
                        break;
                }
            }

            if (QuestionType == "Yes/No") {
                for (j = 1; j <= 2; j++) {
                    obj = new Object();
                    obj.OptionValue = j;
                    obj.OptionText = (j == 1 ? "Yes" : "No");
                    Options.push(obj);
                }
                return Options;

            }

            return null;
        },
        async GetMasterDBData(HierarchyQuestionOrder, DefaultValue) {

            var DrpDwnopt = [];
            var tableName = DefaultValue;
            var TableValue = [];
            if (HierarchyQuestionOrder.includes("0")) {
                TableValue = await db.TbMasterTable.where("TableName").equals(tableName).toArray();

                if (TableValue.length > 0) {
                    TableValue.sort((a, b) => (a.ItemName > b.ItemName) ? 1 : -1);
                }
                for (var index = 0; index < TableValue.length; index++) {
                    DrpDwnopt.push({ "OptionValue": TableValue[index].ItemId, "OptionText": TableValue[index].ItemName });
                }
                return DrpDwnopt;
            }
            return DrpDwnopt;
        },
        async GetGPSLocation(QuestionID, RepeatOrder = 0) {

            if (navigator.geolocation) {
                var gpslocation = "";
                navigator.geolocation.getCurrentPosition(position => {
                    gpslocation = position.coords;
                    if (gpslocation == null || gpslocation == "") {
                        alert("Google Location Service Is Disabled. Please turn on the GPS.");
                        return false;
                    }
                    else {
                        if (gpslocation.longitude != "" && gpslocation.latitude != "" && gpslocation.longitude != undefined && gpslocation.latitude != undefined) {

                            if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                                var currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == RepeatOrder);
                                if (currentqst != null && currentqst.length > 0) {
                                    currentqst[0].latitude = gpslocation.longitude;
                                    currentqst[0].longitude = gpslocation.latitude;
                                    currentqst[0].Answers = gpslocation.latitude + "," + gpslocation.longitude;
                                }
                            }
                        }
                    }
                })
            }
        },
        imagetoblob: async function (e, qstId, RepeatOrder = 0) {

            var actObj = this.upload;
            var arr = e.srcElement.files;
            var blobObject = new Array();
            actObj.blbImage = [];

            if (arr.length > 5) {
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "Maximum 5 files can be uploaded.";
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                return false;
            } else {
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
            }

            if (arr != null && arr.length > 0) {
                var bytes = 0;
                var imagecount = 0;
                for (var j = 0; j < arr.length; j++) {
                    bytes += arr[j].size;

                    if (!arr[j].type.includes('image')) {
                        imagecount++;
                    }
                }

                var totsize = this.$sunidhi.bytestosize(bytes);
                var splt = totsize.split(' ');

                if (splt[1] == 'GB' || splt[1] == 'TB') {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                    return false;
                }
                else if (splt[1] == 'MB' && splt[0] > 10) {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                    return false;
                } else {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
                }

                if (imagecount > 0) {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "Only Image file(s) allowed.(.jpeg,.jpg,.png,.gif etc)";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                    return false;
                } else {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
                }

                var currentqst = [];

                if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                    currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == qstId && x.RepeatOrder == RepeatOrder)
                    if (currentqst != null && currentqst.length > 0) {
                        currentqst[0].Blob = [];
                        currentqst[0].OrginalFileName = "";
                        currentqst[0].Answers = "";
                    }
                }

                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].type.includes('image')) {
                        await this.$sunidhi.FileCompress(arr[i], 600).then(function (blob) {
                            blobObject.push(blob);
                            actObj.blbImage.push(URL.createObjectURL(blob));

                            if (currentqst != null) {
                                var filename1 = (arr[i].name != null ? arr[i].name.split('.')[0] + '_' + qstId + "_" + RepeatOrder + '.' + arr[i].name.split('.')[1] : arr[i].name);
                                currentqst[0].Blob.push(blob);
                                currentqst[0].OrginalFileName = currentqst[0].OrginalFileName != "" ? currentqst[0].OrginalFileName + ',' + filename1 : filename1;
                                currentqst[0].Answers = currentqst[0].Answers != "" ? currentqst[0].Answers + ',' + filename1 : filename1;
                            }
                        });
                    }
                    else {
                        blobObject.push(arr[i]);
                        actObj.blbImage.push(window.location.origin + "/Content/assets/images/Uploaded-File-Image.png");
                    }
                }
            }
        },

        // captureDocs: async function(e,questID,QuestionRepeatOrder) {
        //     debugger

        //     var mediaSupport = 'mediaDevices' in navigator;
        //     let videoObj;

        //     var self = this;
        //     self.isModalVisible = true;
        //     var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        //     if (!isMobile) {
        //         videoObj = {
        //             facingMode: 'user',
        //             width: 320,
        //             height: 240
        //         };
        //     } else {
        //         videoObj = {
        //             facingMode: {
        //                 exact: 'environment'
        //             },
        //             width: 240,
        //             height: 320
        //         };
        //     }
        //     let constraintObj = {
        //         audio: false,
        //         video: videoObj
        //     };

        //     if (mediaSupport && null == cameraStream) {
        //         navigator.mediaDevices.getUserMedia(constraintObj)
        //             .then(function (mediaStream) {
        //                 cameraStream = mediaStream;
        //                 let trackStream = document.getElementById('track');
        //                 if ("srcObject" in trackStream) {
        //                     trackStream.srcObject = mediaStream;
        //                 } else {
        //                     //old version
        //                     trackStream.src = window.URL.createObjectURL(mediaStream);
        //                 }
        //                 trackStream.onloadedmetadata = function () {
        //                     //show in the video element what is being captured by the webcam
        //                     trackStream.play();
        //                 };
        //                 console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
        //                 console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);
        //             })
        //             .catch(function (err) {
        //                 console.log("Unable to access camera: " + err);
        //             });
        //     } else {
        //         alert('Your browser does not support media devices.');
        //         return;
        //     }
        // },

        // eslint-disable-next-line no-unused-vars
        async captureDocs(e, questID, QuestionRepeatOrder) {
            // debugger
            this.nationalidfrontModal = true;
            this.nationalidBackModal = false;
            this.isModalVisible = true;
            var mediaSupport = 'mediaDevices' in navigator;
            let videoObj;

            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (!isMobile) {
                videoObj = {
                    facingMode: 'user',
                    width: 320,
                    height: 240
                };
            } else {
                videoObj = {
                    facingMode: {
                        exact: 'environment'
                    },
                    width: 240,
                    height: 320
                };
            }
            let constraintObj = {
                audio: false,
                video: videoObj
            };

            if (mediaSupport && null == cameraStream) {
                navigator.mediaDevices.getUserMedia(constraintObj)
                    .then(function (mediaStream) {
                        cameraStream = mediaStream;
                        let trackStream = document.getElementById('track');
                        if ("srcObject" in trackStream) {
                            trackStream.srcObject = mediaStream;
                        } else {
                            //old version
                            trackStream.src = window.URL.createObjectURL(mediaStream);
                        }
                        trackStream.onloadedmetadata = function () {
                            //show in the video element what is being captured by the webcam
                            trackStream.play();
                        };
                        console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
                        console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);
                        //alert("height: " + (mediaStream.getVideoTracks()[0].getSettings().height).toString());
                        //alert("width: "+ (mediaStream.getVideoTracks()[0].getSettings().width).toString());

                    })
                    .catch(function (err) {
                        console.log("Unable to access camera: " + err);
                    });
            } else {
                alert('Your browser does not support media devices.');
                return;
            }
        },

        captureTheImg: async function (e, questID, QuestionRepeatOrder) {
            // debugger


            if (null != cameraStream) {
                var track = document.getElementById("track");
                var capturedPhotoNationalID = document.getElementById("captureImage");
                var capture = document.getElementById('capture');

                let width = cameraStream.getVideoTracks()[0].getSettings().width;
                let height = cameraStream.getVideoTracks()[0].getSettings().height;


                capture.height = height;
                capture.width = width;
                var ctx = capture.getContext('2d');
                // ctx.drawImage(track, 0, 0, 1400, 700, 0, 0, width, height);
                ctx.drawImage(track, 30, 35, 260, 170, 0, 0, width, height);

                capturedPhotoNationalID.src = capture.toDataURL("image/png");
                $("#captureImage").show();

                this.imgCaptureToBlob(e, questID, QuestionRepeatOrder, capturedPhotoNationalID.src);

                this.close();
            }
        },

        async capturenationalidfront() {
            // debugger
            this.nationalidfrontModal = true;
            this.nationalidBackModal = false;
            this.isModalVisible = true;
            var mediaSupport = 'mediaDevices' in navigator;
            let videoObj;

            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (!isMobile) {
                videoObj = {
                    facingMode: 'user',
                    width: 320,
                    height: 240
                };
            } else {
                videoObj = {
                    facingMode: {
                        exact: 'environment'
                    },
                    width: 240,
                    height: 320
                };
            }
            let constraintObj = {
                audio: false,
                video: videoObj
            };

            if (mediaSupport && null == cameraStream) {
                navigator.mediaDevices.getUserMedia(constraintObj)
                    .then(function (mediaStream) {
                        cameraStream = mediaStream;
                        let trackStream = document.getElementById('track');
                        if ("srcObject" in trackStream) {
                            trackStream.srcObject = mediaStream;
                        } else {
                            //old version
                            trackStream.src = window.URL.createObjectURL(mediaStream);
                        }
                        trackStream.onloadedmetadata = function () {
                            //show in the video element what is being captured by the webcam
                            trackStream.play();
                        };
                        console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
                        console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);
                        //alert("height: " + (mediaStream.getVideoTracks()[0].getSettings().height).toString());
                        //alert("width: "+ (mediaStream.getVideoTracks()[0].getSettings().width).toString());

                    })
                    .catch(function (err) {
                        console.log("Unable to access camera: " + err);
                    });
            } else {
                alert('Your browser does not support media devices.');
                return;
            }
        },

        async captureNationalIDFrontImage() {
            // debugger
            if (null != cameraStream) {
                var track = document.getElementById("track");
                var capturedPhotoNationalID = document.getElementById("capturedPhotoNationalID");
                var capture = document.getElementById("capture");

                let width = cameraStream.getVideoTracks()[0].getSettings().width;
                let height = cameraStream.getVideoTracks()[0].getSettings().height;


                capture.height = height;
                capture.width = width;
                var ctx = capture.getContext('2d');
                // ctx.drawImage(track, 0, 0, 1400, 700, 0, 0, width, height);
                ctx.drawImage(track, 30, 35, 260, 170, 0, 0, width, height);

                capturedPhotoNationalID.src = capture.toDataURL("image/png");
                $("#capturedPhotoNationalID").show();

                this.nationalidfrontModal = false;
                this.nationalIdFrontImgClicked = true;
                // if( this.nationalIdFrontImgClicked == true &&  this.nationalIdBackImgClicked == true){
                //     $('#submitDocuments').show();
                //     // this.dispNextBtn = true;
                // } else {
                //     $('#submitDocuments').hide();
                //     // this.dispNextBtn = false;
                // }

                this.close();
            }
        },

        // eslint-disable-next-line no-unused-vars
        captureResidenceProof: async function (e, questID, QuestionRepeatOrder) {
            // debugger
            this.isResidenceProofModalVisible = true;
            var mediaSupport = 'mediaDevices' in navigator;
            let videoObj;

            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (!isMobile) {
                videoObj = {
                    facingMode: 'user',
                    width: 320,
                    height: 240
                };
            } else {
                videoObj = {
                    facingMode: {
                        exact: 'environment'
                    },
                    width: 240,
                    height: 320
                };
            }
            let constraintObj = {
                audio: false,
                video: videoObj
            };

            if (mediaSupport && null == cameraStream) {
                navigator.mediaDevices.getUserMedia(constraintObj)
                    .then(function (mediaStream) {
                        cameraStream = mediaStream;
                        let trackStream = document.getElementById('track');
                        if ("srcObject" in trackStream) {
                            trackStream.srcObject = mediaStream;
                        } else {
                            //old version
                            trackStream.src = window.URL.createObjectURL(mediaStream);
                        }
                        trackStream.onloadedmetadata = function () {
                            //show in the video element what is being captured by the webcam
                            trackStream.play();
                        };
                        console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
                        console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);
                        //alert("height: " + (mediaStream.getVideoTracks()[0].getSettings().height).toString());
                        //alert("width: "+ (mediaStream.getVideoTracks()[0].getSettings().width).toString());



                    })
                    .catch(function (err) {
                        console.log("Unable to access camera: " + err);
                    });
            } else {
                alert('Your browser does not support media devices.');
                return;
            }
        },
        captureTheProofOfResidence: async function (e, questID, QuestionRepeatOrder) {
            // debugger


            if (null != cameraStream) {
                var track = document.getElementById("track");
                var capturedProofOfResidence = document.getElementById("ProofOfResidence");
                var capture = document.getElementById('captureProofOfResidence');

                let width = cameraStream.getVideoTracks()[0].getSettings().width;
                let height = cameraStream.getVideoTracks()[0].getSettings().height;


                capture.height = height;
                capture.width = width;
                var ctx = capture.getContext('2d');
                // ctx.drawImage(track, 0, 0, 1400, 700, 0, 0, width, height);
                ctx.drawImage(track, 30, 35, 260, 170, 0, 0, width, height);

                capturedProofOfResidence.src = capture.toDataURL("image/png");
                $("#ProofOfResidence").show();

                this.imgCaptureToBlob(e, questID, QuestionRepeatOrder, capturedProofOfResidence.src);

                this.closeResidenceProofModal();
            }
        },
        closeResidenceProofModal() {
            this.isResidenceProofModalVisible = false;
            if (null != cameraStream) {

                cameraStream.getTracks().forEach(function (track) {
                    track.stop();
                });
                cameraStream = null;
            }
        },

        // eslint-disable-next-line no-unused-vars
        captureUtilityBillProof: async function (e, questID, QuestionRepeatOrder) {
            // debugger
            this.isUtilityBillModalVisible = true;
            var mediaSupport = 'mediaDevices' in navigator;
            let videoObj;

            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (!isMobile) {
                videoObj = {
                    facingMode: 'user',
                    width: 320,
                    height: 240
                };
            } else {
                videoObj = {
                    facingMode: {
                        exact: 'environment'
                    },
                    width: 240,
                    height: 320
                };
            }
            let constraintObj = {
                audio: false,
                video: videoObj
            };

            if (mediaSupport && null == cameraStream) {
                navigator.mediaDevices.getUserMedia(constraintObj)
                    .then(function (mediaStream) {
                        cameraStream = mediaStream;
                        let trackStream = document.getElementById('track');
                        if ("srcObject" in trackStream) {
                            trackStream.srcObject = mediaStream;
                        } else {
                            //old version
                            trackStream.src = window.URL.createObjectURL(mediaStream);
                        }
                        trackStream.onloadedmetadata = function () {
                            //show in the video element what is being captured by the webcam
                            trackStream.play();
                        };
                        console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
                        console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);
                        //alert("height: " + (mediaStream.getVideoTracks()[0].getSettings().height).toString());
                        //alert("width: "+ (mediaStream.getVideoTracks()[0].getSettings().width).toString());



                    })
                    .catch(function (err) {
                        console.log("Unable to access camera: " + err);
                    });
            } else {
                alert('Your browser does not support media devices.');
                return;
            }
        },
        captureTheProofOfUtilityBill: async function (e, questID, QuestionRepeatOrder) {
            // debugger


            if (null != cameraStream) {
                var track = document.getElementById("track");
                var capturedProofOfUtilityBill = document.getElementById("ProofOfUtilityBill");
                var capture = document.getElementById('captureProofOfUtilityBill');

                let width = cameraStream.getVideoTracks()[0].getSettings().width;
                let height = cameraStream.getVideoTracks()[0].getSettings().height;


                capture.height = height;
                capture.width = width;
                var ctx = capture.getContext('2d');
                // ctx.drawImage(track, 0, 0, 1400, 700, 0, 0, width, height);
                ctx.drawImage(track, 30, 35, 260, 170, 0, 0, width, height);

                capturedProofOfUtilityBill.src = capture.toDataURL("image/png");
                $("#ProofOfUtilityBill").show();

                this.imgCaptureToBlob(e, questID, QuestionRepeatOrder, capturedProofOfUtilityBill.src);

                this.closeUtilityBillProofModal();
            }
        },

        closeUtilityBillProofModal() {
            this.isUtilityBillModalVisible = false;
            if (null != cameraStream) {

                cameraStream.getTracks().forEach(function (track) {
                    track.stop();
                });
                cameraStream = null;
            }
        },

        // eslint-disable-next-line no-unused-vars
        captureSourceOfFundsProof: async function (e, questID, QuestionRepeatOrder) {
            // debugger
            this.isSourceOfFundsModalVisible = true;
            var mediaSupport = 'mediaDevices' in navigator;
            let videoObj;

            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (!isMobile) {
                videoObj = {
                    facingMode: 'user',
                    width: 320,
                    height: 240
                };
            } else {
                videoObj = {
                    facingMode: {
                        exact: 'environment'
                    },
                    width: 240,
                    height: 320
                };
            }
            let constraintObj = {
                audio: false,
                video: videoObj
            };

            if (mediaSupport && null == cameraStream) {
                navigator.mediaDevices.getUserMedia(constraintObj)
                    .then(function (mediaStream) {
                        cameraStream = mediaStream;
                        let trackStream = document.getElementById('track');
                        if ("srcObject" in trackStream) {
                            trackStream.srcObject = mediaStream;
                        } else {
                            //old version
                            trackStream.src = window.URL.createObjectURL(mediaStream);
                        }
                        trackStream.onloadedmetadata = function () {
                            //show in the video element what is being captured by the webcam
                            trackStream.play();
                        };
                        console.log("height: ", mediaStream.getVideoTracks()[0].getSettings().height);
                        console.log("width: ", mediaStream.getVideoTracks()[0].getSettings().width);
                        //alert("height: " + (mediaStream.getVideoTracks()[0].getSettings().height).toString());
                        //alert("width: "+ (mediaStream.getVideoTracks()[0].getSettings().width).toString());



                    })
                    .catch(function (err) {
                        console.log("Unable to access camera: " + err);
                    });
            } else {
                alert('Your browser does not support media devices.');
                return;
            }
        },
        captureProofForSourceOfFunds: async function (e, questID, QuestionRepeatOrder) {
            // debugger


            if (null != cameraStream) {
                var track = document.getElementById("track");
                var capturedProofForSourceOfFunds = document.getElementById("ProofForSourceOfFunds");
                var capture = document.getElementById('captureProofForSourceOfFunds');

                let width = cameraStream.getVideoTracks()[0].getSettings().width;
                let height = cameraStream.getVideoTracks()[0].getSettings().height;


                capture.height = height;
                capture.width = width;
                var ctx = capture.getContext('2d');
                // ctx.drawImage(track, 0, 0, 1400, 700, 0, 0, width, height);
                ctx.drawImage(track, 30, 35, 260, 170, 0, 0, width, height);

                capturedProofForSourceOfFunds.src = capture.toDataURL("image/png");
                $("#ProofForSourceOfFunds").show();

                this.imgCaptureToBlob(e, questID, QuestionRepeatOrder, capturedProofForSourceOfFunds.src);

                this.closeSourceOfFundsModal();
            }
        },

        closeSourceOfFundsModal() {
            this.isSourceOfFundsModalVisible = false;
            if (null != cameraStream) {

                cameraStream.getTracks().forEach(function (track) {
                    track.stop();
                });
                cameraStream = null;
            }
        },

        close() {
            this.isModalVisible = false;
            if (null != cameraStream) {

                cameraStream.getTracks().forEach(function (track) {
                    track.stop();
                });
                cameraStream = null;
            }
        },


        imgCaptureToBlob: async function (e, qstId, RepeatOrder = 0, base64) {
            // debugger
            var actObj = this.upload;
            var FileblobObject = new Array();

            actObj.FileName = [];
            actObj.blbFile = [];
            var currentqst = [];

            if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == qstId && x.RepeatOrder == RepeatOrder)
                if (currentqst != null && currentqst.length > 0) {
                    currentqst[0].Blob = [];
                    currentqst[0].OrginalFileName = "";
                    currentqst[0].Answers = "";
                }


            }

            // eslint-disable-next-line no-unused-vars
            var fileReader = new FileReader();
            // var base64 = "";
            // Onload of file read the file content
            //  fileReader.onload = function (fileLoadedEvent) {
            // base64 = fileLoadedEvent.target.result;
            // for (var i = 0; i < arr.length; i++) {
            // if (arr[i].type.includes('application')) {

            var blob = this.$sunidhi.dataURLToBlob(base64);
            FileblobObject.push(blob);
            actObj.blbFile.push(URL.createObjectURL(blob));
            // actObj.FileName.push(arr[i].name);

            if (currentqst != null) {
                // var filename1 = (arr[i].name != null ? arr[i].name.split('.')[0] + '_' + qstId + "_" + RepeatOrder + '.' + arr[i].name.split('.')[1] : arr[i].name);
                currentqst[0].Blob.push(blob);
                // currentqst[0].OrginalFileName = currentqst[0].OrginalFileName != "" ? currentqst[0].OrginalFileName + ',' + filename1 : filename1;
                currentqst[0].Answers = currentqst[0].Blob;

            }
            // }
            // else {
            //     blobObject.push(arr[i]);
            //     actObj.blbFile.push(window.location.origin + "/Content/assets/images/Uploaded-File-Image.png");
            // }
            // }
            // };
            // Convert data to base64
            // fileReader.readAsDataURL(arr[0]);
        },

        filetoblob: async function (e, qstId, RepeatOrder = 0) {
            var blobObject = new Array();
            var actObj = this.upload;
            var arr = e.srcElement.files;
            var FileblobObject = new Array();

            actObj.FileName = [];
            actObj.blbFile = [];

            if (arr.length > 5) {
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "Maximum 5 file(s) can be uploaded.";
                document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                return;
            }

            if (arr != null && arr.length > 0) {
                var bytes = 0;
                for (var j = 0; j < arr.length; j++) {
                    bytes += arr[j].size;
                }

                var totsize = this.$sunidhi.bytestosize(bytes);
                var splt = totsize.split(' ');

                if (splt[1] == 'GB' || splt[1] == 'TB') {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                    return false;
                }
                else if (splt[1] == 'MB' && splt[0] > 10) {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).textContent = "File(s) size cannot exceed 10 MB.";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "inline";
                    return false;
                } else {
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).value = "";
                    document.getElementById("lbl_" + qstId + "_" + RepeatOrder).style.display = "none";
                }

                var currentqst = [];

                if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                    currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == qstId && x.RepeatOrder == RepeatOrder)
                    if (currentqst != null && currentqst.length > 0) {
                        currentqst[0].Blob = [];
                        currentqst[0].OrginalFileName = "";
                        currentqst[0].Answers = "";
                    }
                }

                var fileReader = new FileReader();
                var base64 = "";

                // Onload of file read the file content
                fileReader.onload = function (fileLoadedEvent) {
                    base64 = fileLoadedEvent.target.result;
                    for (var i = 0; i < arr.length; i++) {
                        if (arr[i].type.includes('application')) {

                            var blob = this.$sunidhi.dataURLToBlob(base64);
                            FileblobObject.push(blob);
                            actObj.blbFile.push(URL.createObjectURL(blob));
                            actObj.FileName.push(arr[i].name);

                            if (currentqst != null) {
                                var filename1 = (arr[i].name != null ? arr[i].name.split('.')[0] + '_' + qstId + "_" + RepeatOrder + '.' + arr[i].name.split('.')[1] : arr[i].name);
                                currentqst[0].Blob.push(blob);
                                currentqst[0].OrginalFileName = currentqst[0].OrginalFileName != "" ? currentqst[0].OrginalFileName + ',' + filename1 : filename1;
                                currentqst[0].Answers = currentqst[0].Answers != "" ? currentqst[0].Answers + ',' + filename1 : filename1;
                            }
                        }
                        else {
                            blobObject.push(arr[i]);
                            actObj.blbFile.push(window.location.origin + "/Content/assets/images/Uploaded-File-Image.png");
                        }
                    }
                };
                // Convert data to base64
                fileReader.readAsDataURL(arr[0]);
            }
        },
        audiotoblob: function (e) {
            var actObj = this.upload;
            actObj.blbAudio = [];
            var AudioBlobObj = new Array();
            AudioBlobObj.push(e.blob);
            actObj.blbAudio.push(URL.createObjectURL(e.blob));

            var currentqst = [];

            if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionType == "Audio")
                if (currentqst != null && currentqst.length > 0) {
                    currentqst[0].Blob = [];
                    currentqst[0].OrginalFileName = "";
                    currentqst[0].Answers = "";
                }
            }

            currentqst[0].Blob = AudioBlobObj;
            currentqst[0].OrginalFileName = "Audio.mp3";
            currentqst[0].Answers = "Audio.mp3";
        },
//         async GetSignaturePad(QuestionID, RepeatOrder = 0) {
//       var isSaveClicked = false;
//       var saveCount = 0;
//       var blob = null;
//       var actObj = this.upload;
//       actObj.blbsignImage = [];

//       document.getElementById('btnsignaturepad_' + QuestionID + '_' + RepeatOrder).style.display = "none";
//       document.getElementById('signaturepaddiv_' + QuestionID + '_' + RepeatOrder).style.display = "inline";

//       var saveButton = document.getElementById('save_' + QuestionID + '_' + RepeatOrder);
//       var cancelButton = document.getElementById('clear_' + QuestionID + '_' + RepeatOrder);
//       var canvas = document.getElementById('signature-pad_' + QuestionID + '_' + RepeatOrder);
//       var closeButton = document.getElementById('btn-close_' + QuestionID + "_" + RepeatOrder);

//       var currentqst = [];

//       if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
//         currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == RepeatOrder);
//       }

//       // Initialize the signature pad
//       if (canvas && canvas.getContext) {
//         this.signaturePad = new SignaturePad(canvas, {
//           minWidth: 3,
//           maxWidth: 5,
//           backgroundColor: 'rgb(255, 255, 255)',
//         });
//       } else {
//         console.error('Canvas element or context not found');
//       }

//       // Event listener to clear the signature pad
//       cancelButton.addEventListener('click', () => {
//         this.signaturePad.clear();
//       });

//       // Event listener to close the signature pad
//       closeButton.addEventListener('click', () => {
//         document.getElementById('signaturepaddiv_' + QuestionID + "_" + RepeatOrder).style.display = "none";
//         document.getElementById('btnsignaturepad_' + QuestionID + "_" + RepeatOrder).style.display = "inline";
//       });

//       // Event listener to save the signature
//       saveButton.addEventListener('click', () => {
//     if (!isSaveClicked) {
//       if (this.signaturePad.isEmpty()) {
//         alert("Please provide a signature first.");
//         saveCount = 1;
//       } else {
//         var dataURL = this.signaturePad.toDataURL("image/jpeg");
//         blob = this.$sunidhi.dataURLToBlob(dataURL);
//         if (currentqst != null && currentqst.length > 0) {
//           currentqst[0].Blob = [blob];
//           currentqst[0].OrginalFileName = "Signature_" + QuestionID + "_" + RepeatOrder + ".jpeg";
//           currentqst[0].Answers = currentqst[0].OrginalFileName;

//           document.getElementById('signaturepaddiv_' + QuestionID + '_' + RepeatOrder).style.display = "none";
//           document.getElementById('btnsignaturepad_' + QuestionID + '_' + RepeatOrder).style.display = "inline";
//           if (saveCount === 0) {
//             alert("Signature successfully saved!");
//             saveCount = 1;
//           }
//         }
//       }
//     }
//   });
//     },

async GetSignaturePad(QuestionID, RepeatOrder = 0) {
  var isSaveClicked = false;
  var saveCount = 0;
//   var blob = null;
  var actObj = this.upload;
  actObj.blbsignImage = [];

  document.getElementById('btnsignaturepad_' + QuestionID + '_' + RepeatOrder).style.display = "none";
  document.getElementById('signaturepaddiv_' + QuestionID + '_' + RepeatOrder).style.display = "inline";

  var saveButton = document.getElementById('save_' + QuestionID + '_' + RepeatOrder);
  var cancelButton = document.getElementById('clear_' + QuestionID + '_' + RepeatOrder);
  var canvas = document.getElementById('signature-pad_' + QuestionID + '_' + RepeatOrder);
  var closeButton = document.getElementById('btn-close_' + QuestionID + "_" + RepeatOrder);

  var currentqst = [];

  if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
    currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == RepeatOrder);
  }

  // Initialize the signature pad
  if (canvas && canvas.getContext) {
    this.signaturePad = new SignaturePad(canvas, {
      minWidth: 3,
      maxWidth: 5,
      backgroundColor: 'rgb(255, 255, 255)',
    });
  } else {
    console.error('Canvas element or context not found');
  }

  // Clear the signature pad
  cancelButton.removeEventListener('click', this.clearSignature);
  cancelButton.addEventListener('click', this.clearSignature);

  // Close the signature pad
  closeButton.removeEventListener('click', this.closeSignaturePad);
  closeButton.addEventListener('click', this.closeSignaturePad.bind(this, QuestionID, RepeatOrder));

  // Ensure saveButton doesn't already have listeners attached multiple times
  if (!saveButton.dataset.listenerAdded) {
    saveButton.dataset.listenerAdded = true; // Set a flag to avoid multiple listeners
    saveButton.addEventListener('click', this.saveSignature.bind(this, QuestionID, RepeatOrder, isSaveClicked, saveCount, currentqst));
  }
},

clearSignature() {
    this.signaturePad.clear();
  },
  
  closeSignaturePad(QuestionID, RepeatOrder) {
    document.getElementById('signaturepaddiv_' + QuestionID + "_" + RepeatOrder).style.display = "none";
    document.getElementById('btnsignaturepad_' + QuestionID + "_" + RepeatOrder).style.display = "inline";
  },

  saveSignature(QuestionID, RepeatOrder, isSaveClicked, saveCount, currentqst) {
    if (!isSaveClicked) {
      if (this.signaturePad.isEmpty()) {
        alert("Please provide a signature first.");
        saveCount = 1;
      } else {
        var dataURL = this.signaturePad.toDataURL("image/jpeg");
        var blob = this.$sunidhi.dataURLToBlob(dataURL);
        if (currentqst != null && currentqst.length > 0) {
          currentqst[0].Blob = [blob];
          currentqst[0].OrginalFileName = "Signature_" + QuestionID + "_" + RepeatOrder + ".jpeg";
          currentqst[0].Answers = currentqst[0].OrginalFileName;

          document.getElementById('signaturepaddiv_' + QuestionID + '_' + RepeatOrder).style.display = "none";
          document.getElementById('btnsignaturepad_' + QuestionID + '_' + RepeatOrder).style.display = "inline";
          if (saveCount === 0) {
            alert("Signature successfully saved!");
            saveCount = 1;
          }
        }
      }
    }
  },


    // async GetSignaturePad() {
    //   if (!this.signaturePad) {
    //     this.initializeSignaturePad();
    //   }
    //   // Your logic to use signaturePad
    // },
        async GetOptionIfYes_No(QuestionID, ConditionValue) {

            if (this.CurrentSectionQuestions[0] != null && this.CurrentSectionQuestions[0].Questions.length > 0) {
                var currentqst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID)
                if (currentqst != null && currentqst.length > 0) {
                    currentqst[0].Answers = "";

                    var answer = 0;
                    switch (ConditionValue) {
                        case "No":
                            answer = 2;
                            break;
                        case "Yes":
                            answer = 1;
                            break;
                        default:
                            answer = currentqst[0].Answers
                    }

                    currentqst[0].Answers = answer
                }
            }

        },
        async NextSectionQuestions(surveyId, sectionOrder) {
            // debugger
            var sessionExpired = false;
            sessionExpired = await this.$sunidhi.formsSessionTimeout();
            console.log("session", sessionExpired);
            if (sessionExpired) {
                return false;
            }
            else if (!sessionExpired) {
                var errorCount = await this.ValidateCurrentForm();
                if (errorCount > 0) {
                    return false;
                }
                else {

                    for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Date of Birth') {
                            const currentDate = new Date();
                            console.log("currentDate:", currentDate);
                            // Calculate the birth date from the provided DOB
                            const birthDate = new Date(this.CurrentSectionQuestions[0].Questions[i].Answers);
                            console.log("birthDate:", birthDate)
                            // Calculate the age by subtracting the birth year from the current year
                            const age = currentDate.getFullYear() - birthDate.getFullYear();
                            console.log("age:", age)
                            // Check if the age is less than 18
                            if (age < 18) {
                                // errorcount++;
                                this.isMinor = true;
                                this.ErrorMessage = "Minimum age to open account should be greater than 18. Kindly check your DOB and Resubmit."
                                this.dialogError = true;


                            } else {
                                this.isMinor = false;
                            }

                        }
                    }

                    if (this.isMinor == false) {

                        this.SelectedSection = sectionOrder;

                        if (sectionOrder > this.SelectedSection) {
                            var ss = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 2]);
                            if (ss != null && ss.length > 0) {
                                ss[0].Questions = this.CurrentSectionQuestions[0].Questions;

                            }
                        }

                        if (this.SelectedSection == this.SurveySectionList.length) {
                            this.dispProcessBtn = true;
                        }
                        this.CurrentSectionQuestions = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 1]);
                    }
                }
            }
        },
        async PreviousSectionQuestions(surveyId, sectionOrder) {
            // debugger
            if (this.SelectedSection == 1) {
                this.ActiveAddQuestPopup = false;

            } else {
                if (this.isResidenceProofModalVisible || this.isUtilityBillModalVisible || this.isSourceOfFundsModalVisible || this.isModalVisible) {
                    //if any camera is open close the camera
                    this.isResidenceProofModalVisible = false;
                    this.isUtilityBillModalVisible = false;
                    this.isSourceOfFundsModalVisible = false;
                    this.isModalVisible = false;
                    if (null != cameraStream) {
                        cameraStream.getTracks().forEach(function (track) {
                            track.stop();
                        });
                        cameraStream = null;
                    }
                }
                var errorCount = await this.ValidateCurrentFormToRemoveError();
                if (errorCount > 0) {
                    return true;
                }
                // else {

                this.dispProcessBtn = false;
                this.SelectedSection = sectionOrder;

                if (sectionOrder > this.SelectedSection) {
                    var ss = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 2]);
                    if (ss != null && ss.length > 0) {
                        ss[0].Questions = this.CurrentSectionQuestions[0].Questions;

                    }
                }
                // this.CurrentSectionQuestions = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 1]);
                this.CurrentSectionQuestions = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[sectionOrder - 1]);
                // await this.removeValidation();
                setTimeout(() => {
                    // eslint-disable-next-line no-unused-vars
                    this.CurrentSectionQuestions[0].Questions.forEach(item => {
                        
                    });
                    $("input[type='date']").keydown(function (event) { event.preventDefault(); });
                }, 0);
            }
        },
        async ValidateCurrentFormToRemoveError() {
            // debugger
            var QstList = this.CurrentSectionQuestions[0].Questions;
            var errorcount = 0;

            for (var i = 0; i < QstList.length; i++) {
                var item = QstList[i];
                var ageval = 0;
                switch (item.QuestionType) {
                    case "CheckBox":
                        if (item.IsMandatory) {


                            if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                                (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                                var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Dropdown":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        break;
                    case "ConditionalDropdown":
                        // if (item.IsMandatory && item.QuestionName == msgLBL.BOK_FORM_PAGE_DUAL_CITIZENSHIP_MSG && this.dispDualCitizen == true) {
                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {

                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }
                        // }

                        break;
                    case "Radio":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined" || item.Answers == 0) || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            } else if (item.Answers == "Yes" || item.Answers == "No") {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined" || item.Answers != 0)) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        break;
                    case "Number":

                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers != null && item.Answers != "" && item.Answers.length != 0 || (item.QuestionID == 36)) {
                            if (item.MinValue > 0 || item.MaxValue > 0) {
                                if (item.Answers != "" && item.Answers != 0) {
                                    if (item.Answers < item.MinValue || item.Answers > item.MaxValue) {
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    } else {
                                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && (item.Answers != null && item.Answers != "" && item.Answers.length != 0)) {
                                            var regex = new RegExp(item.RegEx);

                                            if (!(regex.test(item.Answers))) {
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                            }
                                        }
                                    }
                                }
                            }

                            if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                                ((item.Answers != null || item.Answers != "" || item.Answers.length != "undefined") || item.Answers.length != 0) && ageval == 0) {
                                result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                                if (!result) {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            }
                        }
                        break;
                    case "Text":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        break;
                    case "ConditionalText":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }


                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                        result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "EmpConditionalText":
                        if (item.IsMandatory && this.dispEmpName == true) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {

                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Date":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "IssuanceDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ExpiryDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;

                    case "Yes/No":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined")) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Image":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "CaptureImage":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Audio":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Sign":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "GPS":
                        if (item.IsMandatory) {
                            if (item.latitude.length == 0 || item.longitude.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "masterdb":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    // default:
                    // code block
                }
            }


            return errorcount;
        },
        // eslint-disable-next-line no-unused-vars
        async GetHierarchyDrpdwn(QuestionID, SurveyId) {

            var ParentDrpdwnValue = [];
            ParentDrpdwnValue = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);
            if (ParentDrpdwnValue.length == 0) {
                // datap
                ParentDrpdwnValue = this.SurveyQuestionList[0].Questions.filter(x => x.optionIfYes.length > 0);
                ParentDrpdwnValue = ParentDrpdwnValue[0].optionIfYes[0].IfYesQuestions.filter(x => x.QuestionID == QuestionID);
            }

            var HierarchyQuestionOrder = ParentDrpdwnValue[0].HierarchyQuestionOrder.split(';')[0] + ';' + (parseInt(ParentDrpdwnValue[0].HierarchyQuestionOrder.split(';')[1]) + 1);
            //var DependentQuestion = await db.TbSurveyQuestions.where("SurveyID").equals(SurveyId).toArray();
            var DependentQuestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.HierarchyQuestionOrder == HierarchyQuestionOrder);

            if (DependentQuestion.length > 0) {
                var heirarchy1 = HierarchyQuestionOrder;
                var DependentQuestion1 = this.CurrentSectionQuestions[0];
                var k = 1;

                while (k > 0) {
                    // eslint-disable-next-line no-redeclare
                    var DependentQuestion1 = this.CurrentSectionQuestions[0];
                    if (DependentQuestion1 != null && DependentQuestion1.Questions.length > 0) {
                        var DependentQuestion2 = DependentQuestion1.Questions.filter(x => x.HierarchyQuestionOrder == heirarchy1);

                        if (DependentQuestion2.length == 0) {
                            k = 0;
                        }

                        if (DependentQuestion2.length > 0) {
                            for (var j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                                if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == DependentQuestion2[0].QuestionID) {
                                    this.CurrentSectionQuestions[0].Questions[j].Answers = [];
                                    this.CurrentSectionQuestions[0].Questions[j].DrpDwnopt = [];
                                }
                            }
                        }
                    }

                    heirarchy1 = heirarchy1.split(';')[0] + ';' + (parseInt(heirarchy1.split(';')[1]) + 1);
                }
            }

            if (DependentQuestion.length > 0) {
                // if (DependentQuestion[0].QuestionType == "masterdb") {

                //     var tableName = DependentQuestion[0].DefaultValue;
                //     var TableValue = [];
                //     TableValue = await db.TbMasterTable.where("TableName").equals(tableName).toArray();
                //     TableValue = TableValue.filter(x => x.ItemParentId == ParentDrpdwnValue[0].Answers.OptionValue);

                //     if (TableValue.length > 0) {
                //         TableValue.sort((a, b) => (a.ItemName > b.ItemName) ? 1 : -1);
                //     }
                //     DrpDwnopt = [];
                //     for (var index = 0; index < TableValue.length; index++) {
                //         DrpDwnopt.push({ "OptionValue": TableValue[index].ItemId, "OptionText": TableValue[index].ItemName });
                //     }

                //     for (var j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                //         if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == DependentQuestion[0].QuestionID) {
                //             this.CurrentSectionQuestions[0].Questions[j].Answers = [];
                //             this.CurrentSectionQuestions[0].Questions[j].DrpDwnopt = DrpDwnopt;
                //         }
                //     }
                // }
            }
        },
        // eslint-disable-next-line no-unused-vars
        async AppendSection(QuestionID, QuestionType, IsConditionQuestion, answer = "", IsRepeatSection = false, repeatOrder = 0) {
            var ConditionSectionId = 0;
            var ConditionType = 0;
            // eslint-disable-next-line no-unused-vars
            var ConditionValue = "";
            var CurrentAnswer = "";
            var ConditionMatch = false;
            // var ConditionSectionQuestions = "";
            // var surveyId = 0
            var custCategory = [];

            // to replace variabel name in Question
            var cntQuestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);




            // if(cntQuestion[0].QuestionText == "Account Type"){
            //     if(cntQuestion[0].Answers.OptionValue != ''){
            //         console.log(AccountType);
            //     }
            // }
            if (cntQuestion != null && cntQuestion.length > 0) {
                if (cntQuestion[0].FieldVar != null && cntQuestion[0].FieldVar.length > 0) {
                    var field_var = cntQuestion[0].FieldVar;
                    var answer1 = cntQuestion[0].Answers;

                    for (var n = 0; n < this.SurveySectionList.length; n++) {
                        for (var p = 0; p < this.SurveySectionList[n].Questions.length; p++) {
                            if (this.SurveySectionList[n].Questions[p].QuestionName.includes(field_var)) {
                                this.SurveySectionList[n].Questions[p].QuestionName = this.SurveySectionList[n].Questions[p].QuestionName.replace(field_var, answer1);
                            }
                        }
                    }
                }
            }


            if (IsConditionQuestion) {

                var qst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID);

                if (qst != null && qst.length > 0) {
                    ConditionSectionId = qst[0].ConditionSectionId;
                    ConditionType = qst[0].ConditionType; //">=";//
                    // ConditionValue = qst[0].ConditionValue1; 
                    surveyId = qst[0].SurveyID;

                    var CurrentQuestionList = this.CurrentSectionQuestions[0].Questions;

                    //if (repeatOrder == 0) {
                    //    var removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId != ConditionSectionId);
                    //    this.CurrentSectionQuestions[0].Questions = removedConditionquestion;
                    //}


                    switch (QuestionType) {
                        case "CheckBox":

                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                for (var i = 0; i < qst[0].Answers.length; i++) {
                                    var QuestionOption = qst[0].Options.filter(x => x.OptionValue == qst[0].Answers[i]);
                                    if (QuestionOption != null && QuestionOption.length > 0) {
                                        CurrentAnswer = QuestionOption[0].OptionText;
                                        if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                            ConditionMatch = true;
                                            break;
                                        }
                                    }
                                }
                            }
                            break;
                        case "Dropdown":
                            CurrentAnswer = qst[0].Answers.OptionText;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Radio":
                            if (eval("answer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Number":

                            CurrentAnswer = parseInt(qst[0].Answers);
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Text":
                            CurrentAnswer = qst[0].Answers;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                           
                            break;
                        case "MultiLineText":
                            CurrentAnswer = qst[0].Answers;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Datalist":
                            CurrentAnswer = qst[0].Answers.OptionText;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;
                        case "Date":
                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                var spDate = qst[0].Answers.split("-");
                                CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                            }
                            break;
                        case "Yes/No":
                            if (eval("answer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;

                        case "ConditionalDropdown":
                            CurrentAnswer = qst[0].Answers.OptionText;
                            if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                ConditionMatch = true;
                            }
                            break;

                        case "IssuanceDate":
                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                spDate = qst[0].Answers.split("-");
                                CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                            }
                            break;
                        case "ExpiryDate":
                            if (qst[0].Answers != null && qst[0].Answers.length > 0) {
                                spDate = qst[0].Answers.split("-");
                                // eslint-disable-next-line no-unused-vars
                                CurrentAnswer = spDate[2] + "-" + spDate[1] + "-" + spDate[0];
                                if (eval("CurrentAnswer" + ConditionType + "ConditionValue")) {
                                    ConditionMatch = true;
                                }
                            }
                            break;
                        // default:
                        // code block
                    }

                    if (repeatOrder == 0 && !ConditionMatch) {
                        var removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId != ConditionSectionId);

                        var array = [];
                        var array1 = [];
                        var array2 = [];

                        var dd = this.SurveySectionList.filter(x => x.SectionId == ConditionSectionId);
                        var rpt4 = dd;


                        if (dd != null && dd.length > 0) {
                            dd = dd[0].Questions.filter(x => x.IsConditionQuestion == true);
                            for (var j = 0; j < dd.length; j++) {
                                array.push(dd[j].ConditionSectionId);
                                array2.push(dd[j].ConditionSectionId);
                                //Array.prototype.push.apply(array, dd[j].ConditionSectionId);
                            }

                            if (array != null && array.length > 0) {
                                // eslint-disable-next-line no-redeclare
                                for (var j = 0; j < array.length; j++) {
                                    var id = parseInt(array[j]);
                                    var kl = this.SurveySectionList.filter(x => x.SectionId == id);

                                    if (kl != null && kl.length > 0) {
                                        kl = kl[0].Questions.filter(x => x.IsConditionQuestion == true);

                                        for (var m = 0; m < kl.length; m++) {
                                            array1.push(kl[m].ConditionSectionId);
                                            array2.push(kl[m].ConditionSectionId);
                                        }
                                    }
                                }
                            }

                            if (array1 != null && array1.length > 0) {
                                for ( j = 0; j < array1.length; j++) {

                                    id = parseInt(array1[j]);
                                    kl = this.SurveySectionList.filter(x => x.SectionId == id);

                                    if (kl != null && kl.length > 0) {
                                        kl = kl[0].Questions.filter(x => x.IsConditionQuestion == true);

                                        for (m = 0; m < kl.length; m++) {
                                            array2.push(kl[m].ConditionSectionId);
                                        }
                                    }
                                }
                            }
                        }

                        if (array2 != null && array2.length > 0) {
                            for (var k = 0; k < array2.length; k++) {
                                id = parseInt(array2[k]);
                                removedConditionquestion = removedConditionquestion.filter(x => x.SectionId != id);
                            }
                        }

                        if (rpt4 != null && rpt4.length > 0) {
                            rpt4 = rpt4[0].Questions.filter(x => x.IsRepeatSection == true);
                            var repSectionId = 0;
                            if (rpt4 != null && rpt4.length > 0) {
                                repSectionId = rpt4[0].RepeatSectionId;
                                removedConditionquestion = removedConditionquestion.filter(x => x.SectionId != repSectionId);
                            }
                        }

                        this.CurrentSectionQuestions[0].Questions = removedConditionquestion;
                    }

                    if (ConditionMatch == true) {
                        var sectionQst = this.SurveySectionList.filter(x => x.SectionId == ConditionSectionId);

                        var curentsectionQuestions = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == ConditionSectionId && x.RepeatOrder == repeatOrder);

                        if (sectionQst != null && sectionQst.length > 0 && curentsectionQuestions.length == 0) {

                            var position = 0;
                            // eslint-disable-next-line no-redeclare
                            for (var j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                                if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == QuestionID && this.CurrentSectionQuestions[0].Questions[j].RepeatOrder == repeatOrder) {
                                    position = j;
                                    break;
                                }
                            }

                            position = position + 1;
                            var SectionHead = await this.GetConditionHead(ConditionSectionId, surveyId, repeatOrder);
                            this.CurrentSectionQuestions[0].Questions.splice(position, 0, SectionHead);

                            //for (var k = 0; k < sectionQst[0].Questions.length; k++) {
                            //    debugger;
                            //    sectionQst[0].Questions[k].RepeatOrder = repeatOrder;
                            //    debugger;
                            //    this.CurrentSectionQuestions[0].Questions.splice(position + k + 2, 0, sectionQst[0].Questions[k]);
                            //}

                            for (i = 0; i < sectionQst[0].Questions.length; i++) {
                                position = position + 1;
                                var object = new Object();
                                object.QuestionID = sectionQst[0].Questions[i].QuestionID;
                                object.QuestionName = sectionQst[0].Questions[i].QuestionName;
                                object.QuestionType = sectionQst[0].Questions[i].QuestionType;
                                object.QuestionOrder = sectionQst[0].Questions[i].QuestionOrder;
                                object.SurveyID = sectionQst[0].Questions[i].SurveyID;
                                object.SectionId = sectionQst[0].Questions[i].SectionId;
                                object.IsConditionQuestion = sectionQst[0].Questions[i].IsConditionQuestion;
                                object.ConditionSectionId = sectionQst[0].Questions[i].ConditionSectionId;
                                object.ConditionType = sectionQst[0].Questions[i].ConditionType;
                                object.ConditionValue1 = sectionQst[0].Questions[i].ConditionValue1;
                                object.TotCount = sectionQst[0].Questions[i].TotCount;
                                object.IsRepeatSection = sectionQst[0].Questions[i].IsRepeatSection;
                                object.RepeatSectionId = sectionQst[0].Questions[i].RepeatSectionId;
                                object.FieldVar = sectionQst[0].Questions[i].FieldVar;
                                object.FormulaExpression = sectionQst[0].Questions[i].FormulaExpression;
                                object.IsFormulaQuestion = sectionQst[0].Questions[i].IsFormulaQuestion;
                                object.IsSearchable = sectionQst[0].Questions[i].IsSearchable;
                                object.DefaultValue = sectionQst[0].Questions[i].DefaultValue;
                                object.HierarchyQuestionOrder = sectionQst[0].Questions[i].HierarchyQuestionOrder;
                                object.MinValue = sectionQst[0].Questions[i].MinValue;
                                object.MaxValue = sectionQst[0].Questions[i].MaxValue;
                                object.TextLength = sectionQst[0].Questions[i].TextLength;
                                object.ErrorText = sectionQst[0].Questions[i].ErrorText;
                                object.RegEx = sectionQst[0].Questions[i].RegEx;
                                object.ValidationCondition = sectionQst[0].Questions[i].ValidationCondition;
                                object.RepeatOrder = repeatOrder;
                                object.SubRepeatOrder = null;
                                object.IsMandatory = sectionQst[0].Questions[i].IsMandatory;

                                if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" || object.QuestionType == "Datalist") {

                                    object.Options = await this.GetQuestionOptions(sectionQst[0].Questions[i].QuestionText, object.QuestionType)
                                } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                                    object.DrpDwnopt = await this.GetQuestionOptions(sectionQst[0].Questions[i].QuestionText, object.QuestionType)
                                }
                                else if (object.QuestionType == "masterdb") {
                                    object.DrpDwnopt = await this.GetMasterDBData(sectionQst[0].Questions[i].HierarchyQuestionOrder, sectionQst[0].Questions[i].DefaultValue)
                                }

                                if (CurrentQuestionList != null && CurrentQuestionList.length > 0) {
                                    var prevAnswer = CurrentQuestionList.filter(x => x.QuestionID == object.QuestionID && x.RepeatOrder == repeatOrder);

                                    if (prevAnswer != null && prevAnswer.length > 0) {

                                        object.Answers = prevAnswer[0].Answers;
                                    } else {
                                        object.Answers = [];
                                    }
                                } else {
                                    object.Answers = [];
                                }

                                object.FileName = "";
                                object.longitude = "";
                                object.latitude = "";
                                object.OrginalFileName = "";
                                object.Blob = [];
                                this.CurrentSectionQuestions[0].Questions.splice(position, 0, object);
                            }
                        }
                    } else {
                        removedConditionquestion = [];

                        if (repeatOrder > 0) {
                            for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                                if (this.CurrentSectionQuestions[0].Questions[i].SectionId == ConditionSectionId &&
                                    this.CurrentSectionQuestions[0].Questions[i].RepeatOrder == repeatOrder) {
                                    this.CurrentSectionQuestions[0].Questions[i].ConditionSectionId = "Delete";
                                }
                            }

                            removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => (x.ConditionSectionId != "Delete"));

                        } else {
                            removedConditionquestion = this.CurrentSectionQuestions[0].Questions.filter(x => (x.SectionId != ConditionSectionId));
                        }

                        this.CurrentSectionQuestions[0].Questions = removedConditionquestion;
                    }
                }
            } else if (IsRepeatSection == true) {

                qst = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionID && x.RepeatOrder == repeatOrder);
                var answerNumber = 0;
                var repeatSectionId = 0;
                // eslint-disable-next-line no-unused-vars
                var repeatSectionName = "";
                var surveyId = 0;


                if (qst != null && qst.length > 0) {
                    answerNumber = qst[0].Answers;
                    repeatSectionId = qst[0].RepeatSectionId;
                    surveyId = qst[0].SurveyID;

                    var repeatSection = this.SurveySectionList.filter(x => x.SectionId == repeatSectionId);

                    if (repeatSection != null && repeatSection.length > 0) {
                        // repeatSectionName = repeatSection[0].SectionName;


                        var itemstodeleted = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == repeatSectionId && x.RepeatOrder > answerNumber);

                        if (itemstodeleted != null && itemstodeleted.length > 0) {
                            const dist = [...new Set(itemstodeleted.map(x => x.RepeatOrder))];

                            if (dist != null && dist.length > 0) {
                                for (j = 0; j < dist.length; j++) {
                                    var delSect = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == repeatSectionId && x.RepeatOrder == dist[j]);
                                    if (delSect != null && delSect.length > 0) {
                                        for (k = 0; k < delSect.length; k++) {
                                            var thisindex = this.CurrentSectionQuestions[0].Questions.findIndex(x => x.QuestionID === delSect[k].QuestionID && x.RepeatOrder == delSect[k].RepeatOrder);
                                            this.CurrentSectionQuestions[0].Questions.splice(thisindex, 1);
                                        }
                                    }
                                }
                            }
                        }

                        position = 0;
                        for (j = 0; j < this.CurrentSectionQuestions[0].Questions.length; j++) {
                            if (this.CurrentSectionQuestions[0].Questions[j].QuestionID == QuestionID && this.CurrentSectionQuestions[0].Questions[j].RepeatOrder == repeatOrder) {
                                position = j;
                                break;
                            }
                        }

                        for (k = 1; k <= answerNumber; k++) {

                            var subrpt = repeatOrder > 0 ? k + "_" + repeatOrder : null;
                            var isexist = this.CurrentSectionQuestions[0].Questions.filter(x => x.SectionId == repeatSectionId && x.RepeatOrder == k && x.SubRepeatOrder == subrpt);

                            if (isexist != null && isexist.length > 0 && repeatSection != null && repeatSection[0] != null && repeatSection[0].Questions != null) {
                                position = position + (repeatSection[0].Questions.length + 1);
                            }

                            if (isexist == null || isexist.length == 0) {
                                SectionHead = await this.GetRepeatHead(repeatSectionId, surveyId, k, subrpt);
                                position = position + 1;
                                this.CurrentSectionQuestions[0].Questions.splice(position, 0, SectionHead);

                                for (i = 0; i < repeatSection[0].Questions.length; i++) {

                                    position = position + 1;
                                    object = new Object();
                                    object.QuestionID = repeatSection[0].Questions[i].QuestionID;
                                    object.QuestionName = repeatSection[0].Questions[i].QuestionName;
                                    object.QuestionType = repeatSection[0].Questions[i].QuestionType;
                                    object.QuestionOrder = repeatSection[0].Questions[i].QuestionOrder;
                                    object.SurveyID = repeatSection[0].Questions[i].SurveyID;
                                    object.SectionId = repeatSection[0].Questions[i].SectionId;
                                    object.IsConditionQuestion = repeatSection[0].Questions[i].IsConditionQuestion;
                                    object.ConditionSectionId = repeatSection[0].Questions[i].ConditionSectionId;
                                    object.ConditionType = repeatSection[0].Questions[i].ConditionType;
                                    object.ConditionValue1 = repeatSection[0].Questions[i].ConditionValue1;
                                    object.TotCount = repeatSection[0].Questions[i].TotCount;
                                    object.IsRepeatSection = repeatSection[0].Questions[i].IsRepeatSection;
                                    object.RepeatSectionId = repeatSection[0].Questions[i].RepeatSectionId;
                                    object.FieldVar = repeatSection[0].Questions[i].FieldVar;
                                    object.FormulaExpression = repeatSection[0].Questions[i].FormulaExpression;
                                    object.IsFormulaQuestion = repeatSection[0].Questions[i].IsFormulaQuestion;
                                    object.IsSearchable = repeatSection[0].Questions[i].IsSearchable;
                                    object.DefaultValue = repeatSection[0].Questions[i].DefaultValue;
                                    object.HierarchyQuestionOrder = repeatSection[0].Questions[i].HierarchyQuestionOrder;
                                    object.MinValue = repeatSection[0].Questions[i].MinValue;
                                    object.MaxValue = repeatSection[0].Questions[i].MaxValue;
                                    object.TextLength = repeatSection[0].Questions[i].TextLength;
                                    object.ErrorText = repeatSection[0].Questions[i].ErrorText;
                                    object.RegEx = repeatSection[0].Questions[i].RegEx;
                                    object.ValidationCondition = repeatSection[0].Questions[i].ValidationCondition;
                                    object.RepeatOrder = k;
                                    object.SubRepeatOrder = subrpt;
                                    object.IsMandatory = repeatSection[0].Questions[i].IsMandatory;
                                    if (object.QuestionType == "CheckBox" || object.QuestionType == "Radio" || object.QuestionType == "Yes/No" || object.QuestionType == "Datalist") {
                                        object.Options = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                    } else if (object.QuestionType == "Dropdown" || object.QuestionType == "ConditionalDropdown") {
                                        object.DrpDwnopt = await this.GetQuestionOptions(repeatSection[0].Questions[i].QuestionText, object.QuestionType)
                                    }
                                    else if (object.QuestionType == "masterdb") {
                                        object.DrpDwnopt = await this.GetMasterDBData(repeatSection[0].Questions[i].HierarchyQuestionOrder, repeatSection[0].Questions[i].DefaultValue)
                                    }

                                    object.Answers = [];

                                    if (repeatSection[0].Questions[i].DefaultValue != null &&
                                        repeatSection[0].Questions[i].DefaultValue != '' &&
                                        repeatSection[0].Questions[i].DefaultValue != 'undefined' &&
                                        repeatSection[0].Questions[i].QuestionType == "Text") {

                                        var defaultval = [];
                                        // eslint-disable-next-line no-redeclare
                                        for (var j = 0; j < this.SurveySectionList.length; j++) {
                                            defaultval = this.SurveySectionList[j].Questions.filter(x => x.IsConditionQuestion == false && x.IsRepeatSection == false);

                                            if (defaultval.length > 0) {
                                                defaultval = this.SurveySectionList[j].Questions.filter(x => x.FieldVar == repeatSection[0].Questions[i].DefaultValue);
                                                break;
                                            }
                                        }

                                        if (defaultval != null && defaultval.length > 0) {
                                            defaultval = defaultval.filter(x => x.RepeatOrder == object.RepeatOrder);

                                            if (defaultval != null && defaultval.length > 0 && !Array.isArray(defaultval[0].Answers)) {
                                                object.Answers = defaultval[0].Answers;
                                            }
                                        }

                                        if (object.Answers == null || object.Answers.length == 0) {
                                            object.Answers = repeatSection[0].Questions[i].DefaultValue;
                                        }
                                    }

                                    if (repeatSection[0].Questions[i].DefaultValue != null &&
                                        repeatSection[0].Questions[i].DefaultValue != '' &&
                                        repeatSection[0].Questions[i].DefaultValue != 'undefined') {
                                        if (repeatSection[0].Questions[i].QuestionType == "Number" ||
                                            repeatSection[0].Questions[i].QuestionType == "MultiLineText") {
                                            object.Answers = repeatSection[0].Questions[i].DefaultValue;
                                        }
                                    }

                                    object.FileName = "";
                                    object.longitude = "";
                                    object.latitude = "";
                                    object.OrginalFileName = "";
                                    object.Blob = [];
                                    this.CurrentSectionQuestions[0].Questions.splice(position, 0, object);
                                }
                            }
                        }
                    }
                }
            }
            /*var isOCRField = OCRFields.filter(item =>item == cntQuestion[0].QuestionName);
            if(isOCRField.length>0){
             this.reviewerCheck = true;
            }*/


            // if(cntQuestion[0].QuestionText === "Account Type") {
            //     // setTimeout(()=>{
            // 		if(cntQuestion[0].Answers != "") {
            // 			$("#Account Class_layout").hide();
            //             console.log("1st hide");
            // 		} else {
            // 			$("#Account Class_layout").hide();
            //             console.log("2nd hide");
            // 		}
            // 	// },0);

            // } 

            else if (cntQuestion[0].QuestionText === "Interest") {
                $("#IntrestSpecify_layout").hide();
                if (cntQuestion[0].Answers && cntQuestion[0].Answers.length > 0) {
                    // eslint-disable-next-line no-redeclare
                    for (var k = 0; k < cntQuestion[0].Answers.length; k++) {
                        if (cntQuestion[0].Answers[k] == "Other") {
                            $("#IntrestSpecify_layout").show();
                        }
                    }
                }
            }

            else if (cntQuestion[0].QuestionName == "Nationality") {
                var NationalityValue = cntQuestion[0].Answers.OptionValue;
                // if(NationalityValue == 'Botswana'){
                // eslint-disable-next-line no-redeclare
                for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                    if (NationalityValue == 'Botswana') {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Number" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Expiry Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Country") {

                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            this.CurrentSectionQuestions[0].Questions[i].hide = true;
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                            document.getElementById("lbl_" + this.CurrentSectionQuestions[0].Questions[i].QuestionID + "_" + this.CurrentSectionQuestions[0].Questions[i].RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + this.CurrentSectionQuestions[0].Questions[i].QuestionID + "_" + this.CurrentSectionQuestions[0].Questions[i].RepeatOrder).style.display = "none";

                        } if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "National ID Issue Country") {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = { OptionValue: 'Botswana', OptionText: 'Botswana' };

                        }
                    } else if (NationalityValue != 'Botswana') {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Number" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Expiry Date" || this.CurrentSectionQuestions[0].Questions[i].QuestionName == "Passport Issue Country") {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;
                            this.CurrentSectionQuestions[0].Questions[i].hide = false;
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';

                        }
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == "National ID Issue Country") {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';

                        }
                    }
                }
                // } 
            }

            // else if (cntQuestion[0].QuestionName === "Marital Status") {
            //     var MaritalStatusValue = cntQuestion[0].Answers.OptionValue;
                
            // }


            else if (cntQuestion[0].QuestionName === "Customer Type") {
                var custCategoryValue = cntQuestion[0].Answers.OptionValue;
                if (custCategoryValue == "Employed") {
                    this.isdispEmployedLookup = true;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = false;
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                           
                        }


                    }
                } else if (custCategoryValue == "Unemployed") {
                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = true;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = false;
                    this.dispDocForSourceOfFunds = true;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            
                        }

                    }
                } else if (custCategoryValue == "Pensioner") {

                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = true;
                    this.isdispSelfEmployedLookup = false;
                    this.dispDocForSourceOfFunds = true;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                       

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                           
                        }


                    }
                }
                else if (custCategoryValue == "Self Employed") {

                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = true;
                    this.dispDocForSourceOfFunds = true;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 1;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 0;


                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            // await db.TbSurveyQuestions.where({QuestionID: 59}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 61}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 62}).delete();
                        }



                    }

                } else {
                    this.isdispEmployedLookup = false;
                    this.isdispUnEmployedLookup = false;
                    this.isdispPensionerLookup = false;
                    this.isdispSelfEmployedLookup = false;

                    this.dispDocForSourceOfFunds = false;

                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 0;

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                            // await db.TbSurveyQuestions.where({QuestionID: 59}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 60}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 61}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 62}).delete();
                            // await db.TbSurveyQuestions.where({QuestionID: 63}).delete();
                        }




                    }
                }

            }

            else if (cntQuestion[0].QuestionName == "Source of Funds / Income Proof") {
                if (this.isdispEmployedLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // for(var j=0; j< this.CurrentSectionQuestions[0].Questions.length; j++){
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 1;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 0;

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }

                        // await db.TbSurveyQuestions.where({QuestionID: 60}).delete();
                        // await db.TbSurveyQuestions.where({QuestionID: 61}).delete();
                        // await db.TbSurveyQuestions.where({QuestionID: 62}).delete();
                        // }
                    }

                }
                else if (this.isdispUnEmployedLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        // for(var j=0; j< this.CurrentSectionQuestions[0].Questions.length; j++){
                        // this.CurrentSectionQuestions[0].Questions[6].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[7].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[8].IsMandatory = 0;
                        // this.CurrentSectionQuestions[0].Questions[9].IsMandatory = 1;

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }


                    }
                }
                else if (this.isdispPensionerLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }

                    }
                }
                else if (this.isdispSelfEmployedLookup == true) {
                    this.dispDocForSourceOfFunds = true;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {


                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }


                    }
                }
                else {
                    this.dispDocForSourceOfFunds = false;
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {


                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionID == 59 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 60 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 61 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 62 || this.CurrentSectionQuestions[0].Questions[i].QuestionID == 63) {
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 0;
                        }


                    }
                }
            }
            else if (cntQuestion[0].QuestionName == "Is Physical Address same as Postal Address?") {
                var currentHouseNumber = '';
                var currentAreaTown = '';
                var currentCity = '';
                var currentState = '';
                var currentCountry = '';
                if (cntQuestion[0].Answers == null) {
                    cntQuestion[0].Answers = "No";
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)'
                            ||  this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Village/Town/City(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;
 
                        }
                    }
                }
                else if (cntQuestion[0].Answers.length > 0) {
                    if (cntQuestion[0].Answers == "yes") {
 
                        for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Current)') {
                                currentHouseNumber = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Current)') {
                                currentAreaTown = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Current)') {
                                currentCity = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Current)') {
                                currentState = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
 
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Village/Town/City(Current)') {
                                currentCity = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'District(Current)') {
                                currentState = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Current)') {
                                currentCountry = this.CurrentSectionQuestions[0].Questions[i].Answers;
                            }
                        }
 
 
                        for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentHouseNumber;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentAreaTown;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Village/Town/City(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentCity;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            } if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentCity;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'District(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentState;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            } else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentState;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                            else if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = currentCountry;
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            }
                        }
                    }
                    else if (cntQuestion[0].Answers == "no" || cntQuestion[0].Answers == null) {
                        cntQuestion[0].Answers = "No";
                        for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                            if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)'
                                || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)'||  this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Village/Town/City(Permanent)'
                                || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                                this.CurrentSectionQuestions[0].Questions[i].Disabled = false;
 
                            }
                        }
                    }
 
 
                }
                else if (cntQuestion[0].Answers.length == 0) {
                    cntQuestion[0].Answers = "No";
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'House Number and Street(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Area Town(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'City(Permanent)'
                            || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'State(Permanent)' || this.CurrentSectionQuestions[0].Questions[i].QuestionText == 'Country(Permanent)') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = '';
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;
 
                        }
                    }
                }
            }

            else if (cntQuestion[0].QuestionName === "Account Class") {
                var AcctClassValue = cntQuestion[0].Answers.OptionValue;
                if (this.dispTransactionalAccountClass == true) {
                    if (this.$sunidhi.TransactionalAccountClass.length > 0) {
                        custCategory = this.$sunidhi.TransactionalAccountClass.filter(function (value) {
                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });
                    } else if (this.$sunidhi.TransactionalAccountClass.length == 0) {
                        await this.$sunidhi.getTransactionalAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.TransactionalAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });
                    }
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }
                    }
                }
                if (this.dispCurrentAccountClass == true) {
                    if (this.$sunidhi.CurrentAccountClass.length > 0) {

                        custCategory = this.$sunidhi.CurrentAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });
                    } else if (this.$sunidhi.CurrentAccountClass.length == 0) {
                        await this.$sunidhi.getCurrentAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.CurrentAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });

                    }

                    // eslint-disable-next-line no-redeclare
                    for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }
                    }
                }

                else if (this.dispSavingAccountClass == true) {
                    if (this.$sunidhi.SavingsAccountClass.length > 0) {
                        custCategory = this.$sunidhi.SavingsAccountClass.filter(function (value) {
                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }
                        });
                    } else if (this.$sunidhi.SavingsAccountClass.length == 0) {
                        await this.$sunidhi.getSavingsAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.SavingsAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });

                    }
                    // eslint-disable-next-line no-redeclare
                    for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {
                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }
                    }
                }


                else if (this.dispCallAccountClass == true) {
                    if (this.$sunidhi.CallAccountClass.length > 0) {
                        custCategory = this.$sunidhi.CallAccountClass.filter(function (value) {
                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }
                        });
                    } else if (this.$sunidhi.CallAccountClass.length == 0) {
                        await this.$sunidhi.getCallAccountClass();
                        await this.$sunidhi.addTboptionValues();
                        custCategory = this.$sunidhi.CallAccountClass.filter(function (value) {

                            if (value.LookUpValue == AcctClassValue) {
                                return value.LookUpValue;
                            }

                        });

                    }
                    for (i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                        if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Customer Category') {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = custCategory[0].MapField1; // Autofill cust category based on account class 
                        }

                    }
                }


            }

            else if (cntQuestion[0].QuestionName === "Account Type") {

                // if(cntQuestion[0].Answers.OptionValue == null){
                //     this.dispFullKycAccountClass = false;
                // }


                if (cntQuestion[0].Answers.OptionValue == 'Savings') {

                    // await SavingsAcctClass();
                    this.CurrentSectionQuestions[0].Questions[1].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[2].IsMandatory = 1;
                    this.CurrentSectionQuestions[0].Questions[3].IsMandatory = 0;

                    this.dispSavingAccountClass = true;
                    this.dispCallAccountClass = false;
                    this.dispCurrentAccountClass = false;
                    this.dispTransactionalAccountClass = false;
                    this.isCallAcct = false;

                }
                else if (cntQuestion[0].Answers.OptionValue == 'Current') {
                    this.CurrentSectionQuestions[0].Questions[1].IsMandatory = 1;
                    this.CurrentSectionQuestions[0].Questions[2].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[3].IsMandatory = 0;
                    this.dispSavingAccountClass = false;
                    this.dispCallAccountClass = false;
                    this.dispCurrentAccountClass = true;
                    this.dispTransactionalAccountClass = false;
                    this.isCallAcct = false;


                }
                else if (cntQuestion[0].Answers.OptionValue == 'Call') {
                    this.CurrentSectionQuestions[0].Questions[1].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[2].IsMandatory = 0;
                    this.CurrentSectionQuestions[0].Questions[3].IsMandatory = 1;
                    this.dispCurrentAccountClass = false;
                    this.dispSavingAccountClass = false;
                    this.dispCallAccountClass = true;
                    this.dispTransactionalAccountClass = false;
                    this.isCallAcct = true;

                    // await db.TbSurveyQuestions.where({QuestionID: "Account Class(Savings)"}).delete();

                    //  await db.TbSurveyQuestions.where({QuestionID: "Account Class(Current)"}).delete();

                    // await CallAcctClass();


                }

                //         this.CurrentSectionQuestions[0].Questions.forEach(qtn => {
                //     if(qtn.QuestionName == "Account Currency" && qtn.QuestionID == '52'){
                //                                 debugger
                //                                 if(this.isCallAcct){
                //                                     qtn.Answers =  ''
                //                                     qtn.Disabled = false
                //                                     qtn.hide = false
                //                                     qtn.IsMandatory = 1
                //                                 } else if(!this.isCallAcct){
                //                                     qtn.Answers= 'Botswana Pula'
                //                                 //    qtn.Disabled = true
                //                                 //    qtn.hide = true
                //                                    qtn.IsMandatory = 0
                //                                 }
                //                             }
                //    })

                // eslint-disable-next-line no-redeclare
                for (var i = 0; i < this.CurrentSectionQuestions[0].Questions.length; i++) {

                    if (this.CurrentSectionQuestions[0].Questions[i].QuestionName == 'Account Currency' && this.CurrentSectionQuestions[0].Questions[i].QuestionID == '52') {
                        if (this.isCallAcct) {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = { OptionValue: '', OptionText: '' };
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = false;
                            //    this.CurrentSectionQuestions[0].Questions[i].hide = false;
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        }
                        if (!this.isCallAcct) {
                            this.CurrentSectionQuestions[0].Questions[i].Answers = { OptionValue: 'Botswana Pula', OptionText: 'Botswana Pula' };
                            this.CurrentSectionQuestions[0].Questions[i].Disabled = true;
                            //    this.CurrentSectionQuestions[0].Questions[i].hide = true;
                            this.CurrentSectionQuestions[0].Questions[i].IsMandatory = 1;
                        }
                    }
                }



                // else if (cntQuestion[0].Answers.OptionValue == 'Transactional'){ 
                //         this.dispTransactionalAccountClass = true;
                //         this.dispCurrentAccountClass = false;
                //         this.dispSavingAccountClass=false;
                //         this.dispCallAccountClass=false;
                //     }
                // else{
                //     this.dispTransactionalAccountClass = false;
                //     this.dispCurrentAccountClass = false;
                //         this.dispSavingAccountClass=false;
                //         this.dispCallAccountClass=false;
                // }


                //     AccountClass.forEach(item =>{
                //        if(cntQuestion[0].Answers.OptionValue){
                // 			if(cntQuestion[0].Answers.OptionValue == item.LookUpValue){
                // 				this.CurrentSectionQuestions[0].Questions.forEach(qtn =>{
                // 				if(qtn.QuestionName == "Account Class"){
                // 					qtn.Answers = item.LookUpCode;
                // 				} 
                //                 // else if(qtn.QuestionName == "Account Currency") {
                // 				// 	qtn.Answers = item.CIFCode;
                // 				// }
                // 				});
                // 			} 
                // 		}
                //         else {
                // 			this.CurrentSectionQuestions[0].Questions.forEach(qtn =>{
                // 				if(qtn.QuestionName == "Account Class"){
                // 					qtn.Answers = '';
                // 				} 
                //                 // else if(qtn.QuestionName == "Account Currency") {
                // 				// 	qtn.Answers = '';
                // 				// }
                // 			});
                // 		}
                //   });


            }
        },

        async getSelectiveAccountClass() {
    var url = externalURL + "get_lookup_value/?lookupType=AccountType&lookupString=";

    try {
        const data = await $.ajax({
            url: url,
            type: 'POST'
        });

        if (data && data.length > 0) {
            // A function that filters based on account type
            const checkAcctType = (acctType) => {
                const { LookUpValue } = acctType;
                if (LookUpValue === 'Savings' || LookUpValue === 'Current' || LookUpValue === 'Call') {
                    return true;
                }
                return false;
            };

            // Use the filter() method with the checkAcctType function
            const acctClass = data.filter(checkAcctType);

            // Log the result
            console.log(acctClass);

            return acctClass; // Return the filtered array or whatever result is needed
        }
    } catch (error) {
        console.error('Error in getSelectiveAccountClass:', error);
        throw error; // Re-throw the error to propagate it further if needed
    }
},
        async GetConditionHead(sectionId, SurveyId, repeatOrder = 0) {
            var sections = await db.TbSurveySection.where({ SectionId: sectionId }).toArray();
            var object = new Object();
            object.QuestionID = 0;
            if (sections != null && sections.length > 0) {
                object.QuestionName = sections[0].Name;
            } else {
                object.QuestionName = "";
            }
            object.QuestionType = "Notes";
            object.QuestionOrder = 1;
            object.SurveyID = SurveyId;
            object.SectionId = sectionId;
            object.IsConditionQuestion = false;
            object.ConditionSectionId = 0;
            object.ConditionType = null;
            object.ConditionValue1 = null;
            object.TotCount = 0;
            object.IsRepeatSection = false;
            object.RepeatSectionId = null;
            object.FieldVar = null;
            object.FormulaExpression = null;
            object.IsFormulaQuestion = false;
            object.IsSearchable = false;
            object.DefaultValue = null;
            object.HierarchyQuestionOrder = null;
            object.MinValue = 0;
            object.MaxValue = 0;
            object.TextLength = 0;
            object.ErrorText = null;
            object.RegEx = null;
            object.ValidationCondition = null;
            object.RepeatOrder = repeatOrder;
            object.SubRepeatOrder = null;
            object.IsMandatory = false;
            object.Options = [];
            object.DrpDwnopt = [];
            object.Answers = [];
            object.FileName = "";
            object.longitude = "";
            object.latitude = "";
            object.OrginalFileName = "";
            object.Blob = [];
            return object;
        },
        async GetRepeatHead(sectionId, SurveyId, RepeatOrder, SubRepeatOrder) {
            var sections = await db.TbSurveySection.where({ SectionId: sectionId }).toArray();
            var object = new Object();
            object.QuestionID = 0;
            if (sections != null && sections.length > 0) {
                object.QuestionName = sections[0].Name + ": " + RepeatOrder;
            } else {
                object.QuestionName = "";
            }
            object.QuestionType = "Notes";
            object.QuestionOrder = 1;
            object.SurveyID = SurveyId;
            object.SectionId = sectionId;
            object.IsConditionQuestion = false;
            object.ConditionSectionId = 0;
            object.ConditionType = null;
            object.ConditionValue1 = null;
            object.TotCount = 0;
            object.IsRepeatSection = false;
            object.RepeatSectionId = null;
            object.FieldVar = null;
            object.FormulaExpression = null;
            object.IsFormulaQuestion = false;
            object.IsSearchable = false;
            object.DefaultValue = null;
            object.HierarchyQuestionOrder = null;
            object.MinValue = 0;
            object.MaxValue = 0;
            object.TextLength = 0;
            object.ErrorText = null;
            object.RegEx = null;
            object.ValidationCondition = null;
            object.RepeatOrder = RepeatOrder;
            object.SubRepeatOrder = SubRepeatOrder;
            object.IsMandatory = false;
            object.Options = [];
            object.DrpDwnopt = [];
            object.Answers = [];
            object.FileName = "";
            object.longitude = "";
            object.latitude = "";
            object.OrginalFileName = "";
            object.Blob = [];
            return object;
        },
        
        async Calculation(QuestionId, IsFormulaQuestion, RepeatOrder = 0, SubRepeatOrder = null) {
            if (IsFormulaQuestion) {
                var Question = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionId && x.RepeatOrder == RepeatOrder);

                if (SubRepeatOrder != null) {
                    Question = Question.filter(x => x.SubRepeatOrder == SubRepeatOrder);
                }

                var SurveyId = 0;
                var FormulaExpression = "";

                if (Question != null && Question.length > 0) {
                    SurveyId = Question[0].SurveyID;
                    FormulaExpression = Question[0].FormulaExpression.replace("{", '(').replace("}", ')');
                }

                var isFunction = false;
                var functions = "";
                var fnsubstr = "";
                var survey = await db.TbSurvey.where("SurveyID").equals(SurveyId).toArray();
                var SurveyQuestions = await db.TbSurveyQuestions.where("SurveyID").equals(SurveyId).toArray();
                SurveyQuestions = SurveyQuestions.filter(x => x.FieldVar != null && x.FieldVar != "" && x.FieldVar != undefined);

                if (SurveyQuestions != null) {
                    for (var i = 0; i < SurveyQuestions.length; i++) {
                        var fieldvar = SurveyQuestions[i].FieldVar;
                        var answer = "";
                        // var QuestionRepeatOrder = 0;

                        var repeatQst = [];
                        for (var j = 0; j < this.SurveySectionList.length; j++) {
                            var dd = this.SurveySectionList[j].Questions.filter(x => x.FieldVar == fieldvar);
                            repeatQst = dd;
                            //if (QuestionRepeatOrder > 0) {
                            //    dd = dd.filter(x => x.RepeatOrder == QuestionRepeatOrder);
                            //}

                            if (dd != null && dd.length > 0) {
                                if (RepeatOrder > 0) {
                                    dd = dd.filter(x => x.RepeatOrder == RepeatOrder);
                                }

                                if (SubRepeatOrder != null) {
                                    dd = dd.filter(x => x.SubRepeatOrder == SubRepeatOrder);
                                }

                                if (dd.length > 0 && !Array.isArray(dd[0].Answers) && dd[0].Answers > 0) {
                                    answer = dd[0].Answers;
                                }
                            }

                            var repeatAnwer = "";
                            if (repeatQst != null && repeatQst.length > 0) {

                                for (var k = 0; k < repeatQst.length; k++) {
                                    var count = k + 1;
                                    var newfiled = fieldvar + "[" + count + "]";
                                    // var regex1 = new RegExp(newfiled, "g");

                                    if (repeatQst[k].QuestionType == "CheckBox" ||
                                        repeatQst[k].QuestionType == "Radio" ||
                                        repeatQst[k].QuestionType == "Dropdown" ||
                                        repeatQst[k].QuestionType == "ConditionalDropdown"

                                    ) {

                                        if (repeatQst[k].Answers != null &&
                                            repeatQst[k].Answers > 0 || (repeatQst[k].QuestionType == "Dropdown" && repeatQst[k].Answers != null) || (repeatQst[k].QuestionType == "ConditionalDropdown" && repeatQst[k].Answers != null)) {
                                            var wer = !Array.isArray(repeatQst[k].Answers) ? repeatQst[k].Answers : repeatQst[k].Answers[0];

                                            if (repeatQst[k].QuestionType == "CheckBox" ||
                                                repeatQst[k].QuestionType == "Radio") {

                                                var SurveyQuestionOptions = await db.TbQuestionOptions.where("OptionID").equals(parseInt(wer)).toArray();

                                                if (SurveyQuestionOptions != null && SurveyQuestionOptions.length > 0) {
                                                    wer = SurveyQuestionOptions[0].OptionText;
                                                }
                                            } else if (repeatQst[k].QuestionType == "Dropdown" || repeatQst[k].QuestionType == "ConditionalDropdown") {
                                                wer = (wer != null ? wer.OptionText : wer);
                                            }

                                            if (repeatAnwer.length > 0) {
                                                repeatAnwer += "," + wer;
                                            } else {
                                                repeatAnwer += wer;
                                            }

                                            if (wer > 0) {
                                                FormulaExpression = FormulaExpression.replace(newfiled, wer);
                                            }
                                        }

                                    } else {

                                        if (repeatQst[k].Answers != null && !Array.isArray(repeatQst[k].Answers) &&
                                            repeatQst[k].Answers > 0) {

                                            wer = repeatQst[k].Answers;

                                            if (repeatAnwer.length > 0) {
                                                repeatAnwer += "," + wer;
                                            } else {
                                                repeatAnwer += wer;
                                            }

                                            if (wer > 0) {
                                                FormulaExpression = FormulaExpression.replace(newfiled, wer);
                                            }
                                        }
                                    }
                                }
                            }

                            if (fieldvar != null && fieldvar.length > 0) {
                                var indexnumber = FormulaExpression.indexOf(fieldvar);
                                var indexItem = FormulaExpression.substr(indexnumber + fieldvar.length, 1);
                                var indexItem1 = 0;
                                if (indexnumber > 0) {
                                    indexItem1 = FormulaExpression.substr(indexnumber - 1, 1);
                                }


                                if (indexItem != null && indexItem.includes("'") && indexItem1 != 0 && indexItem1.includes("'")) {
                                    if (repeatAnwer.length > 0) {
                                        FormulaExpression = FormulaExpression.replace(fieldvar, repeatAnwer);
                                    }
                                }
                            }
                        }

                        var regex = new RegExp(fieldvar, "g");
                        if (answer > 0) {
                            FormulaExpression = FormulaExpression.replace(regex, answer);
                        }
                    }
                }

                var SurveyFunction = (survey[0].FormulaFunction != null && survey[0].FormulaFunction.length > 0) ? survey[0].FormulaFunction.split('~') : "";

                if (SurveyFunction != null && SurveyFunction.length > 0) {
                    // eslint-disable-next-line no-redeclare
                    for (var j = 0; j < SurveyFunction.length; j++) {
                        fnsubstr = SurveyFunction[j].substr(0, SurveyFunction[j].indexOf('('));
                        if (fnsubstr != null && fnsubstr.length > 0 && FormulaExpression.includes(fnsubstr)) {
                            isFunction = true;
                            functions = SurveyFunction[j];
                        }
                    }
                }

                var calanswer;

                if (!isFunction) {
                    calanswer = eval(FormulaExpression);
                } else {
                    var ss = "function " + functions + ";" + FormulaExpression
                    calanswer = eval(ss);
                }

                Question[0].Answers = calanswer > 0 ? Math.round(calanswer) : calanswer;

                if (Question[0].IsConditionQuestion) {
                    this.AppendSection(Question[0].QuestionID, Question[0].QuestionType, Question[0].IsConditionQuestion, "", Question[0].IsRepeatSection)
                }
            }
        },
       
        async ValidateCurrentForm() {
            var QstList = this.CurrentSectionQuestions[0].Questions;
            var errorcount = 0;
            var isAccountNo = false;
            var otherSpecify = false;
            var isMarried = false;
            var isGrossCur = false;
            var isNetCur = false;
            var netId = "";
            var grossId = "";
            for (var i = 0; i < QstList.length; i++) {
                var item = QstList[i];
                var ageval = 0;
                if (item.QuestionText === "IsAccountPresent") {
                    if (item.Answers == 1) {
                        isAccountNo = true;
                    }
                }
                if (item.QuestionText === "Interest") {
                    if (item.Answers && item.Answers.length > 0) {
                        for (var k = 0; k < item.Answers.length; k++) {
                            if (item.Answers[k] == "Other") {
                                otherSpecify = true;
                            }
                        }
                    }
                }
                if (item.QuestionName === "Marital Status") {
                    if (item.Answers == "Married") {
                        isMarried = true;
                    }
                }
                if (item.QuestionName === "Gross salary currency type") {
                    // eslint-disable-next-line no-unused-vars
                    grossId = item.QuestionID;
                    if (item.Answers) {
                        isGrossCur = true;
                    }
                }
                if (item.QuestionName === "Net salary currency type") {
                    // eslint-disable-next-line no-unused-vars
                    netId = item.QuestionID;
                    if (item.Answers) {
                        isNetCur = true;
                    }
                }
                switch (item.QuestionType) {
                    case "CheckBox":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " "  || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Dropdown":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != 0)) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Radio":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined" || item.Answers == 0) || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined" || item.Answers != 0)) {
                                result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "Number":

                        if (item.QuestionText === "AccountNumber") {
                            if (isAccountNo) {
                                if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {

                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            }
                        }
                        else if (item.IsMandatory) {


                            if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        else {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }
                        if (item.QuestionText === "ISDCode") {
                            if (item.Answers && item.Answers.length < 9 && (item.Answers.length != 0 || item.IsMandatory)) {
                                if (item.QuestionName != 'Primary Mobile Number') {
                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Enter valid Mobile number";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                            else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        if (item.QuestionName === "Gross salary" && item.Answers && item.Answers.length != 0) {
                            if (!isGrossCur) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Select currency type";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";

                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";

                            }
                        }
                        if (item.QuestionName === "Net salary") {
                            if (item.Answers && !isNetCur) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Select currency type";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";

                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";

                            }
                        }

                        if (item.Answers != null && item.Answers != "" && item.Answers.length != 0 || (item.QuestionID == 36)) {
                            if (item.MinValue > 0 || item.MaxValue > 0) {
                                if (item.Answers != "" && item.Answers != 0) {
                                    if (item.Answers < item.MinValue || item.Answers > item.MaxValue) {
                                        errorcount++;
                                        if (item.QuestionID == 36) {
                                            item.ErrorText = "";
                                            ageval++;
                                        }
                                        if (item.ErrorText == null || item.ErrorText == "") {
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Value should be between " + item.MinValue + " and " + item.MaxValue;
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                        } else if (item.ErrorText.length > 0) {
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                        }
                                    } else {
                                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && (item.Answers != null && item.Answers != "" && item.Answers.length != 0)) {
                                            var regex = new RegExp(item.RegEx);
                                            if (!(regex.test(item.Answers))) {

                                                errorcount++;
                                                if (item.ErrorText.length > 0) {
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                                } else if (item.ErrorText == null && item.ErrorText == "") {
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                                }
                                            }
                                            else {
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                            }

                                        } else {
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                        }
                                    }
                                }
                            }

                            if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                                ((item.Answers != null || item.Answers != "" || item.Answers.length != "undefined") || item.Answers.length != 0) && ageval == 0) {
                                result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                                if (!result) {
                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            }
                        }
                        if (item.QuestionName === "Address Line3 [Street no]") {
                            if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {
                                this.CurrentSectionQuestions[0].Questions[i].Answers = 0;
                                item.Answers = 0;
                            }
                        }
                        break;
                    case "Text":
                        if ((item.QuestionText === "IntrestSpecify") || (item.QuestionText === "SpouseName")) {
                            if (item.IsMandatory && (item.QuestionText === "IntrestSpecify" && otherSpecify) || (item.QuestionText === "SpouseName" && isMarried)) {
                                if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                    errorcount++;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        else if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.Answers && item.Answers != '' && item.validationType == "onlyEmailId") {
                            var regEx = /^([A-Za-z0-9_.])+@([A-Za-z0-9_.])+\.([A-Za-z]{2,4})$/;
                            if (!(regEx.test(item.Answers))) {
                                errorcount++;
                                if (item.ErrorText.length > 0) {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else if (item.ErrorText == null && item.ErrorText == "") {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                            else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        } else {
                            if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                                regex = new RegExp(item.RegEx);
                                if (!(regex.test(item.Answers))) {
                                    errorcount++;
                                    if (item.ErrorText.length > 0) {
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    } else if (item.ErrorText == null && item.ErrorText == "") {
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                    }
                                }
                                else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                        }

                        if ((item.Answers.length > 0 || item.QuestionID == 35) && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        break;
                    case "MultiLineText":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                            regex = new RegExp(item.RegEx);

                            if (!(regex.test(item.Answers))) {

                                errorcount++;
                                if (item.ErrorText.length > 0) {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText;
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                } else if (item.ErrorText == null && item.ErrorText == "") {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Not Matching with the Regular Expression";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                }
                            }
                            else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            }
                        }

                        if (item.ValidationCondition != null && item.Answers.length > 0 && item.ValidationCondition.length > 0) {
                            result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Date":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0 || item.Answers == "undefined--undefined") {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Date is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {

                                if (item.QuestionName == "Date of Birth") {
                                    const currentDate = new Date();
                                    console.log("currentDate:", currentDate);
                                    // Calculate the birth date from the provided DOB
                                    const birthDate = new Date(item.Answers);
                                    console.log("birthDate:", birthDate)
                                    // Calculate the age by subtracting the birth year from the current year
                                    const age = currentDate.getFullYear() - birthDate.getFullYear();
                                    console.log("age:", age)
                                    // Check if the age is less than 18
                                    if (age < 18) {
                                        // errorcount++;
                                        this.isMinor = true;
                                        // this.ErrorMessage = "Minimum age to open account should be greater than 18. Kindly check your DOB and Resubmit."
                                        // this.dialogError = true;



                                    } else {
                                        this.isMinor = false;
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                        document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                    }

                                } else {
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                    document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                                }





                            }
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "IssuanceDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0 || item.Answers == "undefined--undefined") {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.QuestionName + " is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ExpiryDate":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0 || item.Answers == "undefined--undefined") {
                                errorcount++;
                                this.expiryErrMsg = true;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.QuestionName + " is required";
                                // this.expiryError = true;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                this.expiryErrMsg = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else if (!item.IsMandatory) {
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                            document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                        }

                        if (item.Answers.length > 0 && item.ValidationCondition != null && item.ValidationCondition.length > 0) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                // this.expiryError = true;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                // this.expiryError = false;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Yes/No":
                        if (item.IsMandatory) {
                            if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }

                        if (item.ValidationCondition != null && item.ValidationCondition.length > 0 &&
                            (item.Answers != null || item.Answers != "" || item.Answers.length != "undefined")) {
                            // eslint-disable-next-line no-redeclare
                            var result = await this.ValidationConditionSection(item.SurveyID, item.QuestionID);

                            if (!result) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = item.ErrorText
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ResidencePeriod":
                        if (item.IsMandatory) {
                            var period = "";

                            if (this.years_period && this.months_period) {
                                if (this.years_period > 0 || this.months_period > 0) {
                                    period = this.years_period + "-" + this.months_period;
                                }
                            }
                            this.CurrentSectionQuestions[0].Questions[i].Answers = period;
                            item.Answers = period;
                            if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        } else {
                            period = "";
                            if (!this.years_period) {
                                this.years_period = "00"
                            }
                            if (!this.months_period) {
                                this.months_period = "00"
                            }

                            if (this.years_period && this.months_period) {
                                period = this.years_period + "-" + this.months_period;
                            }
                            this.CurrentSectionQuestions[0].Questions[i].Answers = period;
                            item.Answers = period;
                        }
                        break;
                    case "Image":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Image(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "CaptureImage":
                        //const source_proofOfidentification = $("#captureImage")[0];
                        // var resultProofOfidentification = jic.compress(source_proofOfidentification, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfidentification)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;

                    case "ProofOfResidence":
                        // const source_proofOfResidence = $("#ProofOfResidence")[0];
                        // var resultProofOfResidence = jic.compress(source_proofOfResidence, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfResidence)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ProofOfUtilityBill":
                        // const source_ProofOfUtilityBill = $("#ProofOfUtilityBill")[0];
                        // var resultProofOfUtilityBill = jic.compress(source_ProofOfUtilityBill, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfUtilityBill)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "ProofForSourceOfFunds":
                        // const source_ProofOfUtilityBill = $("#ProofOfUtilityBill")[0];
                        // var resultProofOfUtilityBill = jic.compress(source_ProofOfUtilityBill, 90, '').src;

                        if (item.IsMandatory) {
                            // item.Blob.push(resultProofOfUtilityBill)
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "File(s) is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;

                    case "Audio":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Audio is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "Sign":
                        if (item.IsMandatory) {
                            if (item.Blob.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Signature is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                document.getElementById('signaturepaddiv_' + item.QuestionID + "_" + item.RepeatOrder).style.display = "block";
                                document.getElementById('btnsignaturepad_' + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                                alert("Please provide the signature and save it")
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "GPS":
                        if (item.IsMandatory) {
                            if (item.latitude.length == 0 || item.longitude.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "GPS required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    case "masterdb":
                        if (item.IsMandatory) {
                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                errorcount++;
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "Field is required";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "inline";
                            } else {
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).textContent = "";
                                document.getElementById("lbl_" + item.QuestionID + "_" + item.RepeatOrder).style.display = "none";
                            }
                        }
                        break;
                    // default:
                    // code block
                }
            }


            return errorcount;
        },
        async ValidateAllForms() {
            // debugger
            var errorcount = 0;

            if (this.sectionArray != null && this.sectionArray.length > 0) {

                for (var k = 0; k < this.sectionArray.length; k++) {

                    var sections = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[k])
                    var QstList;

                    if (sections != null && sections.length > 0) {
                        QstList = sections[0].Questions;
                    }

                    if (QstList != null && QstList.length > 0) {
                        var isAccountNo = false;
                        var otherSpecify = false;
                        var isMarried = false;
                        var isGrossCur = false;
                        var isNetCur = false;
                        var netId = "";
                        var grossId = "";
                        for (var i = 0; i < QstList.length; i++) {
                            var item = QstList[i];
                            if (item.QuestionText === "IsAccountPresent") {
                                if (item.Answers == 1) {
                                    isAccountNo = true;
                                }
                            }
                            if (item.QuestionText === "Interest") {
                                if (item.Answers && item.Answers.length > 0) {
                                    // eslint-disable-next-line no-redeclare
                                    for (var k = 0; k < item.Answers.length; k++) {
                                        if (item.Answers[k] == "Other") {
                                            otherSpecify = true;
                                        }
                                    }
                                }
                            }

                            if (item.QuestionName === "Marital Status") {
                                if (item.Answers == "Married") {
                                    isMarried = true;
                                }
                            }

                            if (item.QuestionName === "Gross salary currency type") {
                                // eslint-disable-next-line no-unused-vars
                                grossId = item.QuestionID;
                                if (item.Answers) {
                                    isGrossCur = true;
                                }
                            }
                            if (item.QuestionName === "Net salary currency type") {
                                // eslint-disable-next-line no-unused-vars
                                netId = item.QuestionID;
                                if (item.Answers) {
                                    isNetCur = true;
                                }
                            }
                            switch (item.QuestionType) {
                                case "CheckBox":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Dropdown":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Datalist":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Radio":
                                    if (item.IsMandatory) {
                                        if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined" || item.Answers == 0) || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Number":
                                    if (item.QuestionText === "AccountNumber") {
                                        if (isAccountNo) {
                                            if (item.Answers == null || item.Answers.toString() == "" || item.Answers.length == 0) {
                                                errorcount++;
                                            }
                                        }
                                    }
                                    else if (item.IsMandatory) {
                                        if ((item.Answers == null || item.Answers.toString() == "" || item.Answers.toString().length == "undefined" || item.Answers.length == 0)) {
                                            errorcount++;
                                        }
                                    }
                                    if (item.QuestionText === "ISDCode" && item.Answers && item.Answers.length < 9 && (item.Answers.length != 0 || item.IsMandatory)) {
                                        if (item.QuestionName != "Primary Mobile Number") {
                                            errorcount++;
                                        }

                                    }
                                    if (item.QuestionName === "Gross salary" && item.Answers && item.Answers.length != 0) {
                                        if (!isGrossCur) {
                                            errorcount++;
                                        }

                                    }
                                    if (item.QuestionName === "Net salary") {
                                        if (item.Answers && !isNetCur) {
                                            errorcount++;
                                        }
                                    }
                                    if (item.Answers != null && item.Answers != "" && item.Answers.length != 0) {
                                        if (item.MinValue > 0 || item.MaxValue > 0) {
                                            if (item.Answers != "" || item.Answers != 0) {
                                                if (item.Answers < item.MinValue || item.Answers > item.MaxValue) {
                                                    errorcount++;

                                                } else {
                                                    if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 &&
                                                        (item.Answers != null && item.Answers != "" && item.Answers.length != 0)) {
                                                        var regex = new RegExp(item.RegEx);
                                                        if (!(regex.test(item.Answers))) {
                                                            errorcount++;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    break;
                                case "Text":
                                    if(item.QuestionText === 'National ID Number'){
                                        if(item.Answers != null ||item.Answers != '' || item.Answers == " " ){
                                            var randomId = this.generateRandomId();
                                            console.log("actual ID:", item.Answers)
                                            console.log("random ID:", randomId)
                                            item.Answers = item.Answers + randomId ;
                                        }
                                    }
                                    if ((item.QuestionText === "IntrestSpecify") || (item.QuestionText === "SpouseName")) {
                                        if (item.IsMandatory && (item.QuestionText === "IntrestSpecify" && otherSpecify) || (item.QuestionText === "SpouseName" && isMarried)) {
                                            if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                                errorcount++;
                                            }
                                        }
                                    } else if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }

                                    if (item.Answers && item.Answers != '' && item.validationType == "onlyEmailId") {
                                        var regEx = /^([A-Za-z0-9_.]+)@([A-Za-z0-9_.]+)\.([A-Za-z]{2,4})$/;
                                        if (!(regEx.test(item.Answers))) {
                                            errorcount++;
                                        }
                                    } else {
                                        if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                                            regex = new RegExp(item.RegEx);
                                            if (!(regex.test(item.Answers))) {
                                                errorcount++;
                                            }
                                        }
                                    }
                                    break;
                                case "MultiLineText":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }

                                    if (item.RegEx != null && item.RegEx != "" && item.RegEx.length > 0 && item.Answers.length > 0) {
                                        regex = new RegExp(item.RegEx);

                                        if (!(regex.test(item.Answers))) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Date":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "IssuanceDate":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "ExpiryDate":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Yes/No":
                                    if (item.IsMandatory) {
                                        if ((item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == "undefined") || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Image":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "CaptureImage":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Audio":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "Sign":
                                    if (item.IsMandatory) {
                                        if (item.Blob.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "GPS":
                                    if (item.IsMandatory) {
                                        if (item.latitude.length == 0 || item.longitude.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "masterdb":
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                case "ConditionalDropdown":
                                    // if (item.IsMandatory &&item.QuestionName == msgLBL.BOK_FORM_PAGE_DUAL_CITIZENSHIP_MSG && this.dispDualCitizen == true) {
                                    //     if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                    //         errorcount++;
                                    //     }
                                    // }
                                    if (item.IsMandatory) {
                                        if (item.Answers == null || item.Answers == "" || item.Answers == " " || item.Answers.length == 0) {
                                            errorcount++;
                                        }
                                    }
                                    break;
                                // default:
                                // code block
                            }
                        }
                    }
                }
            }

            return errorcount;
        },
        async SubmitSurveyFom() {
            clearInterval(this.intervalid1);
            // backbuttonpressed = false;
            this.Issubmitclicked = 'True';
            this.isSubmitBtnClicked = true;
            var errorCount = 0;
            var UserId = 0;
            // this.showProcessMsg = false;

            errorCount = await this.ValidateCurrentForm();

            if (errorCount > 0) {
                this.Issubmitclicked = 'False';
                this.isSubmitBtnClicked = false;
                return false;
            } else {
                errorCount = await this.ValidateAllForms();

                if (errorCount > 0) {
                    this.isMinor = false;
                    this.ErrorMessage = "Please fill all mandatory questions in all sections before submitting the form !";
                    this.dialogError = true;
                    this.Issubmitclicked = 'False';
                    this.isSubmitBtnClicked = false;
                    return false;
                } else {
                    if (localStorage) {
                        UserId = localStorage.getItem("UserId");
                    }
                    $("#submit-btn").attr("disabled", true);
                    $("#submit-btn").removeClass("primary-btn");
                    $("#submit-btn").addClass("grey lighten-2");
                    $("#submit-btn").css("color", "black");
                    this.SaveToClientDB(this.SurveySectionList, UserId, true, false, this.sectionArray, 0, 0);

                }
            }
        },
        async SaveAndExitForm() {
            // backbuttonpressed = false;
            this.Issubmitclicked = 'True';

            var errorCount = 0;
            var UserId = 0;

            errorCount = await this.ValidateCurrentForm();

            if (errorCount > 0) {
                this.Issubmitclicked = 'False';
                return false;
            } else {

                if (localStorage) {
                    UserId = localStorage.getItem("UserId");
                }

                var ss = this.SurveySectionList.filter(x => x.SectionId == this.sectionArray[this.SelectedSection - 1]);

                if (ss != null && ss.length > 0) {
                    ss[0].Questions = this.CurrentSectionQuestions[0].Questions;
                }

                this.SaveToClientDB(this.SurveySectionList, UserId, false, true, this.sectionArray, 0, 0);
            }
        },
        // eslint-disable-next-line no-unused-vars
        async SaveToClientDB(SurveySectionList, UserId, IsSubmitted, IsSaved, SectionList, FormId = 0, EntryId = 0) {
            this.uploadSuccess = [];
            // var unName = "";
            // var password = "";
            var userTokenID = "";

            var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
            if (genzdata1 != null || genzdata1.length > 0) {
                // eslint-disable-next-line no-unused-vars
                userTokenID = genzdata1[0].token;
            }

            if (IsSubmitted) {
                this.processLoader = 1;
                this.SubmitProgressMessage = "Processing Form Submission to dc...";

                if (this.processedFormId > 0) {
                    await db.ClientSyncQueue.where("FormID").equals(this.processedFormId).delete();
                    await db.TbSurveyForm.where("FormID").equals(this.processedFormId).delete();
                    await db.TbAnswers.where("FormID").equals(this.processedFormId).delete();
                    this.processedFormId = 0;
                }
            }

            if (SectionList != null && SectionList.length > 0) {

                var SurveyId = 0;
                var SurveyName = 0;

                if (SurveySectionList != null && SurveySectionList.length > 0) {
                    SurveyId = SurveySectionList[0].SurveyID;
                    SurveyName = SurveySectionList[0].SurveyName;
                }

                var ID = this.$sunidhi.IDGenerator();
                var FormCount = await db.TbSurveyForm.where("SurveyID").equals(SurveyId).toArray();
                var FormName = SurveyName + '_' + (FormCount.length + 1);

                // eslint-disable-next-line no-unused-vars
                var pkId = await db.TbSurveyForm.put({ FormID: ID, Name: FormName, SurveyID: SurveyId, CreatedDate: Date(), CreatedBy: parseInt(UserId), IsActive: true, IsSubmitted: IsSubmitted, IsSaved: IsSaved, UserID: parseInt(UserId) });

                for (var i = 0; i < SectionList.length; i++) {
                    var Section = SurveySectionList.filter(x => x.SectionId == SectionList[i]);

                    if (Section != null && Section.length > 0 &&
                        Section[0].Questions != null && Section[0].Questions.length > 0) {

                        ///  Insert into TbSurveyAnswers Table
                        for (var j = 0; j < Section[0].Questions.length; j++) {
                            var item = Section[0].Questions[j];

                            if (item.QuestionType == "Dropdown" || item.QuestionType == "masterdb" || item.QuestionType == "ConditionalDropdown") {
                                if (Object.keys(item.Answers).length > 0) {
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers.OptionValue, OptionID: item.Answers.OptionValue, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: null, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: null, Blob: null });
                                }
                            }
                            else if (item.QuestionType == "Image" || item.QuestionType == "Audio" || item.QuestionType == "Sign") {
                                if (item.Blob.length > 0 && item.OrginalFileName != "") {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            }
                            else if (item.QuestionType == "CaptureImage" || item.QuestionType == "ProofOfResidence" || item.QuestionType == "ProofOfUtilityBill" || item.QuestionType == "ProofForSourceOfFunds") {
                                if (item.Blob.length > 0) {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            }
                            else if (item.QuestionType == "CheckBox" || item.QuestionType == "Radio") {
                                if (item.Answers.length == 0) {
                                    item.Answers = "No";
                                    AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                } else {
                                    AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }

                            }
                            else if (item.Answers > 0 || item.Answers.length > 0) {

                                if (item.Answers instanceof Array) {

                                    if (typeof item.Answers[item.Answers.length - 1] != 'string') {

                                        AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                    else {
                                        AnswerID = await db.TbAnswers.put({ Answer: item.Answers[item.Answers.length - 1], QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                }
                                else {
                                    if (item.QuestionName == "First Name" || item.QuestionName == "Last Name" || item.QuestionName == "Name on Debit card") {
                                        item.Answers = (item.Answers != null && item.Answers != undefined) ? item.Answers.toUpperCase() : "";
                                    }

                                    // eslint-disable-next-line no-unused-vars
                                    AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }
                            }
                        }
                    }
                }

                ///  Insert into ClientSyncQueue Table
                if (IsSubmitted == true) {
                    this.processLoader = 2;
                    this.SubmitProgressMessage = "Processing Form Submission to dc...2";
                    // eslint-disable-next-line no-unused-vars
                    var SyncQueuePKID = await db.ClientSyncQueue.put({ FormID: ID, SurveyID: SurveyId, CreatedDate: Date(), TagName: "SurveyForm" });
                }


                // eslint-disable-next-line no-unused-vars
                var success = false;

                if (IsSubmitted == false) {
                    //  alert("saved Successfully");
                    this.Issubmitclicked = 'False';
                    this.dialogSuccess = true;
                    this.successMessage = "saved Successfully";
                } else {

                    if (window.navigator.onLine) {
                        this.processLoader = 3;
                        this.SubmitProgressMessage = "Processing Form Submission to dc...3";
                        var response = await this.$sunidhi.submitgenz(1, ID);

                        if (response != null && response != undefined && response.Message == "Success") {

                            this.SubmitProgressMessage = "Submission Completed";
                            this.processLoader = 5;
                            this.processLoader = 6;
                            //this.submitLoading = false;
                            // this.successMessage = "Submitted Successfully,";
                            this.successMessage1 = "Submitted Successfully";
                            this.successMessage2 = "Thank you for your application,";
                            this.successMessage = "account information will be sent to the registered email / SMS.";

                            this.uploadSuccess.push("Ref No : " + response.resultStatus); //ReferenceNumber
                            this.dialogSuccess = true;
                        }
                        else {
                            this.processLoader = 6;
                            await db.TbSurveyForm.where("FormID").equals(this.processedFormId).modify({ IsSubmitted: false, IsSaved: true });
                            var err = "Sorry an error has occured. Please try again.";
                            this.ErrorMessage = err;
                            this.dialogError1 = true;
                            return false;
                            // alert("Form Submition Failed, Message : " + response.Message);
                        }
                        this.Issubmitclicked = 'False';
                    }
                    else {
                        await db.TbSurveyForm.where("FormID").equals(this.processedFormId).modify({ IsSubmitted: false, IsSaved: true });
                        this.processLoader = 6;
                        this.Issubmitclicked = 'False';
                        err = "Sorry an error has occured. Please try again.";
                        this.ErrorMessage = err;
                        this.dialogError1 = true;
                        return false;
                    }
                }

                //if (success) {
                //    window.location.reload();
                // }
            }
        },

        async GetEditedSurvey() {
            var UserID;
            if (localStorage) {
                // eslint-disable-next-line no-unused-vars
                UserID = parseInt(localStorage.getItem("UserId"));
            }
            var Editedforms = [];
            var SurveyDetails = [];
            var Formcount = 0;
            var EditedSurveyList = [];

            let SearchableQuestion = await db.TbSurveyQuestions.toArray();
            SearchableQuestion = SearchableQuestion.filter(x => x.IsSearchable == true);
            Editedforms = await db.TbSurveyForm.toArray();
            if (Editedforms.length > 0) {
                for (var i = 0; i < Editedforms.length; i++) {
                    SurveyDetails = await db.TbSurvey.where("SurveyID").equals(Editedforms[i].SurveyID).toArray();
                    var form = await db.TbSurveyForm.where("SurveyID").equals(Editedforms[i].SurveyID).toArray();
                    form = form.filter(x => x.IsActive == true);
                    form = form.filter(x => x.IsSaved == true);
                    form = form.filter(x => x.IsSubmitted == false);
                    Formcount = form.length;
                    SurveyDetails[0].Formcount = Formcount;
                    if (EditedSurveyList.length > 0) {
                        var SavedSurvey = EditedSurveyList.filter(x => x.SurveyID == Editedforms[i].SurveyID);
                        if (SavedSurvey.length == 0) { EditedSurveyList.push(SurveyDetails[0]); }

                    }
                    else { EditedSurveyList.push(SurveyDetails[0]); }
                }
            }

            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve, reject) => {
                let search = this.Search.trim().toLowerCase();
                let surveyList = [];
                if (search) {

                    let Searchsurvey = EditedSurveyList.filter(item => {
                        return Object.values(item)
                            .join(",")
                            .toLowerCase()
                            .includes(search);
                    });
                    //
                    let SearchQuestion = SearchableQuestion.filter(item => {
                        return Object.values(item)
                            .join(",")
                            .toLowerCase()
                            .includes(search);
                    });
                    if (SearchQuestion.length > 0) {
                        let Surveyid = [...new Set(SearchQuestion.map(function (v) { return v.SurveyID }))];
                        for (var x = 0; x < Surveyid.length; x++) {
                            if (EditedSurveyList.filter(item => item.SurveyID == Surveyid[x]).length > 0) {
                                surveyList.push(EditedSurveyList.filter(item => item.SurveyID == Surveyid[x])[0]);
                            }
                        }

                        EditedSurveyList = [];
                        for (x = 0; x < surveyList.length; x++) {
                            EditedSurveyList.push(surveyList[x]);
                        }
                    }
                    if (SearchQuestion == 0 && Searchsurvey.length > 0) {
                        EditedSurveyList = [];
                        EditedSurveyList.push(Searchsurvey[0]);
                    }
                    else {
                        for (x = 0; x < Searchsurvey.length; x++) {
                            EditedSurveyList.push(Searchsurvey[x]);
                        }
                    }
                    if (SearchQuestion.length == 0 && Searchsurvey.length == 0) {
                        EditedSurveyList = [];
                    }
                }
                EditedSurveyList = [...new Map(EditedSurveyList.map(item => [item.SurveyID, item])).values()];
                setTimeout(() => {
                    this.loading = false;
                    resolve({
                        EditedSurveyList
                    });
                }, 300);

            })
        },
        async GetSubmittedSurvey() {

            var UserID;
            if (localStorage) {
                // eslint-disable-next-line no-unused-vars
                UserID = parseInt(localStorage.getItem("UserId"));
            }
            var submittedforms = [];
            var forms = [];
            var SurveyDetails = [];
            var Formcount = 0;
            var SubmittedSurveyList = [];
            let SearchableQuestion = await db.TbSurveyQuestions.toArray();
            SearchableQuestion = SearchableQuestion.filter(x => x.IsSearchable == true);
            submittedforms = await db.TbSurveyForm.toArray();
            if (submittedforms.length > 0) {

                for (var i = 0; i < submittedforms.length; i++) {
                    SurveyDetails = await db.TbSurvey.where("SurveyID").equals(submittedforms[i].SurveyID).toArray();
                    forms = await db.TbSurveyForm.where("SurveyID").equals(submittedforms[i].SurveyID).toArray();
                    forms = forms.filter(x => x.IsActive == true);
                    forms = forms.filter(x => x.IsSubmitted == true);
                    Formcount = forms.length;
                    SurveyDetails[0].Formcount = Formcount;
                    if (submittedforms.length > 0) {
                        if (SubmittedSurveyList.length > 0) {
                            var SavedSurvey = SubmittedSurveyList.filter(x => x.SurveyID == submittedforms[i].SurveyID);
                            if (SavedSurvey.length == 0) { SubmittedSurveyList.push(SurveyDetails[0]); }

                        }
                        else { SubmittedSurveyList.push(SurveyDetails[0]); }
                    }

                }
            }

            // eslint-disable-next-line no-unused-vars
            return new Promise((resolve, reject) => {
                let search = this.Search.trim().toLowerCase();
                let surveyList = [];
                if (search) {

                    let Searchsurvey = SubmittedSurveyList.filter(item => {
                        return Object.values(item)
                            .join(",")
                            .toLowerCase()
                            .includes(search);
                    });
                    //
                    let SearchQuestion = SearchableQuestion.filter(item => {
                        return Object.values(item)
                            .join(",")
                            .toLowerCase()
                            .includes(search);
                    });
                    if (SearchQuestion.length > 0) {
                        let Surveyid = [...new Set(SearchQuestion.map(function (v) { return v.SurveyID }))];
                        for (var x = 0; x < Surveyid.length; x++) {
                            if (SubmittedSurveyList.filter(item => item.SurveyID == Surveyid[x]).length > 0) {
                                surveyList.push(SubmittedSurveyList.filter(item => item.SurveyID == Surveyid[x])[0]);
                            }
                        }

                        SubmittedSurveyList = [];
                        // eslint-disable-next-line no-redeclare
                        for (var x = 0; x < surveyList.length; x++) {
                            SubmittedSurveyList.push(surveyList[x]);
                        }
                    }
                    if (SearchQuestion == 0 && Searchsurvey.length > 0) {
                        SubmittedSurveyList = [];
                        SubmittedSurveyList.push(Searchsurvey[0]);
                    }
                    else {
                        // eslint-disable-next-line no-redeclare
                        for (var x = 0; x < Searchsurvey.length; x++) {
                            SubmittedSurveyList.push(Searchsurvey[x]);
                        }
                    }
                    if (SearchQuestion.length == 0 && Searchsurvey.length == 0) {
                        SubmittedSurveyList = [];
                    }
                }
                SubmittedSurveyList = [...new Map(SubmittedSurveyList.map(item => [item.SurveyID, item])).values()];
                setTimeout(() => {
                    this.loading = false;
                    resolve({
                        SubmittedSurveyList
                    });
                }, 300);

            })
        },
        async ValidationConditionSection(SurveyId, QuestionId) {

            var validCondition = this.CurrentSectionQuestions[0].Questions.filter(x => x.QuestionID == QuestionId)

            if (validCondition != null && validCondition.length > 0) {
                validCondition = validCondition[0].ValidationCondition.replace("{", '(').replace("}", ')');
            }

            var isRepeatIncluded = validCondition.includes("[");

            var Questions = await db.TbSurveyQuestions.where("SurveyID").equals(SurveyId).toArray();
            Questions = Questions.filter(x => x.FieldVar != null && x.FieldVar != "" && x.FieldVar != undefined);

            if (Questions != null && !isRepeatIncluded) {
                for (var i = 0; i < Questions.length; i++) {
                    var fieldvar = Questions[i].FieldVar;
                    var answer = "";

                    for (var j = 0; j < this.SurveySectionList.length; j++) {
                        var dd = this.SurveySectionList[j].Questions.filter(x => x.FieldVar == fieldvar);
                        if (dd.length > 0) {
                            answer = dd[0].Answers;
                        }
                    }


                    for (j = 0; j < this.CurrentSectionQuestions.length; j++) {
                        dd = this.CurrentSectionQuestions[j].Questions.filter(x => x.FieldVar == fieldvar);
                        if (dd.length > 0) {
                            answer = dd[0].Answers;
                        }
                    }

                    var textArray = [];
                    if (Questions[i].QuestionType == "CheckBox" &&
                        Questions[i].QuestionID == QuestionId) {

                        for (var cnt = 0; cnt < answer.length; cnt++) {
                            var text = await db.TbQuestionOptions.where("OptionID").equals(parseInt(answer[cnt])).toArray();
                            text = (text != null && text.length > 0 ? text[0].OptionText : "");
                            if (text.length > 0) {
                                textArray.push(text);
                            }
                        }
                    }

                    if (textArray.length > 0) {
                        validCondition = validCondition.replace(fieldvar, textArray);
                    } else {
                        if (answer != null && answer != "" && (answer.length > 0 || answer > 0)) {
                            validCondition = validCondition.replace(fieldvar, answer);
                        }
                        else {
                            validCondition = validCondition.replace(fieldvar, 0);
                        }
                    }
                }
            }

            var isFunction = false;
            var calanswer;

            var formulafunction = await db.TbSurvey.where("SurveyID").equals(SurveyId).toArray();
            var formulas = [];
            if (formulafunction != null && formulafunction.length > 0 &&
                formulafunction[0].FormulaFunction != null && formulafunction[0].FormulaFunction.length > 0) {
                formulas = formulafunction[0].FormulaFunction.split('~');

                for (var k = 0; k < formulas.length; k++) {

                    var substr = formulas[k].substr(0, formulas[k].indexOf('('));
                    if (substr != null && substr.length > 0 && validCondition.includes(substr)) {
                        isFunction = true;
                        var firstfn = validCondition.split('(');
                        if (firstfn != null && firstfn.length > 0) {
                            firstfn = firstfn[1].split(')');
                            if (firstfn != null && firstfn.length > 0) {
                                firstfn = firstfn[0].split(',');
                                for (var z = 0; z < firstfn.length; z++) {
                                    firstfn[z] = !isNaN(firstfn[z]) ? parseInt(firstfn[z]) : firstfn[z];
                                }
                            }
                        }

                        eval("var fun= function " + formulas[k]);
                        // eslint-disable-next-line no-undef
                        calanswer = fun.apply(this, firstfn);
                    }
                }
            }

            if (!isFunction) {
                calanswer = eval(validCondition);
            }

            return calanswer;
        }, 
        keymonitor: function (evt) {
            //if (evt.which != 8 && (evt.which < 48 || evt.which > 57)) {
            //    evt.preventDefault();
            //}

            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode != 8 && (charCode < 48 || charCode > 57)) {
                evt.preventDefault();
            }
            // return true;
        },
        async checkSpcialChar(event) {
            var k = event.keyCode;
            if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)) {
                // debugger;
                event.returnValue = true;
                return;
            }
            else {
                //debugger;
                event.returnValue = false;
            }

        },
        
        async CallBankApis(SectionList, SurveySectionList, indexid, userId, hdngpslocation) {
            var self = this;
            var customercreationId = "";
            var correlationId = "";
            var CasaAccountId = "";
            var apiStatus = false;

            var objectArray = await this.$sunidhi.SubmitToBankApisNew(SectionList, SurveySectionList, indexid, userId, hdngpslocation);

            var object = new Object();
            var objectData = new Object();

            if (objectArray != null && objectArray.object != null &&
                objectArray.object.length > 0 &&
                objectArray.objectData != null &&
                objectArray.objectData.length > 0) {

                object = objectArray.object[0];
                objectData = objectArray.objectData[0];

            } else {
                apiStatus = false;
                return apiStatus;
            }

            customercreationId = await this.$sunidhi.SubmitCustomerCreation(object, userId);

            if (customercreationId != null &&
                customercreationId != undefined &&
                customercreationId.length > 0) {

                this.customerCreationNo = customercreationId;

                self.processLoader = 2;
                self.SubmitProgressMessage = "Processing AML Query...";

                correlationId = await this.$sunidhi.SubmitCustomerAML(object.Data.Individual, customercreationId, userId);

                if (correlationId != null &&
                    correlationId != undefined &&
                    correlationId.length > 0) {

                    var aml2Status = false;

                    self.processLoader = 3;
                    self.SubmitProgressMessage = "Processing CASA Account Creation...";

                    // eslint-disable-next-line no-undef
                    sleep(aml2waitTime);

                    // eslint-disable-next-line no-unused-vars
                    aml2Status = await this.$sunidhi.QueryResponseAML(correlationId, userId);

                    CasaAccountId = await this.$sunidhi.CASAAccountCreation(objectData, customercreationId, userId);

                    if (CasaAccountId != null && CasaAccountId != undefined &&
                        CasaAccountId.length > 0) {

                        this.casaAccountNo = CasaAccountId;
                        apiStatus = true;

                        self.processLoader = 4;
                        self.SubmitProgressMessage = "Processing Form Submission to dc...";

                        var objectSMS = [];
                        var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
                        if (genzdata1 != null && genzdata1.length > 0) {
                            if (genzdata1[0].mobilenumber != null && genzdata1[0].mobilenumber != undefined) {
                                objectSMS.push({ "Name": "mobilenumber", "Value": "91" + genzdata1[0].mobilenumber });
                            }

                            objectSMS.push({ "Name": "templateid", "Value": "SMS749" });
                        }

                        objectSMS.push({ "Name": "accountid", "Value": CasaAccountId.substring(CasaAccountId.length - 4) });

                        this.$sunidhi.SendSMS(objectSMS, userId);
                    }
                }
            }

            return apiStatus;
        },
        async SubmitDataProcess() {
            this.PreLoader = true;
            var errorCount = 0;
            var UserId = 0;

            errorCount = await this.ValidateCurrentForm();

            if (errorCount > 0) {
                this.Issubmitclicked = 'False';
                setTimeout(() => {
                    this.PreLoader = false;
                }, 500);

                return false;
            } else {
                errorCount = await this.ValidateAllForms();

                if (errorCount > 0) {
                    this.isMinor = false;
                    this.ErrorMessage = "Please fill all mandatory questions in all sections before submitting the form !";
                    this.dialogError = true;
                    this.Issubmitclicked = 'False';
                    setTimeout(() => {
                        this.PreLoader = false;
                    }, 500);
                    return false;
                } else {
                    if (localStorage) {
                        UserId = localStorage.getItem("UserId");
                    }

                    this.showProcessMsg = true;

                    await this.StartDataProcessing(this.SurveySectionList, UserId, true, false, this.sectionArray, 0, 0);
                    setTimeout(() => {
                        this.PreLoader = false;
                    }, 500);
                    this.todo();
                    return false;
                }
            }
        },
        todo: async function () {
            this.intervalid1 = setInterval(async function () {

                if (this.onceProcessed) {
                    if (JSON.stringify(this.ProcessedSurveySectionList) != JSON.stringify(this.SurveySectionList)) {
                        clearInterval(this.intervalid1);
                        await db.ClientSyncQueue.where("FormID").equals(this.processedFormId).delete();
                        await db.TbSurveyForm.where("FormID").equals(this.processedFormId).delete();
                        await db.TbAnswers.where("FormID").equals(this.processedFormId).delete();
                        this.processedFormId = 0;
                        this.dataProcessed = false;
                        this.showProcessMsg = false;
                        this.onceProcessed = false;
                        this.processedStatus = true;
                        this.dispProcessBtn = false
                    }
                }
            }.bind(this), 500);
        },
        
        // eslint-disable-next-line no-unused-vars
        async StartDataProcessing(SurveySectionList, UserId, IsSubmitted, IsSaved, SectionList, FormId = 0, EntryId = 0) {
            this.uploadSuccess = [];
            // var unName = "";
            // var password = "";
            var userTokenID = "";

            var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
            if (genzdata1 != null || genzdata1.length > 0) {
                // eslint-disable-next-line no-unused-vars
                userTokenID = genzdata1[0].token;
            }

            if (SectionList != null && SectionList.length > 0) {

                var SurveyId = 0;
                var SurveyName = 0;

                if (SurveySectionList != null && SurveySectionList.length > 0) {
                    SurveyId = SurveySectionList[0].SurveyID;
                    SurveyName = SurveySectionList[0].SurveyName;
                }

                var ID = this.$sunidhi.IDGenerator();
                var FormCount = await db.TbSurveyForm.where("SurveyID").equals(SurveyId).toArray();
                var FormName = SurveyName + '_' + (FormCount.length + 1);

                /// Insert into TbSurveyForm Table
                // eslint-disable-next-line no-unused-vars
                var pkId = await db.TbSurveyForm.put({ FormID: ID, Name: FormName, SurveyID: SurveyId, CreatedDate: Date(), CreatedBy: parseInt(UserId), IsActive: true, IsSubmitted: IsSubmitted, IsSaved: IsSaved, UserID: parseInt(UserId) });

                for (var i = 0; i < SectionList.length; i++) {
                    var Section = SurveySectionList.filter(x => x.SectionId == SectionList[i]);

                    if (Section != null && Section.length > 0 &&
                        Section[0].Questions != null && Section[0].Questions.length > 0) {

                        ///  Insert into TbSurveyAnswers Table
                        for (var j = 0; j < Section[0].Questions.length; j++) {
                            var item = Section[0].Questions[j];

                            if (item.QuestionType == "Dropdown" || item.QuestionType == "masterdb" || item.QuestionType == "ConditionalDropdown") {

                                if (Object.keys(item.Answers).length > 0) {
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers.OptionValue, OptionID: item.Answers.OptionValue, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: null, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: null, Blob: null });
                                }
                            } else if (item.QuestionType == "Image" || item.QuestionType == "Audio" || item.QuestionType == "Sign") {
                                if (item.Blob.length > 0 && item.OrginalFileName != "") {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            } else if (item.QuestionType == "CaptureImage" || item.QuestionType == "ProofOfResidence" || item.QuestionType == "ProofOfUtilityBill" || item.QuestionType == "ProofForSourceOfFunds") {
                                if (item.Blob.length > 0) {
                                    AnswerID = await db.TbAnswers.put({ QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: item.Blob });
                                }
                            }
                            // else if (item.QuestionType == "CheckBox" ) {
                            //     var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });

                            // }
                            else if (item.QuestionType == "CheckBox" || item.QuestionType == "Radio") {
                                if (item.Answers.length == 0) {
                                    item.Answers = "No";
                                    // eslint-disable-next-line no-redeclare
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                } else {
                                    // eslint-disable-next-line no-redeclare
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }

                            }
                            else if (item.Answers > 0 || item.Answers.length > 0) {

                                if (item.Answers instanceof Array) {

                                    if (typeof item.Answers[item.Answers.length - 1] != 'string') {

                                        // eslint-disable-next-line no-redeclare
                                        var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, OptionID: item.Answers, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                    else {
                                        // eslint-disable-next-line no-redeclare
                                        var AnswerID = await db.TbAnswers.put({ Answer: item.Answers[item.Answers.length - 1], QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                    }
                                }
                                else {
                                    if (item.QuestionName == "First Name" || item.QuestionName == "Last Name" || item.QuestionName == "Middle Name" || item.QuestionName == "Name on Debit card") {
                                        item.Answers = (item.Answers != null && item.Answers != undefined) ? item.Answers.toUpperCase() : "";
                                    }

                                    // eslint-disable-next-line no-unused-vars, no-redeclare
                                    var AnswerID = await db.TbAnswers.put({ Answer: item.Answers, QuestionID: item.QuestionID, SurveyID: item.SurveyID, UserID: parseInt(UserId), FormID: ID, FormName: FormName, EntryId: 0, EntryName: null, FileName: item.FileName, RepeatOrder: item.RepeatOrder, QuestionType: item.QuestionType, OrginalFileName: item.OrginalFileName, Blob: null });
                                }
                            }
                        }
                    }
                }
            }

            var SyncQueuePKID = await db.ClientSyncQueue.put({ FormID: ID, SurveyID: SurveyId, CreatedDate: Date(), TagName: "SurveyForm" });
            this.processedFormId = ID;
            var response = await this.$sunidhi.DataProcess(1, SyncQueuePKID);

            if (response.Message == "Success" && response.resultStatus == "Form Saved") {
                this.ProcessedSurveySectionList = [];
                this.ProcessedSurveySectionList = JSON.parse(JSON.stringify(this.SurveySectionList));
                this.dataProcessed = true;
                this.dispProcessBtn = false
                this.onceProcessed = true;
                // this.ProcessMsg = "Process Completed. You can submit form Now.";
                this.dataprocessedsuccess = true;
                this.dataprocessedfailure = false;
                await this.SubmitSurveyFom()
            } else {
                this.ProcessedSurveySectionList = [];
                this.dataProcessed = false;
                this.dispProcessBtn = true;
                this.onceProcessed = false;
                this.ProcessMsg = "Form data process failed. Please try again.";
                this.processedStatus = false;
                this.dataprocessedsuccess = false;
                this.dataprocessedfailure = true;
            }
        },

        async CalPincodeApi(pin) {

            if (pin.length == 6) {
                this.PreLoader = true;
                var userTokenID = "";
                var genzdata1 = await db.TbGenz.where("UserId").anyOf(1).toArray();
                if (genzdata1 != null || genzdata1.length > 0) {
                    userTokenID = genzdata1[0].token;
                }

                var url = "https://ccapi.gieom.com/api/SearchbyPincode?userid=" + userTokenID + "&pincode=" + pin;

                try {

                    var self = this;
                    await $.ajax({
                        url: url,
                        type: 'GET',
                        success: async function (data) {

                            if (data.Status == "success") {

                                if (data != null && data != undefined &&
                                    data.Data != null && data.Data != undefined &&
                                    data.Data.Data != null && data.Data.Data != undefined &&
                                    data.Data.Data.ResponseData != null && data.Data.Data.ResponseData != undefined) {

                                    if (self.SurveySectionList != null && self.SurveySectionList.length > 0) {
                                        var sections = self.SurveySectionList.filter(x => x.SectionId == 3);

                                        if (sections != null && sections.length > 0) {
                                            var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                                            var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                                            // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                                            if (varcity != null && varcity.length > 0) {
                                                varcity[0].Answers = data.Data.Data.ResponseData.City;
                                            }

                                            if (vardistrict != null && vardistrict.length > 0) {
                                                vardistrict[0].Answers = data.Data.Data.ResponseData.District;
                                            }

                                            // if (state != null && state.length > 0) {
                                            //     var stname = data.Data.Data.ResponseData.StateCode + "-" + data.Data.Data.ResponseData.StateName;
                                            //     state[0].Answers = { "OptionValue": stname, "OptionText": data.Data.Data.ResponseData.StateName };
                                            // }
                                        }
                                    }

                                    self.PreLoader = false;
                                } else {

                                    if (self.SurveySectionList != null && self.SurveySectionList.length > 0) {
                                        // eslint-disable-next-line no-redeclare
                                        var sections = self.SurveySectionList.filter(x => x.SectionId == 3);

                                        if (sections != null && sections.length > 0) {
                                            // eslint-disable-next-line no-redeclare
                                            var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                                            // eslint-disable-next-line no-redeclare
                                            var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                                            // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                                            if (varcity != null && varcity.length > 0) {
                                                varcity[0].Answers = "";
                                            }

                                            if (vardistrict != null && vardistrict.length > 0) {
                                                vardistrict[0].Answers = "";
                                            }

                                            // if (state != null && state.length > 0) {
                                            //     state[0].Answers = null;
                                            // }
                                        }
                                    }

                                    self.PreLoader = false;
                                }
                            }
                        },
                        // eslint-disable-next-line no-unused-vars
                        error: function (ex) {
                            if (this.SurveySectionList != null && this.SurveySectionList.length > 0) {
                                var sections = this.SurveySectionList.filter(x => x.SectionId == 3);

                                if (sections != null && sections.length > 0) {
                                    var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                                    if (varcity != null && varcity.length > 0) {
                                        varcity[0].Answers = "";
                                    }

                                    var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                                    if (vardistrict != null && vardistrict.length > 0) {
                                        vardistrict[0].Answers = "";
                                    }

                                    // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                                    // if (state != null && state.length > 0) {
                                    //     state[0].Answers = null;
                                    // }
                                }
                            }
                            self.PreLoader = false;
                        }
                    });
                } catch (error) {

                    if (this.SurveySectionList != null && this.SurveySectionList.length > 0) {
                        var sections = this.SurveySectionList.filter(x => x.SectionId == 3);

                        if (sections != null && sections.length > 0) {
                            var varcity = sections[0].Questions.filter(x => x.QuestionID == 51);
                            if (varcity != null && varcity.length > 0) {
                                varcity[0].Answers = "";
                            }

                            var vardistrict = sections[0].Questions.filter(x => x.QuestionID == 64);
                            if (vardistrict != null && vardistrict.length > 0) {
                                vardistrict[0].Answers = "";
                            }

                            // var state = sections[0].Questions.filter(x => x.QuestionID == 52);

                            // if (state != null && state.length > 0) {
                            //     state[0].Answers = null;
                            // }
                        }
                    }

                    self.PreLoader = false;

                }
            }
        }
    }, 
        // beforeRouteLeave(to, from, next) {
        //     if (backbuttonpressed) {
        //         // if (confirm('You may have unsaved changes. Do you want to continue?')) {
        //         return next(false);
        //         //  }
        //     } else {
        //         return next();
        //     }
        // }
    };
</script>

<style type="text/css" scoped>
.v-dialog--active {
  width: auto !important;
  
}
.transparentbackground > .v-dialog:not(.v-dialog--fullscreen) {
    display: flex !important;
    justify-content: center !important;
}
.custom-file-upload {
  background-color: #fff;
  /*  background-image: url("../images/ic-fileUpload.png"); */
  height: 82px;
}

.w-100 {
    width: 100% !important;
}

.max-content {
    width: max-content !important
}

.mdi-alert {
    color: rgb(255 122 0)
}

.v-application .error {
    background-color: transparent !important;
    border: 0;
}

        .errorStyle{
            color:red;
            display:none
        }

        input[id="First Name"], input[id="Middle Name"], input[id="Last Name"] {
            text-transform: uppercase !important;
        }
		.ResidencePeriod {
		border: 1px solid #bbbbbb;
		}
		.ResidencePeriod input {
			border: 0;
		}
            .Sig-btn-close {
                /* position: relative!important; */
                bottom: 189px;
                right: 25px;
                border: none;
                font-size: 40px;
                padding: 10px;
                cursor: pointer;
                font-weight: bold;
                color: #e3352a;
                background: transparent;
            }

          /* .btn-close {
            position: absolute !important;
            top: 0 !important;
            right: 0 !important;
            border: none !important;
            font-size: 20px !important;
            padding: 10px !important;
            cursor: pointer !important;
            font-weight: bold !important;
            color: #b78b20 !important;
            background: transparent !important;
            } */

          .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .transparentBackground > .theme--light.v-sheet {
    background-color: transparent !important;
  }

  /* #capture {
  display: none;
}

#snapshot {
  display: inline-block;
  width: 320px;
  height: 240px;
} */

div#captureModalDocuments {
    position: relative !important;
    background-color: white !important;
}

.v-dialog {
    overflow-y: hidden !important;
    padding-bottom: 2rem !important;
}
.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  /* width: 100%; */
  padding: 3px !important;
}
</style>

<style scoped>
.v-application ul {
    padding-left: 2px !important

}
    .v-tabs__wrapper {
        padding-bottom: 10px;
    }

    .ar {
        width: 280px !important;
    }

    .ar-records {
        height: inherit !important;
    }

    .ar-player {
        width: 250px !important
    }

        .ar-player > .ar-player-bar > .ar-player__progress {
            width: 4px !important;
        }

    .ar-records__record {
        width: 197px !important;
    }
    .successPopupStyle{
    position: relative;
    background-color: transparent;
    text-align: -webkit-center;
    margin-right: 12px;
    /* padding-right: 46px; */
    box-shadow: none !important;
}
.successDialog {
    box-shadow: none !important;
    text-align: -webkit-center !important;
    bottom: auto !important;
    max-width: max-content;
    position: relative;
    /* text-align: -webkit-center; */
}
.maxWidth {
    max-width: max-content !important;
}
</style>

<style type = "text/css">

.v-dialog__content {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: center;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 23px;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: 6;
    outline: none;
}

@media only screen and (max-device-width:480px) {
    /* show the popup */
    #TCModalPopUp {
     display: block; 
    }
}

/* signature css  */
.button-container {
  position: absolute;
  /* bottom: 0;
  right: 0; */
  /* right: -100px; */
  display: flex;
  gap: 10px; /* Add spacing between buttons */
  left: 25rem;
}

.signature-container {
  position: relative;
  width: 400px; /* Adjust as needed */
  height: 200px; /* Same height as canvas */
  /* border: 1px solid #000; Optional border for visual clarity */
}

.sigCanvasWidth {
  width: 400px;
  height: 200px;
  display: block;
  border: 1px solid black;
}

.Sig-btn-close {
   
  font-weight: bold;
  color: #e3352a;
  position: absolute;
  /* top: 0;
  right: 0; */
  /* top: -12px; */
  /* right: -9px; */
  background-color: transparent;
  border: none;
  font-size: 40px;
  cursor: pointer;
  z-index: 10; /* Ensure it's on top */
  left: 23rem;
}

@media only screen and (max-width: 768px) {
  .Sig-btn-close {
    /* font-size: 14px; */
    /* top: 3px;
    right: 3px; */
  }     

  .signature-container {
    max-width: 300px; /* Resize for smaller screens */
  }
}

@media only screen and (max-width: 480px) {
  .Sig-btn-close {
    /* font-size: 12px; */
    /* top: 2px;
    right: 2px; */
  }

  .signature-container {
    max-width: 250px; /* Further resize for very small screens */
  }
}

@media only screen and (max-width:450px){
    .button-container {
        /* right: 0 !important; */
        left: 10rem !important;
    }
    .sigCanvasWidth {
        width: 240px;
        height: 200px;
    }
    .Sig-btn-close {
        left: 12rem;
    }
}
/* signature css ENDS */

.DigiFormsTitle{
    padding-top: 2rem !important;
}

.searchPadTop{
    padding-top: 3rem !important;
}

@media only screen and (max-width:599px) {
    .DigiFormsTitle{
        padding-top: 1rem !important;
    }

    .searchPadTop{
        padding-top: 1rem !important;
    }
}
</style>